// Universal Media Player
// Build Date: 2025-01-16T19:17:32.571Z
// Commit: f10b591ec73eead1df5d2d9ed284b6bdc8312e5c
// Build Number: 20250116.03

import { createContext as ft, consume as M, provide as qt, ContextProvider as Gt } from "@lit/context";
import Kt from "codem-isoboxer";
import { css as w, LitElement as C, html as d, unsafeCSS as yt } from "lit";
import { customElement as S, query as $, property as I, state as Te } from "lit/decorators.js";
import y from "shaka-player";
import { msg as s, localized as Ke, configureLocalization as Qt } from "@lit/localize";
import { classMap as c } from "lit/directives/class-map.js";
import { unsafeSVG as v } from "lit/directives/unsafe-svg.js";
import { templates as Yt } from "./locales/en-gb.mjs";
import { templates as Wt } from "./locales/es-es.mjs";
import { templates as Xt } from "./locales/es-mx.mjs";
import { templates as Jt } from "./locales/fr-fr.mjs";
import { templates as eo } from "./locales/it-it.mjs";
import { templates as to } from "./locales/pt-br.mjs";
import { ApplicationInsights as oo } from "@microsoft/applicationinsights-web";
const L = ft(
  Symbol("playerState")
);
var ro = Object.defineProperty, ao = Object.getOwnPropertyDescriptor, wt = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? ao(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && ro(t, o, a), a;
};
let ke = class extends C {
  render() {
    return d`<div
      class="ump-visually-hidden"
      aria-live="assertive"
      data-testid="aria-announcer"
    >
      ${this.playerState.ended ? s("Ended") : this.playerState.paused ? s("Paused") : s("Playing")}
    </div>`;
  }
};
ke.styles = w`
.ump-visually-hidden{position:absolute !important;width:1px !important;height:1px !important;padding:0 !important;margin:-1px !important;overflow:hidden !important;clip:rect(0,0,0,0) !important;white-space:nowrap !important;border:0 !important;z-index:-100}
  `;
wt([
  M({ context: L, subscribe: !0 })
], ke.prototype, "playerState", 2);
ke = wt([
  S("ump-aria-announcer")
], ke);
function kt(e, t, o) {
  return e < t ? t : e > o ? o : e;
}
function nt(e) {
  const o = Math.round(kt(e, 0, 1) * 255).toString(16).toUpperCase();
  return o.length === 1 ? "0" + o : o;
}
var no = Object.defineProperty, io = Object.getOwnPropertyDescriptor, Qe = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? io(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && no(t, o, a), a;
};
const so = 2.5;
let ne = class extends C {
  render() {
    return d`
      <div
        class=${c({
      "ump-caption-display-container": !0,
      "ump-caption-display-container-hidden": !this.playerState.captionSettings.enabled
    })}
      ></div>
    `;
  }
  updated() {
    const {
      fontScale: e,
      textColor: t,
      textOpacity: o,
      backgroundColor: r,
      backgroundOpacity: a,
      fontFamily: n,
      textShadow: i
    } = this.playerState.captionSettings;
    this.style.setProperty(
      "--ump-caption-display-font-size",
      `${e * so}cqw`
    ), this.style.setProperty(
      "--ump-caption-display-color",
      `${t}${nt(o)}`
    ), this.style.setProperty(
      "--ump-caption-display-background",
      `${r}${nt(a)}`
    ), this.style.setProperty("--ump-caption-display-font-family", n), this.style.setProperty("--ump-caption-display-text-shadow", i), this.dispatchEvent(new Event("captionsettingupdated"));
  }
};
ne.styles = w`
.ump-caption-display-container{display:inline-block;position:absolute;width:95%;bottom:90px;left:50%;transform:translateX(-50%)}.ump-caption-display-container span:not(:has(span)){font-size:var(--ump-caption-display-font-size);color:var(--ump-caption-display-color);background-color:var(--ump-caption-display-background) !important;font-family:var(--ump-caption-display-font-family),sans-serif;text-shadow:var(--ump-caption-display-text-shadow);max-width:100%}.ump-caption-display-container-hidden{display:none}*{opacity:1 !important}.ump-caption-display-container *{position:relative !important}
  `;
Qe([
  M({ context: L, subscribe: !0 })
], ne.prototype, "playerState", 2);
Qe([
  $(".ump-caption-display-container")
], ne.prototype, "captionContainer", 2);
ne = Qe([
  S("ump-caption-display")
], ne);
const xt = [
  "facebook",
  "twitter",
  "linkedin",
  "mail",
  "copy"
], Oe = {
  sources: [],
  ccFiles: [],
  downloadableFiles: [],
  adobeCms: null,
  ageGate: !1,
  aspectRatio: "16:9",
  autoplay: !1,
  checkpoints: [],
  debug: !1,
  dir: null,
  disableKeyboardEvents: !1,
  hideControls: null,
  hidePosterImage: !1,
  language: "en",
  layout: "fluid",
  loop: !1,
  maskLevel: 0,
  muted: !1,
  partnerName: "",
  percentage: 50,
  playButtonSize: "medium",
  playButtonTheme: "dark",
  playbackRates: [0.5, 0.75, 1, 1.25, 1.5, 2],
  playFullScreen: !1,
  plugins: {},
  poster: "",
  qualityBehavior: "auto",
  reporting: !0,
  share: !0,
  shareOptions: [...xt],
  showDownloadMenu: !0,
  showFocusIndicator: "default",
  showImageOnError: !1,
  showQualityMenu: !0,
  startTime: 0,
  title: "",
  unlocalizedTitle: ""
}, ie = {
  videoId: -1,
  label: s("Auto")
}, ae = {
  captionId: -1,
  language: s("option for turning off caption"),
  label: s("Off")
}, Z = {
  enabled: !1,
  fontScale: 1,
  textColor: "#FFFFFF",
  textOpacity: 1,
  backgroundColor: "#000000",
  backgroundOpacity: 1,
  fontFamily: "sans-serif",
  textShadow: "rgb(255, 255, 255) 0px 0px 0px"
}, it = {
  audioTracks: [],
  bigPlayButtonClicked: !1,
  buffered: [],
  captionSettings: Z,
  captionTracks: [],
  controlsState: "controlbar",
  currentTime: 0,
  dir: "ltr",
  disableKeyboardEvents: !1,
  downloadableTranscriptFiles: [],
  downloadableVideoFiles: [],
  duration: 0,
  ended: !1,
  fullscreen: !1,
  loading: !1,
  maskLevel: 0,
  muted: !1,
  paused: !0,
  playbackRate: 1,
  playbackRates: [],
  playButtonSize: "medium",
  playButtonTheme: "dark",
  qualityBehavior: "auto",
  selectedVideoQualityId: ie.videoId,
  shareDialogOpened: !1,
  shareOptions: [],
  showDownloadMenu: !0,
  showFocusIndicator: "default",
  showQualityMenu: !0,
  showVolumeSlider: !0,
  videoQualities: [],
  visible: !0,
  volume: 1
}, xe = ["HQ", "HD", "SD", "LO"], st = [
  "application/dash+xml",
  "application/vnd.apple.mpegurl",
  "application/vnd.ms-sstr+xml",
  "video/mp4"
], Et = {
  DASH: "application/dash+xml",
  MP4: "video/mp4",
  HLS: "application/vnd.apple.mpegurl",
  MSS: "application/vnd.ms-sstr+xml"
}, lo = {
  VTT: "text/vtt",
  TTML: "application/ttml+xml"
}, z = "@back", co = 3e3, uo = s(
  "We're sorry, but something went wrong."
), Pe = "dau-", po = "universal-media-player", Ct = "ump";
class p extends CustomEvent {
  constructor(t, o) {
    super(t, {
      bubbles: !0,
      composed: !0,
      cancelable: !0,
      detail: o
    });
  }
}
const ho = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10a7 7 0 0 1 14 0v1h-3.5a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5H16a2 2 0 0 0 2-2v-6a8 8 0 1 0-16 0v6c0 1.1.9 2 2 2h2.5a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5H3v-1Z"/></svg>', mo = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10a7 7 0 0 1 14 0v1h-3.5a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5H16a2 2 0 0 0 2-2v-6a8 8 0 1 0-16 0v6c0 1.1.9 2 2 2h2.5a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5H3v-1Zm0 2h3v5H4a1 1 0 0 1-1-1v-4Zm14 0v4a1 1 0 0 1-1 1h-2v-5h3Z"/></svg>', go = '<svg fill="currentColor" viewBox="0 0 1316 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M288 567.990857h97.718857l-0.585143-151.442286z m586.276571-56.576c0-63.414857-36.571429-110.299429-112.566857-110.299428h-30.866285v221.696h29.696c71.424 0 113.700571-52.004571 113.700571-111.433143z m-327.972571-215.405714l0.585143 432.018286a19.126857 19.126857 0 0 1-18.870857 19.419428h-123.428572a19.163429 19.163429 0 0 1-18.870857-19.419428v-35.437715H219.428571l-31.414857 46.299429a19.748571 19.748571 0 0 1-16.018285 8.557714H19.419429c-16.018286 0-25.161143-17.700571-15.433143-30.281143L321.682286 284.598857a18.212571 18.212571 0 0 1 15.433143-8.009143h189.696c10.861714 0 19.419429 8.557714 19.419428 19.419429z m472.539429 215.405714c0 150.272-109.714286 235.995429-257.133715 235.995429h-154.294857a19.236571 19.236571 0 0 1-19.419428-19.419429V295.972571c0-10.861714 8.557714-19.419429 19.419428-19.419428h153.161143c148.553143 0 258.304 84.553143 258.304 234.861714z m89.161142 0.585143s2.304 148.553143-84.553142 235.995429h-29.147429c77.714286-92.562286 79.433143-236.580571 79.433143-236.580572s1.133714-113.152-77.129143-234.276571h24.576C1105.737143 373.723429 1108.041143 512 1108.041143 512z m105.142858 0s2.304 148.553143-85.138286 235.995429h-29.147429c77.714286-92.562286 79.433143-236.580571 79.433143-236.580572s1.133714-113.152-76.580571-234.276571h24.576C1210.843429 373.723429 1213.147429 512 1213.147429 512zM1316.571429 512s2.304 148.553143-84.553143 235.995429h-29.147429c77.129143-92.562286 78.848-236.580571 78.848-236.580572s1.133714-113.152-76.580571-234.276571h24.576C1314.267429 373.723429 1316.571429 512 1316.571429 512z" fill="" /></svg>';
function u(e) {
  return {
    "focus-always": e.showFocusIndicator === "always",
    "focus-default": e.showFocusIndicator === "default"
  };
}
function vo(e) {
  return (t) => (e.setValue({
    ...e.value,
    showFocusIndicator: t.options.showFocusIndicator
  }), () => {
  });
}
const B = w`
.btn{display:inline-flex;align-items:center;justify-content:center;gap:var(--spacing-s-nudge);margin:0;padding:var(--spacing-s-nudge) var(--spacing-m);border-radius:var(--border-radius-medium);color:var(--color-neutral-foreground-1);font-weight:var(--font-weight-semibold);font-family:var(--font-family-default);line-height:var(--line-height-base-300);transition-duration:var(--duration-faster);transition-property:background,color;transition-timing-function:var(--curve-easy-ease);cursor:pointer;-webkit-user-select:none;user-select:none;border:solid var(--stroke-width-thick) var(--color-transparent-stroke);background-color:var(--color-neutral-background-1)}.btn:hover{background-color:var(--color-neutral-background-1-hover);color:var(--color-neutral-foreground-1-hover)}.btn.focus-always:focus,.btn.focus-default:focus-visible{outline:var(--stroke-width-thick) solid var(--color-stroke-focus-2)}.btn svg{fill:currentcolor}.btn-xs{padding:var(--spacing-xs)}.btn-s{padding:var(--spacing-s)}.btn-xl{padding:var(--spacing-xl)}.btn-xxl{padding:var(--spacing-xxl)}.btn-xxl svg{width:var(--size-10);height:var(--size-10)}.btn-outline{background-color:transparent;border-color:var(--color-neutral-stroke-1)}.btn-outline:hover{background-color:transparent}.btn-outline.focus-always:focus,.btn-outline.focus-default:focus-visible{border-color:transparent}.btn-subtle{background-color:var(--color-subtle-background);color:var(--color-neutral-foreground-2);border-color:transparent}.btn-subtle:hover{background-color:var(--color-subtle-background-hover);color:var(--color-neutral-foreground-2-hover);border-color:transparent}.btn-subtle:active{background-color:var(--color-subtle-background-pressed);color:var(--color-neutral-foreground-2-pressed)}.btn-icon-only{padding:var(--spacing-s-nudge)}.btn-brand{background-color:var(--color-brand-background);color:var(--color-brand-foreground)}.btn-brand:hover{background-color:var(--color-brand-background-hover);color:var(--color-brand-foreground)}.btn-brand:active{background-color:var(--color-brand-background-pressed);color:var(--color-brand-foreground)}.btn-circle{border-radius:var(--border-radius-circular)}@media (forced-colors:active){.btn{color:ButtonText;background-color:ButtonFace;border-color:ButtonText}.btn:hover{background-color:Highlight;border-color:Highlight;color:HighlightText}.btn-brand{forced-color-adjust:none}.btn.focus-always:focus,.btn.focus-default:focus-visible{outline-color:Highlight}.btn-outline{background-color:ButtonFace;border-color:ButtonText}.btn-subtle{background-color:ButtonFace;color:ButtonText}}
`, Me = w`
hr{width:var(--size-full);height:var(--size-px);padding:0;margin:var(--spacing-s) 0;border:none;background-color:var(--color-neutral-stroke-alpha)}@media (forced-colors:active){hr{background-color:ButtonBorder}}
`, te = w`
.tooltip[data-tooltip]{position:relative;--tooltip-gap:var(--spacing-s);--tooltip-top:auto;--tooltip-left:50%;--tooltip-right:auto;--tooltip-bottom:100%;--tooltip-translate-x:-50%;--tooltip-translate-y:calc(0px - var(--tooltip-gap));--tooltip-width:auto}.tooltip[data-tooltip]::before{pointer-events:none;display:none;width:var(--tooltip-width);z-index:100;background-color:var(--color-grey-10-alpha-90);color:var(--color-neutral-foreground-1);content:attr(data-tooltip);padding:var(--spacing-xs) var(--spacing-s);border-radius:var(--border-radius-medium);font-weight:var(--font-weight-regular);font-size:var(--font-size-base-200);line-height:var(--line-height-base-200);font-family:var(--font-family-default);position:absolute;inset:var(--tooltip-top) var(--tooltip-right) var(--tooltip-bottom) var(--tooltip-left);transform:translate(var(--tooltip-translate-x),var(--tooltip-translate-y))}.tooltip[data-tooltip].tooltip-top::before{--tooltip-top:auto;--tooltip-bottom:100%;transform:translate(0,calc(0px - var(--tooltip-gap)))}.tooltip[data-tooltip].tooltip-top.tooltip-right::before{--tooltip-left:auto;--tooltip-right:0}.tooltip[data-tooltip].tooltip-top.tooltip-left::before{--tooltip-left:0;--tooltip-right:auto}.tooltip[data-tooltip].tooltip-disable-when-aria-expanded[aria-expanded='true']::before{display:none}.tooltip[data-tooltip]:hover::before,.tooltip[data-tooltip]:focus-visible::before,.tooltip[data-tooltip].tooltip-visible::before{display:block}@media (forced-colors:active){.tooltip[data-tooltip]::before{background-color:var(--color-grey-10)}.tooltip[data-tooltip]:hover::before,.tooltip[data-tooltip]:focus-visible::before,.tooltip[data-tooltip].tooltip-visible::before{color:ButtonText}}
`;
var bo = Object.defineProperty, fo = Object.getOwnPropertyDescriptor, Ye = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? fo(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && bo(t, o, a), a;
};
let se = class extends C {
  render() {
    var t;
    const e = this.playerState.audioTracks;
    return e.length < 2 ? null : d`
      <ump-popup
        popupAriaLabel="${s("Audio")}"
        @ump-popup-changed=${() => this.requestUpdate()}
      >
        <button
          type="button"
          slot="trigger"
          class=${c({
      btn: !0,
      "btn-subtle": !0,
      "btn-icon-only": !0,
      ...u(this.playerState),
      tooltip: !0,
      "tooltip-disable-when-aria-expanded": !0
    })}
          data-tooltip="${s("Audio")}"
          aria-label="${s("Audio Menu")}"
          data-testid="audio-menu-button"
        >
          ${(t = this.popup) != null && t.opened ? v(ho) : v(mo)}
        </button>

        <ump-menu data-focusgroup>
          <ump-menu-label>${s("Audio Track")}</ump-menu-label>

          <hr aria-hidden="true" />

          <ump-submenu>
            ${e.map(
      (o) => d`
                <ump-menu-item
                  class=${c({ ...u(this.playerState) })}
                  type="radio"
                  .checked=${this.playerState.selectedAudioTrackId === o.audioId}
                  @click=${this.onAudioTrackSelected(o)}
                >
                  <div
                    class="audio-track-menu-item-content"
                    aria-label=${lt(o) ? `${o.label} ${s("Audio Description")}` : o.label}
                  >
                    ${o.label}
                    ${lt(o) ? v(go) : null}
                  </div>
                </ump-menu-item>
              `
    )}
          </ump-submenu>
        </ump-menu>
      </ump-popup>
    `;
  }
  onAudioTrackSelected(e) {
    return () => {
      this.dispatchEvent(new p("audio-track-clicked", e));
    };
  }
  get opened() {
    var e;
    return (e = this.popup) == null ? void 0 : e.opened;
  }
};
se.styles = [
  B,
  Me,
  te,
  w`
.btn.tooltip{--tooltip-gap:var(--spacing-xxxl)}ump-popup{--ump-popup-spacing:var(--spacing-xxxl)}ump-menu{width:var(--size-64);display:block}.audio-track-menu-item-content{display:flex;align-items:flex-end;width:100%;gap:var(--spacing-xs)}.audio-track-menu-item-content svg{width:var(--size-6);height:var(--size-6);margin-bottom:calc(0px - var(--spacing-xs))}
    `
];
Ye([
  $("ump-popup")
], se.prototype, "popup", 2);
Ye([
  M({ context: L, subscribe: !0 })
], se.prototype, "playerState", 2);
se = Ye([
  S("ump-audio-menu")
], se);
function lt(e) {
  return e.role === "public.accessibility.describes-video";
}
const yo = '<svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><path d="M23.5 14A9.5 9.5 0 0 0 7.07 7.5h2.68a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 5 8.25v-4a.75.75 0 0 1 1.5 0v1.7a11 11 0 1 1-3.42 6.7.75.75 0 1 1 1.49.2A9.5 9.5 0 1 0 23.5 14Z"/></svg>', wo = '<svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><path d="M6.75 3A2.75 2.75 0 0 0 4 5.75v16.5A2.75 2.75 0 0 0 6.75 25h3a2.75 2.75 0 0 0 2.75-2.75V5.75A2.75 2.75 0 0 0 9.75 3h-3Zm11.5 0a2.75 2.75 0 0 0-2.75 2.75v16.5A2.75 2.75 0 0 0 18.25 25h3A2.75 2.75 0 0 0 24 22.25V5.75A2.75 2.75 0 0 0 21.25 3h-3Z"/></svg>', ko = '<svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><path d="M10.14 3.38A2.75 2.75 0 0 0 6 5.76v16.48c0 2.13 2.3 3.45 4.14 2.38l14.7-8.6a2.35 2.35 0 0 0 0-4.05l-14.7-8.59Z"/></svg>';
var xo = Object.defineProperty, Eo = Object.getOwnPropertyDescriptor, $t = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? Eo(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && xo(t, o, a), a;
};
let le = class extends C {
  render() {
    return d`<button
      type="button"
      class=${c({
      btn: !0,
      "btn-xl": this.playerState.playButtonSize === "medium",
      "btn-xxl": this.playerState.playButtonSize === "large",
      "btn-circle": !0,
      "big-play-button": !0,
      "big-play-button-light": this.playerState.playButtonTheme === "light",
      "big-play-button-dark": this.playerState.playButtonTheme === "dark",
      ...u(this.playerState),
      tooltip: !0
    })}
      aria-label="${this.playerState.ended ? s("Replay") : this.playerState.paused ? s("Play") : s("Pause")}"
      data-tooltip="${this.playerState.ended ? s("Replay") : this.playerState.paused ? s("Play") : s("Pause")}"
      data-testid="big-play-button"
      @click=${this.onBigPlayButtonClick}
      @keydown=${this.onBigPlayButtonKeyDown}
    >
      ${this.playerState.ended ? v(yo) : this.playerState.paused ? v(ko) : v(wo)}
    </button>`;
  }
  onBigPlayButtonClick() {
    this.dispatchEvent(new p("big-play-button-triggered"));
  }
  onBigPlayButtonKeyDown(e) {
    this.playerState.disableKeyboardEvents || (e.key === "Enter" || e.key === " ") && (e.preventDefault(), e.stopPropagation(), this.dispatchEvent(new p("big-play-button-triggered")));
  }
};
le.shadowRootOptions = {
  ...C.shadowRootOptions,
  delegatesFocus: !0
};
le.styles = [
  B,
  te,
  w`
.big-play-button{transition-property:background,color,outline}.big-play-button.tooltip{--tooltip-gap:var(--spacing-m)}.big-play-button-light{background-color:var(--color-white-alpha-90);outline:var(--stroke-width-thickest) solid var(--color-white-alpha-20)}.big-play-button-light:hover{background-color:var(--color-white-alpha-20);outline:var(--stroke-width-thickest) solid var(--color-white-alpha-90)}.big-play-button-light svg{fill:var(--color-brand-40)}.big-play-button-dark{background-color:var(--color-black-alpha-60);outline:var(--stroke-width-thickest) solid var(--color-black-alpha-20)}.big-play-button-dark:hover{background-color:var(--color-black-alpha-60);outline:var(--stroke-width-thickest) solid var(--color-white-alpha-90)}.big-play-button-dark svg{fill:var(--color-neutral-foreground-1)}@media (forced-colors:active){.big-play-button-dark{background-color:ButtonText;outline:var(--stroke-width-thickest) solid Highlight}.big-play-button-dark:hover{background-color:Highlight;outline:var(--stroke-width-thickest) solid ButtonText}.big-play-button-dark svg{fill:ButtonFace}.big-play-button-light{background-color:Highlight;outline:var(--stroke-width-thickest) solid ButtonText}.big-play-button-light:hover{background-color:ButtonText;outline:var(--stroke-width-thickest) solid Highlight}.big-play-button-light svg{fill:ButtonFace}}
    `
];
$t([
  M({ context: L, subscribe: !0 })
], le.prototype, "playerState", 2);
le = $t([
  Ke(),
  S("ump-big-play-button")
], le);
const Ae = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.35 15.85a.5.5 0 0 1-.7 0L6.16 10.4a.55.55 0 0 1 0-.78l5.49-5.46a.5.5 0 1 1 .7.7L7.2 10l5.16 5.15c.2.2.2.5 0 .7Z"/></svg>', De = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.65 4.15c.2-.2.5-.2.7 0l5.49 5.46c.21.22.21.57 0 .78l-5.49 5.46a.5.5 0 0 1-.7-.7L12.8 10 7.65 4.85a.5.5 0 0 1 0-.7Z"/></svg>', Co = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5Zm1.4 3.24c.82-.41 1.8-.24 2.45.4a.5.5 0 0 1-.7.71 1.12 1.12 0 0 0-1.3-.22C6.44 8.34 6 8.9 6 10s.44 1.66.85 1.87c.43.21.95.13 1.3-.22a.5.5 0 1 1 .7.7c-.65.65-1.63.82-2.45.41C5.56 12.34 5 11.39 5 10c0-1.39.56-2.34 1.4-2.76Zm7.95.4a.5.5 0 0 1-.7.71 1.12 1.12 0 0 0-1.3-.22c-.41.21-.85.76-.85 1.87s.44 1.66.85 1.87c.43.21.95.13 1.3-.22a.5.5 0 0 1 .7.7c-.65.65-1.63.82-2.45.41-.84-.42-1.4-1.37-1.4-2.76 0-1.39.56-2.34 1.4-2.76.82-.41 1.8-.24 2.45.4Z"/></svg>', $o = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.4 7.24c.82-.41 1.8-.24 2.45.4a.5.5 0 0 1-.7.71 1.12 1.12 0 0 0-1.3-.22C6.44 8.34 6 8.9 6 10s.44 1.66.85 1.87c.43.21.95.13 1.3-.22a.5.5 0 0 1 .7.7c-.65.65-1.63.82-2.45.41C5.56 12.34 5 11.39 5 10c0-1.39.56-2.34 1.4-2.76Zm7.95.4a2.12 2.12 0 0 0-2.45-.4c-.84.42-1.4 1.37-1.4 2.76 0 1.39.56 2.34 1.4 2.76.82.41 1.8.24 2.45-.4a.5.5 0 0 0-.7-.71c-.35.35-.87.43-1.3.22-.41-.21-.85-.76-.85-1.87s.44-1.66.85-1.87c.43-.21.95-.13 1.3.22a.5.5 0 0 0 .7-.7ZM2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm3-2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5Z"/></svg>', So = [
  0.5,
  0.75,
  1,
  1.25,
  1.5,
  1.75,
  2,
  3,
  4
], ye = [
  {
    label: s("White"),
    hexCode: "#FFFFFF"
  },
  {
    label: s("Yellow"),
    hexCode: "#FFFF00"
  },
  {
    label: s("Black"),
    hexCode: "#000000"
  },
  {
    label: s("Green"),
    hexCode: "#008000"
  },
  {
    label: s("Blue"),
    hexCode: "#0000FF"
  },
  {
    label: s("Magenta"),
    hexCode: "#FF00FF"
  },
  {
    label: s("Cyan"),
    hexCode: "#00FFFF"
  }
], ct = [
  {
    label: s("Proportional Sans Serif"),
    family: "sans-serif"
  },
  {
    label: s("Monospace Sans Serif"),
    family: '"Andale Mono", "Lucida Console", monospace'
  },
  {
    label: s("Proportional Serif"),
    family: "serif"
  },
  {
    label: s("Monospace Serif"),
    family: '"Courier New", monospace'
  },
  {
    label: s("Casual"),
    family: '"Comic Sans MS", Impact, fantasy'
  },
  {
    label: s("Cursive"),
    family: '"Monotype Corsiva", cursive'
  },
  {
    label: s("Small Capitals"),
    family: '"Andale Mono", "Lucida Console", monospace, sans-serif'
  }
], Io = [0, 0.25, 0.5, 0.75, 1], O = "rgb(34, 34, 34)", ut = "rgb(204, 204, 204)", dt = [
  {
    label: s("None"),
    textShadow: "rgb(255, 255, 255) 0px 0px 0px"
  },
  {
    label: s("Drop Shadow"),
    textShadow: `${O} 2px 2px 3px, ${O} 2px 2px 4px, ${O} 2px 2px 5px`
  },
  {
    label: s("Depressed"),
    textShadow: `${ut} 1px 1px 0px, ${ut} 0px 1px 0px, ${O} -1px -1px 0px, ${O} 0px -1px 0px`
  },
  {
    label: s("Uniform"),
    textShadow: `${O} 0px 0px 4px, ${O} 0px 0px 4px, ${O} 0px 0px 4px, ${O} 0px 0px 4px`
  },
  {
    label: s("Raised"),
    textShadow: `${O} 1px 1px 0px, ${O} 2px 2px 0px, ${O} 3px 3px 0px`
  }
];
var To = Object.defineProperty, Mo = Object.getOwnPropertyDescriptor, We = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? Mo(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && To(t, o, a), a;
};
let ce = class extends C {
  constructor() {
    super(...arguments), this.buildColorMenu = (e, t, o, r, a) => {
      const n = this.playerState.disableKeyboardEvents;
      function i(l) {
        const [h] = l.currentTarget.querySelectorAll("button");
        h == null || h.focus();
      }
      return d`
      <ump-menu-item
        class=${c({
        "cc-style-menu-item": !0,
        ...u(this.playerState)
      })}
        role="menuitem"
        .focusable="${!n}"
        @focus=${i}
        @click=${(l) => l.stopPropagation()}
      >
        <div>
          <div><b>${s("Color")}</b></div>
          <div>
            ${s(
        ye.find((l) => l.hexCode === t).label
      )}
          </div>
        </div>

        <div slot="suffix" class=${c({ "color-suffix": !0 })}>
          ${ye.map(
        (l) => d`
              <button
                type="button"
                class=${c({
          btn: !0,
          "btn-circle": !0,
          "btn-color": !0,
          ...u(this.playerState)
        })}
                style="background-color: ${l.hexCode};"
                aria-label="${s(l.label)}"
                data-testid="${e}-${l.label}"
                @click=${r(l.hexCode)}
                @keydown=${(h) => this.onColorOptionsKeyDown(h)}
              ></button>
            `
      )}
        </div>
      </ump-menu-item>

      <ump-menu-item
        class=${c({
        "cc-style-menu-item": !0,
        ...u(this.playerState)
      })}
        role="menuitem"
        .focusable="${!n}"
        @focus=${i}
        @click=${(l) => l.stopPropagation()}
      >
        <div>
          <div><b>${s("Opacity")}</b></div>
          <div>${`${o * 100}%`}</div>
        </div>

        <div slot="suffix" class=${c({ "opacity-suffix": !0 })}>
          ${Io.map(
        (l) => d`
              <button
                type="button"
                class=${c({
          btn: !0,
          "btn-subtle": !0,
          "btn-xs": !0,
          ...u(this.playerState)
        })}
                data-testid="${e}-${l * 100}"
                @click=${a(l)}
                @keydown=${(h) => this.onColorOptionsKeyDown(h)}
              >
                ${`${l * 100}%`}
              </button>
            `
      )}
        </div>
      </ump-menu-item>
    `;
    };
  }
  render() {
    var a;
    const { captionTracks: e, selectedCaptionTrackId: t, captionSettings: o } = this.playerState;
    if (e.length <= 1)
      return null;
    const r = this.playerState.disableKeyboardEvents ? 0 : -1;
    return d`
      <ump-popup
        popupAriaLabel="${s("Captions")}"
        @ump-popup-changed=${() => this.requestUpdate()}
      >
        <button
          type="button"
          slot="trigger"
          class=${c({
      btn: !0,
      "btn-subtle": !0,
      "btn-icon-only": !0,
      ...u(this.playerState),
      tooltip: !0,
      "tooltip-disable-when-aria-expanded": !0
    })}
          data-tooltip="${s("Captions")}"
          aria-label="${s("Captions Menu")}"
          data-testid="captions-menu-button"
        >
          ${(a = this.popup) != null && a.opened ? v(Co) : v($o)}
        </button>

        <ump-menu data-focusgroup>
          <!-- DEFAULT MENU -->
          <ump-submenu>
            <div class="menu-scrollable" data-scrollable>
              <ump-menu-label> ${s("Captions")} </ump-menu-label>

              <hr aria-hidden="true" />

              ${e.map(
      (n) => d`
                  <ump-menu-item
                    class=${c({ ...u(this.playerState) })}
                    type="radio"
                    .checked="${n.captionId === t}"
                    @click=${this.onCaptionClicked(n)}
                  >
                    ${n.captionId !== ae.captionId ? n.label : ae.label}
                  </ump-menu-item>
                `
    )}
            </div>
            <div class="menu-footer">
              <ump-menu-footer>
                <button
                  type="button"
                  class=${c({
      btn: !0,
      "btn-outline": !0,
      ...u(this.playerState)
    })}
                  role="menuitem"
                  submenu="captions-settings"
                  slot="suffix"
                  tabindex="${r}"
                  @focusin=${this.onFooterButtonFocusIn}
                  @focusout=${this.onFooterButtonFocusOut}
                  aria-roledescription="button"
                  aria-label="${s("Caption Settings")}"
                  data-testid="captions-settings-button"
                >
                  ${s("Caption Settings")}
                  ${this.playerState.dir === "ltr" ? v(De) : v(Ae)}
                </button>
              </ump-menu-footer>
            </div>
          </ump-submenu>

          <!-- SETTINGS MENU -->
          <ump-submenu id="captions-settings">
            <ump-menu-item
              class=${c({ ...u(this.playerState) })}
              submenu="${z}"
            >
              ${s("Caption Settings")}
            </ump-menu-item>

            <hr aria-hidden="true" />

            <ump-menu-item
              class=${c({ ...u(this.playerState) })}
              submenu="captions-font-size"
            >
              ${s("Font Size")}
              <div slot="suffix">${`${o.fontScale * 100}%`}</div>
            </ump-menu-item>

            <ump-menu-item
              class=${c({ ...u(this.playerState) })}
              submenu="captions-text-color"
            >
              ${s("Text Color")}
              <div slot="suffix">
                ${s(
      ye.find(
        (n) => n.hexCode === o.textColor
      ).label
    )},
                ${o.textOpacity === 1 ? s("Opaque") : `${o.textOpacity * 100}%`}
              </div>
            </ump-menu-item>

            <ump-menu-item
              class=${c({ ...u(this.playerState) })}
              submenu="captions-background-color"
            >
              ${s("Background Color")}
              <div slot="suffix">
                ${s(
      ye.find(
        (n) => n.hexCode === o.backgroundColor
      ).label
    )},
                ${o.backgroundOpacity === 1 ? s("Opaque") : `${o.backgroundOpacity * 100}%`}
              </div>
            </ump-menu-item>

            <ump-menu-item
              class=${c({ ...u(this.playerState) })}
              submenu="captions-font-family"
            >
              ${s("Font Family")}
              <div slot="suffix">
                ${s(
      ct.find(
        (n) => n.family === o.fontFamily
      ).label
    )}
              </div>
            </ump-menu-item>

            <ump-menu-item
              class=${c({ ...u(this.playerState) })}
              submenu="captions-text-edge-style"
            >
              ${s("Text Edge Style")}
              <div slot="suffix">
                ${s(
      dt.find(
        (n) => n.textShadow === o.textShadow
      ).label
    )}
              </div>
            </ump-menu-item>
          </ump-submenu>

          <!-- FONT SIZE MENU -->
          <ump-submenu id="captions-font-size">
            <div class="menu-scrollable" data-scrollable>
              <ump-menu-item
                class=${c({ ...u(this.playerState) })}
                submenu="${z}"
              >
                ${s("Font Size")}
              </ump-menu-item>

              <hr aria-hidden="true" />

              ${So.map(
      (n) => d`
                  <ump-menu-item
                    class=${c({ ...u(this.playerState) })}
                    type="radio"
                    .checked=${o.fontScale === n}
                    @click=${this.onFontSizeClicked(n)}
                  >
                    ${`${n * 100}%`}
                  </ump-menu-item>
                `
    )}
            </div>
            <div class="menu-footer">
              <ump-menu-footer>
                <button
                  type="button"
                  class=${c({
      btn: !0,
      "btn-outline": !0,
      ...u(this.playerState)
    })}
                  slot="suffix"
                  role="menuitem"
                  aria-roledescription="button"
                  aria-label="${s("Reset")}"
                  tabindex="${r}"
                  @focusin=${this.onFooterButtonFocusIn}
                  @focusout=${this.onFooterButtonFocusOut}
                  data-testid="reset-font-size"
                  @click=${this.onFontSizeClicked(
      Z.fontScale
    )}
                >
                  ${s("Reset")}
                </button>
              </ump-menu-footer>
            </div>
          </ump-submenu>

          <!-- TEXT COLOR MENU -->
          <ump-submenu id="captions-text-color">
            <div class="menu-scrollable" data-scrollable>
              <ump-menu-item
                class=${c({ ...u(this.playerState) })}
                submenu="${z}"
              >
                ${s("Text Color")}
              </ump-menu-item>

              <hr aria-hidden="true" />

              ${this.buildColorMenu(
      "text-color",
      o.textColor,
      o.textOpacity,
      this.onTextColorClicked.bind(this),
      this.onTextOpacityClicked.bind(this)
    )}
            </div>
            <div class="menu-footer">
              <ump-menu-footer>
                <button
                  type="button"
                  class=${c({
      btn: !0,
      "btn-outline": !0,
      ...u(this.playerState)
    })}
                  slot="suffix"
                  role="menuitem"
                  aria-roledescription="button"
                  aria-label="${s("Reset")}"
                  tabindex="${r}"
                  @focusin=${this.onFooterButtonFocusIn}
                  @focusout=${this.onFooterButtonFocusOut}
                  data-testid="reset-text-color"
                  @click=${() => {
      this.onTextColorClicked(
        Z.textColor
      )(), this.onTextOpacityClicked(
        Z.textOpacity
      )();
    }}
                >
                  ${s("Reset")}
                </button>
              </ump-menu-footer>
            </div>
          </ump-submenu>

          <!-- BACKGROUND COLOR MENU -->
          <ump-submenu id="captions-background-color">
            <div class="menu-scrollable" data-scrollable>
              <ump-menu-item
                class=${c({ ...u(this.playerState) })}
                submenu="${z}"
              >
                ${s("Background Color")}
              </ump-menu-item>

              <hr aria-hidden="true" />

              ${this.buildColorMenu(
      "background-color",
      o.backgroundColor,
      o.backgroundOpacity,
      this.onBackgroundColorClicked.bind(this),
      this.onBackgroundOpacityClicked.bind(this)
    )}
            </div>
            <div class="menu-footer">
              <ump-menu-footer>
                <button
                  type="button"
                  class=${c({
      btn: !0,
      "btn-outline": !0,
      ...u(this.playerState)
    })}
                  slot="suffix"
                  role="menuitem"
                  aria-roledescription="button"
                  aria-label="${s("Reset")}"
                  tabindex="${r}"
                  @focusin=${this.onFooterButtonFocusIn}
                  @focusout=${this.onFooterButtonFocusOut}
                  data-testid="reset-background-color"
                  @click=${() => {
      this.onBackgroundColorClicked(
        Z.backgroundColor
      )(), this.onBackgroundOpacityClicked(
        Z.backgroundOpacity
      )();
    }}
                >
                  ${s("Reset")}
                </button>
              </ump-menu-footer>
            </div>
          </ump-submenu>

          <!-- FONT FAMILY MENU -->
          <ump-submenu id="captions-font-family">
            <div class="menu-scrollable" data-scrollable>
              <ump-menu-item
                class=${c({ ...u(this.playerState) })}
                submenu="${z}"
              >
                ${s("Font Family")}
              </ump-menu-item>

              <hr aria-hidden="true" />

              ${ct.map(
      (n) => d`
                  <ump-menu-item
                    class=${c({ ...u(this.playerState) })}
                    type="radio"
                    .checked=${n.family === o.fontFamily}
                    @click=${this.onFontFamilyClicked(n.family)}
                  >
                    ${s(n.label)}
                  </ump-menu-item>
                `
    )}
            </div>
            <div class="menu-footer">
              <ump-menu-footer>
                <button
                  type="button"
                  class=${c({
      btn: !0,
      "btn-outline": !0,
      ...u(this.playerState)
    })}
                  slot="suffix"
                  role="menuitem"
                  aria-roledescription="button"
                  aria-label="${s("Reset")}"
                  tabindex="${r}"
                  @focusin=${this.onFooterButtonFocusIn}
                  @focusout=${this.onFooterButtonFocusOut}
                  data-testid="reset-font-family"
                  @click=${this.onFontFamilyClicked(
      Z.fontFamily
    )}
                >
                  ${s("Reset")}
                </button>
              </ump-menu-footer>
            </div>
          </ump-submenu>

          <!-- TEXT EDGE STYLE MENU -->
          <ump-submenu id="captions-text-edge-style">
            <div class="menu-scrollable" data-scrollable>
              <ump-menu-item
                class=${c({ ...u(this.playerState) })}
                submenu="${z}"
              >
                ${s("Text Edge Style")}
              </ump-menu-item>

              <hr aria-hidden="true" />

              ${dt.map(
      (n) => d`
                  <ump-menu-item
                    class=${c({ ...u(this.playerState) })}
                    type="radio"
                    .checked=${o.textShadow === n.textShadow}
                    @click=${this.onTextEdgeStyleClicked(n.textShadow)}
                  >
                    ${s(n.label)}
                  </ump-menu-item>
                `
    )}
            </div>
            <div class="menu-footer">
              <ump-menu-footer>
                <button
                  type="button"
                  class=${c({
      btn: !0,
      "btn-outline": !0,
      ...u(this.playerState)
    })}
                  slot="suffix"
                  role="menuitem"
                  aria-roledescription="button"
                  aria-label="${s("Reset")}"
                  tabindex="${r}"
                  @focusin=${this.onFooterButtonFocusIn}
                  @focusout=${this.onFooterButtonFocusOut}
                  data-testid="reset-text-edge-style"
                  @click=${this.onTextEdgeStyleClicked(
      Z.textShadow
    )}
                >
                  ${s("Reset")}
                </button>
              </ump-menu-footer>
            </div>
          </ump-submenu>
        </ump-menu>
      </ump-popup>
    `;
  }
  onFooterButtonFocusIn(e) {
    this.playerState.disableKeyboardEvents || (e.target.tabIndex = 0);
  }
  onFooterButtonFocusOut(e) {
    this.playerState.disableKeyboardEvents || (e.target.tabIndex = -1);
  }
  onCaptionClicked(e) {
    return () => {
      this.dispatchEvent(new p("caption-track-clicked", e)), this.dispatchEvent(new p("closedcaptionschanged"));
    };
  }
  captionSettingChanged(e) {
    this.dispatchEvent(e), this.dispatchEvent(new p("closedcaptionsettingschanged"));
  }
  onFontSizeClicked(e) {
    return () => this.captionSettingChanged(
      new p("caption-font-size-clicked", e)
    );
  }
  onTextColorClicked(e) {
    return () => this.captionSettingChanged(
      new p("caption-text-color-clicked", e)
    );
  }
  onTextOpacityClicked(e) {
    return () => this.captionSettingChanged(
      new p("caption-text-opacity-clicked", e)
    );
  }
  onBackgroundColorClicked(e) {
    return () => this.captionSettingChanged(
      new p("caption-background-color-clicked", e)
    );
  }
  onBackgroundOpacityClicked(e) {
    return () => this.captionSettingChanged(
      new p("caption-background-opacity-clicked", e)
    );
  }
  onFontFamilyClicked(e) {
    return () => this.captionSettingChanged(
      new p("caption-font-family-clicked", e)
    );
  }
  onTextEdgeStyleClicked(e) {
    return () => this.captionSettingChanged(
      new p("caption-text-edge-style-clicked", e)
    );
  }
  onColorOptionsKeyDown(e) {
    if (this.playerState.disableKeyboardEvents) return;
    const t = e.currentTarget, o = Array.from(
      t.parentElement.querySelectorAll("button")
    ), r = o.indexOf(t);
    switch (e.key) {
      case " ":
      case "Enter":
        e.preventDefault(), e.stopPropagation(), t.click();
        break;
      case "ArrowRight": {
        const a = (r + 1) % o.length;
        o[a].focus();
        break;
      }
      case "ArrowLeft": {
        const a = (r - 1 + o.length) % o.length;
        o[a].focus();
        break;
      }
    }
  }
  get opened() {
    var e;
    return (e = this.popup) == null ? void 0 : e.opened;
  }
};
ce.styles = [
  B,
  Me,
  te,
  w`
.btn.tooltip{--tooltip-gap:var(--spacing-xxxl)}ump-popup{--ump-popup-spacing:var(--spacing-xxxl)}ump-menu{width:var(--size-80);display:block}@container universalmediaplayer (max-width:450px){ump-menu{width:calc(var(--size-80) - 3cqw)}}.menu-title-spacer{width:var(--size-6);height:var(--size-6)}@container universalmediaplayer (min-width:0){.menu-scrollable{scrollbar-base-color:green;overflow:hidden auto;max-height:calc(100cqh - var(--ump-lower-controls-height) - 4rem);flex-direction:column;padding:var(--spacing-xs)}}.menu-footer{width:100%;border-top:1px solid var(--color-neutral-stroke-alpha)}.menu-footer div:focus,.menu-footer div:focus-visible{outline:var(--stroke-width-thick) solid var(--color-stroke-focus-2)}.menu-footer div svg{fill:currentcolor}.color-suffix{display:flex;align-items:center;justify-content:space-between;gap:var(--spacing-m);padding:var(--spacing-s) var(--spacing-m)}.opacity-suffix{display:flex;gap:var(--spacing-xs)}.opacity-suffix .btn{font-weight:var(--font-weight-normal)}.cc-style-menu-item{display:flex;align-items:center;justify-content:space-between;padding:var(--spacing-s) 0}.btn-color{width:var(--size-5);height:var(--size-5);padding:0;border:solid var(--stroke-width-thin) var(--color-neutral-stroke-1)}.text-color-list{display:flex;gap:var(--spacing-s)}@media (forced-colors:active){.btn-color{outline:var(--stroke-width-thick) solid;outline-offset:var(--spacing-xxs)}.btn-color:hover{outline-color:Highlight}.menu-footer{border-top-color:ButtonBorder}}
    `
];
We([
  $("ump-popup")
], ce.prototype, "popup", 2);
We([
  M({ context: L, subscribe: !0 })
], ce.prototype, "playerState", 2);
ce = We([
  S("ump-caption-menu")
], ce);
const Lo = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M16 10A6 6 0 0 0 5.53 6H7.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v1.6a7 7 0 1 1-1.98 4.36.5.5 0 0 1 1 .08L4 10a6 6 0 0 0 12 0Z"/></svg>', Po = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 5.25C3 4.01 4 3 5.25 3h1.87a.75.75 0 1 1 0 1.5H5.25a.75.75 0 0 0-.75.75v1.87a.75.75 0 1 1-1.5 0V5.25Zm9.13-1.5c0-.41.34-.75.75-.75h1.87C15.99 3 17 4 17 5.25v1.87a.75.75 0 0 1-1.5 0V5.25a.75.75 0 0 0-.75-.75h-1.87a.75.75 0 0 1-.75-.75Zm-8.38 8.38c.41 0 .75.34.75.75v1.87c0 .41.34.75.75.75h1.87a.75.75 0 0 1 0 1.5H5.25C4.01 17 3 16 3 14.75v-1.87c0-.41.34-.75.75-.75Zm12.5 0c.41 0 .75.34.75.75v1.87c0 1.24-1 2.25-2.25 2.25h-1.87a.75.75 0 0 1 0-1.5h1.87c.41 0 .75-.34.75-.75v-1.87c0-.41.34-.75.75-.75Z"/></svg>', _o = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15 5.5a.5.5 0 0 1-.5-.5V2.75a.75.75 0 0 0-1.5 0V5c0 1.1.9 2 2 2h2.25a.75.75 0 0 0 0-1.5H15ZM5.5 15a.5.5 0 0 0-.5-.5H2.75a.75.75 0 0 1 0-1.5H5a2 2 0 0 1 2 2v2.25a.75.75 0 0 1-1.5 0V15Zm9 0c0-.28.22-.5.5-.5h2.25a.75.75 0 0 0 0-1.5H15a2 2 0 0 0-2 2v2.25a.75.75 0 0 0 1.5 0V15Zm-9-10a.5.5 0 0 1-.5.5H2.75a.75.75 0 0 0 0 1.5H5a2 2 0 0 0 2-2V2.75a.75.75 0 0 0-1.5 0V5Z"/></svg>', Vo = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5ZM4 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4Zm9-2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-2Zm-1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4Z"/></svg>', zo = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M17.22 8.69a1.5 1.5 0 0 1 0 2.62l-10 5.5A1.5 1.5 0 0 1 5 15.5v-11A1.5 1.5 0 0 1 7.22 3.2l10 5.5Zm-.48 1.75a.5.5 0 0 0 0-.88l-10-5.5A.5.5 0 0 0 6 4.5v11c0 .38.4.62.74.44l10-5.5Z"/></svg>', Fo = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12 3a1 1 0 0 0-1.68-.73l-3.88 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .34.13l3.88 3.6a1 1 0 0 0 1.68-.74V3.01ZM7.12 6.6 11 3v14l-3.88-3.6A1.5 1.5 0 0 0 6.1 13H3.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.14 1.02-.4Zm8.14-1.97a.5.5 0 0 1 .7.04 8 8 0 0 1 0 10.66.5.5 0 0 1-.74-.66 7 7 0 0 0 0-9.34.5.5 0 0 1 .04-.7Zm-1.18 8.3a.5.5 0 0 1-.18-.68 4.5 4.5 0 0 0 0-4.5.5.5 0 1 1 .86-.5 5.5 5.5 0 0 1 0 5.5.5.5 0 0 1-.68.18Z"/></svg>', Oo = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.85 2.15a.5.5 0 1 0-.7.7L5.29 6H3.5C2.68 6 2 6.67 2 7.5v5c0 .83.68 1.5 1.5 1.5H6.1a.5.5 0 0 1 .34.13l3.88 3.6a1 1 0 0 0 1.68-.74V12.7l5.15 5.15a.5.5 0 0 0 .7-.7l-2.56-2.57L2.85 2.15ZM11 11.7V17l-3.88-3.6A1.5 1.5 0 0 0 6.1 13H3.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5h2.6l.18-.01L11 11.7ZM11 3v5.88l1 1V3a1 1 0 0 0-1.68-.74L7.24 5.12l.71.71L11 3.01Zm3.06 8.94.74.74a5.5 5.5 0 0 0-.04-5.43.5.5 0 1 0-.86.5 4.5 4.5 0 0 1 .16 4.19Zm1.84 1.84.72.72a8 8 0 0 0-.66-9.83.5.5 0 1 0-.74.66 7 7 0 0 1 .68 8.45Z"/></svg>', Ao = (e, t, o) => {
  const r = e[t];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((a, n) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      n.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + t + (t.split("/").length !== o ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, Do = "en-us", Ro = [
  "af-za",
  "am-et",
  "ar-sa",
  "as-in",
  "be-by",
  "bg-bg",
  "bn-in",
  "ca-es",
  "cs-cz",
  "cy-gb",
  "da-dk",
  "de-at",
  "de-ch",
  "de-de",
  "el-gr",
  "en-au",
  "en-ca",
  "en-gb",
  "en-hk",
  "en-ie",
  "en-in",
  "en-my",
  "en-nz",
  "en-ph",
  "en-sg",
  "en-za",
  "es-ar",
  "es-cl",
  "es-co",
  "es-es",
  "es-mx",
  "et-ee",
  "eu-es",
  "fa-ir",
  "fi-fi",
  "fr-be",
  "fr-ca",
  "fr-ch",
  "fr-fr",
  "fr-ma",
  "ga-ie",
  "gd-gb",
  "gl-es",
  "gu-in",
  "he-il",
  "hi-in",
  "hr-hr",
  "hu-hu",
  "hy-am",
  "id-id",
  "is-is",
  "it-it",
  "ja-jp",
  "ka-ge",
  "kk-kz",
  "kn-in",
  "ko-kr",
  "ky-kg",
  "lb-lu",
  "lo-la",
  "lt-lt",
  "lv-lv",
  "mi-nz",
  "mk-mk",
  "ml-in",
  "mr-in",
  "ms-bn",
  "ms-my",
  "mt-mt",
  "nb-no",
  "ne-np",
  "nl-be",
  "nl-nl",
  "nn-no",
  "or-in",
  "pa-in",
  "pl-pl",
  "ps-af",
  "pt-br",
  "pt-pt",
  "ro-ro",
  "ru-ru",
  "si-lk",
  "sk-sk",
  "sl-si",
  "sq-al",
  "sv-se",
  "sw-ke",
  "ta-in",
  "te-in",
  "tg-tj",
  "th-th",
  "ti-et",
  "tk-tm",
  "tr-tr",
  "tt-ru",
  "ug-cn",
  "uk-ua",
  "ur-in",
  "ur-pk",
  "uz-uz",
  "vi-vn",
  "wo-sn",
  "xh-za",
  "yo-ng",
  "zh-cn",
  "zh-hk",
  "zh-tw",
  "zu-za"
], No = [
  "af-za",
  "am-et",
  "ar-sa",
  "as-in",
  "be-by",
  "bg-bg",
  "bn-in",
  "ca-es",
  "cs-cz",
  "cy-gb",
  "da-dk",
  "de-at",
  "de-ch",
  "de-de",
  "el-gr",
  "en-au",
  "en-ca",
  "en-gb",
  "en-hk",
  "en-ie",
  "en-in",
  "en-my",
  "en-nz",
  "en-ph",
  "en-sg",
  "en-us",
  "en-za",
  "es-ar",
  "es-cl",
  "es-co",
  "es-es",
  "es-mx",
  "et-ee",
  "eu-es",
  "fa-ir",
  "fi-fi",
  "fr-be",
  "fr-ca",
  "fr-ch",
  "fr-fr",
  "fr-ma",
  "ga-ie",
  "gd-gb",
  "gl-es",
  "gu-in",
  "he-il",
  "hi-in",
  "hr-hr",
  "hu-hu",
  "hy-am",
  "id-id",
  "is-is",
  "it-it",
  "ja-jp",
  "ka-ge",
  "kk-kz",
  "kn-in",
  "ko-kr",
  "ky-kg",
  "lb-lu",
  "lo-la",
  "lt-lt",
  "lv-lv",
  "mi-nz",
  "mk-mk",
  "ml-in",
  "mr-in",
  "ms-bn",
  "ms-my",
  "mt-mt",
  "nb-no",
  "ne-np",
  "nl-be",
  "nl-nl",
  "nn-no",
  "or-in",
  "pa-in",
  "pl-pl",
  "ps-af",
  "pt-br",
  "pt-pt",
  "ro-ro",
  "ru-ru",
  "si-lk",
  "sk-sk",
  "sl-si",
  "sq-al",
  "sv-se",
  "sw-ke",
  "ta-in",
  "te-in",
  "tg-tj",
  "th-th",
  "ti-et",
  "tk-tm",
  "tr-tr",
  "tt-ru",
  "ug-cn",
  "uk-ua",
  "ur-in",
  "ur-pk",
  "uz-uz",
  "vi-vn",
  "wo-sn",
  "xh-za",
  "yo-ng",
  "zh-cn",
  "zh-hk",
  "zh-tw",
  "zu-za"
], St = {
  en: "en-us",
  es: "es-es",
  de: "de-de",
  fi: "fi-fi",
  fr: "fr-fr",
  hi: "hi-in",
  hu: "hu-hu",
  is: "is-is",
  it: "it-it",
  ja: "ja-jp",
  kk: "kk-kz",
  ko: "ko-kr",
  lt: "lt-lt",
  lv: "lv-lv",
  mk: "mk-mk",
  mt: "mt-mt",
  nb: "nb-no",
  nn: "nn-no",
  pl: "pl-pl",
  pt: "pt-pt",
  ro: "ro-ro",
  ru: "ru-ru",
  sk: "sk-sk",
  sl: "sl-si",
  sq: "sq-al",
  sv: "sv-se",
  ta: "ta-in",
  te: "te-in",
  th: "th-th",
  tr: "tr-tr",
  uk: "uk-ua",
  ur: "ur-pk",
  uz: "uz-uz",
  vi: "vi-vn",
  zh: "zh-cn"
};
function _e(e) {
  try {
    return new Intl.DisplayNames([e], {
      type: "language",
      fallback: "none"
    }).of(e);
  } catch {
    return;
  }
}
const Ee = (e) => {
  const t = /* @__PURE__ */ new Map(), o = e.map((r) => {
    const [a, n] = r.split("-");
    let i = _e(a), l = null;
    if (!i)
      i = r;
    else if (n) {
      const x = _e(r);
      x && x !== i && (l = x);
    } else {
      const x = St[a.toLowerCase()];
      if (x) {
        const E = _e(x);
        E && E !== i && (l = E);
      }
    }
    let h = t.get(i);
    h || (h = [], t.set(i, h));
    const k = {
      code: r,
      fallbackName: l,
      selectedName: i
    };
    return h.push(k), k;
  });
  for (const [r, a] of t)
    if (a.length > 1 && new Set(a.map((n) => n.fallbackName)).size > 1)
      for (const n of a)
        n.selectedName = n.fallbackName || r;
  return Object.fromEntries(o.map((r) => [r.code, r.selectedName]));
}, we = (e) => {
  if (e)
    return e = e.toLowerCase(), No.includes(e) ? e : St[e.split("-")[0]];
}, Uo = /* @__PURE__ */ new Set([
  "??-??-????????",
  "???-????-??",
  "??-????-??",
  "???-????",
  "??-????",
  "???-??",
  "??-??",
  "???",
  "??"
]), Bo = Array.from(Uo).map((e) => `(?:${e.replace(/\?/g, "[a-zA-Z]")})`).join("|");
function Ho() {
  const e = new RegExp(`^https?://[^/]+/(${Bo})/[^/]+.*`), t = window.location.href.match(e);
  return t && we(t[1]) || null;
}
const Re = /* @__PURE__ */ new Map(), pt = {
  "es-es": { templates: Wt },
  "pt-br": { templates: to },
  "en-gb": { templates: Yt },
  "fr-fr": { templates: Jt },
  "es-mx": { templates: Xt },
  "it-it": { templates: eo }
};
let It = (e) => Ao(/* @__PURE__ */ Object.assign({ "../generated/locales/af-za.ts": () => import("./locales/af-za.mjs"), "../generated/locales/am-et.ts": () => import("./locales/am-et.mjs"), "../generated/locales/ar-sa.ts": () => import("./locales/ar-sa.mjs"), "../generated/locales/as-in.ts": () => import("./locales/as-in.mjs"), "../generated/locales/be-by.ts": () => import("./locales/be-by.mjs"), "../generated/locales/bg-bg.ts": () => import("./locales/bg-bg.mjs"), "../generated/locales/bn-in.ts": () => import("./locales/bn-in.mjs"), "../generated/locales/ca-es.ts": () => import("./locales/ca-es.mjs"), "../generated/locales/cs-cz.ts": () => import("./locales/cs-cz.mjs"), "../generated/locales/cy-gb.ts": () => import("./locales/cy-gb.mjs"), "../generated/locales/da-dk.ts": () => import("./locales/da-dk.mjs"), "../generated/locales/de-at.ts": () => import("./locales/de-at.mjs"), "../generated/locales/de-ch.ts": () => import("./locales/de-ch.mjs"), "../generated/locales/de-de.ts": () => import("./locales/de-de.mjs"), "../generated/locales/el-gr.ts": () => import("./locales/el-gr.mjs"), "../generated/locales/en-au.ts": () => import("./locales/en-au.mjs"), "../generated/locales/en-ca.ts": () => import("./locales/en-ca.mjs"), "../generated/locales/en-gb.ts": () => import("./locales/en-gb.mjs"), "../generated/locales/en-hk.ts": () => import("./locales/en-hk.mjs"), "../generated/locales/en-ie.ts": () => import("./locales/en-ie.mjs"), "../generated/locales/en-in.ts": () => import("./locales/en-in.mjs"), "../generated/locales/en-my.ts": () => import("./locales/en-my.mjs"), "../generated/locales/en-nz.ts": () => import("./locales/en-nz.mjs"), "../generated/locales/en-ph.ts": () => import("./locales/en-ph.mjs"), "../generated/locales/en-sg.ts": () => import("./locales/en-sg.mjs"), "../generated/locales/en-za.ts": () => import("./locales/en-za.mjs"), "../generated/locales/es-ar.ts": () => import("./locales/es-ar.mjs"), "../generated/locales/es-cl.ts": () => import("./locales/es-cl.mjs"), "../generated/locales/es-co.ts": () => import("./locales/es-co.mjs"), "../generated/locales/es-es.ts": () => import("./locales/es-es.mjs"), "../generated/locales/es-mx.ts": () => import("./locales/es-mx.mjs"), "../generated/locales/et-ee.ts": () => import("./locales/et-ee.mjs"), "../generated/locales/eu-es.ts": () => import("./locales/eu-es.mjs"), "../generated/locales/fa-ir.ts": () => import("./locales/fa-ir.mjs"), "../generated/locales/fi-fi.ts": () => import("./locales/fi-fi.mjs"), "../generated/locales/fr-be.ts": () => import("./locales/fr-be.mjs"), "../generated/locales/fr-ca.ts": () => import("./locales/fr-ca.mjs"), "../generated/locales/fr-ch.ts": () => import("./locales/fr-ch.mjs"), "../generated/locales/fr-fr.ts": () => import("./locales/fr-fr.mjs"), "../generated/locales/fr-ma.ts": () => import("./locales/fr-ma.mjs"), "../generated/locales/ga-ie.ts": () => import("./locales/ga-ie.mjs"), "../generated/locales/gd-gb.ts": () => import("./locales/gd-gb.mjs"), "../generated/locales/gl-es.ts": () => import("./locales/gl-es.mjs"), "../generated/locales/gu-in.ts": () => import("./locales/gu-in.mjs"), "../generated/locales/he-il.ts": () => import("./locales/he-il.mjs"), "../generated/locales/hi-in.ts": () => import("./locales/hi-in.mjs"), "../generated/locales/hr-hr.ts": () => import("./locales/hr-hr.mjs"), "../generated/locales/hu-hu.ts": () => import("./locales/hu-hu.mjs"), "../generated/locales/hy-am.ts": () => import("./locales/hy-am.mjs"), "../generated/locales/id-id.ts": () => import("./locales/id-id.mjs"), "../generated/locales/is-is.ts": () => import("./locales/is-is.mjs"), "../generated/locales/it-it.ts": () => import("./locales/it-it.mjs"), "../generated/locales/ja-jp.ts": () => import("./locales/ja-jp.mjs"), "../generated/locales/ka-ge.ts": () => import("./locales/ka-ge.mjs"), "../generated/locales/kk-kz.ts": () => import("./locales/kk-kz.mjs"), "../generated/locales/kn-in.ts": () => import("./locales/kn-in.mjs"), "../generated/locales/ko-kr.ts": () => import("./locales/ko-kr.mjs"), "../generated/locales/ky-kg.ts": () => import("./locales/ky-kg.mjs"), "../generated/locales/lb-lu.ts": () => import("./locales/lb-lu.mjs"), "../generated/locales/lo-la.ts": () => import("./locales/lo-la.mjs"), "../generated/locales/lt-lt.ts": () => import("./locales/lt-lt.mjs"), "../generated/locales/lv-lv.ts": () => import("./locales/lv-lv.mjs"), "../generated/locales/mi-nz.ts": () => import("./locales/mi-nz.mjs"), "../generated/locales/mk-mk.ts": () => import("./locales/mk-mk.mjs"), "../generated/locales/ml-in.ts": () => import("./locales/ml-in.mjs"), "../generated/locales/mr-in.ts": () => import("./locales/mr-in.mjs"), "../generated/locales/ms-bn.ts": () => import("./locales/ms-bn.mjs"), "../generated/locales/ms-my.ts": () => import("./locales/ms-my.mjs"), "../generated/locales/mt-mt.ts": () => import("./locales/mt-mt.mjs"), "../generated/locales/nb-no.ts": () => import("./locales/nb-no.mjs"), "../generated/locales/ne-np.ts": () => import("./locales/ne-np.mjs"), "../generated/locales/nl-be.ts": () => import("./locales/nl-be.mjs"), "../generated/locales/nl-nl.ts": () => import("./locales/nl-nl.mjs"), "../generated/locales/nn-no.ts": () => import("./locales/nn-no.mjs"), "../generated/locales/or-in.ts": () => import("./locales/or-in.mjs"), "../generated/locales/pa-in.ts": () => import("./locales/pa-in.mjs"), "../generated/locales/pl-pl.ts": () => import("./locales/pl-pl.mjs"), "../generated/locales/ps-af.ts": () => import("./locales/ps-af.mjs"), "../generated/locales/pt-br.ts": () => import("./locales/pt-br.mjs"), "../generated/locales/pt-pt.ts": () => import("./locales/pt-pt.mjs"), "../generated/locales/ro-ro.ts": () => import("./locales/ro-ro.mjs"), "../generated/locales/ru-ru.ts": () => import("./locales/ru-ru.mjs"), "../generated/locales/si-lk.ts": () => import("./locales/si-lk.mjs"), "../generated/locales/sk-sk.ts": () => import("./locales/sk-sk.mjs"), "../generated/locales/sl-si.ts": () => import("./locales/sl-si.mjs"), "../generated/locales/sq-al.ts": () => import("./locales/sq-al.mjs"), "../generated/locales/sv-se.ts": () => import("./locales/sv-se.mjs"), "../generated/locales/sw-ke.ts": () => import("./locales/sw-ke.mjs"), "../generated/locales/ta-in.ts": () => import("./locales/ta-in.mjs"), "../generated/locales/te-in.ts": () => import("./locales/te-in.mjs"), "../generated/locales/tg-tj.ts": () => import("./locales/tg-tj.mjs"), "../generated/locales/th-th.ts": () => import("./locales/th-th.mjs"), "../generated/locales/ti-et.ts": () => import("./locales/ti-et.mjs"), "../generated/locales/tk-tm.ts": () => import("./locales/tk-tm.mjs"), "../generated/locales/tr-tr.ts": () => import("./locales/tr-tr.mjs"), "../generated/locales/tt-ru.ts": () => import("./locales/tt-ru.mjs"), "../generated/locales/ug-cn.ts": () => import("./locales/ug-cn.mjs"), "../generated/locales/uk-ua.ts": () => import("./locales/uk-ua.mjs"), "../generated/locales/ur-in.ts": () => import("./locales/ur-in.mjs"), "../generated/locales/ur-pk.ts": () => import("./locales/ur-pk.mjs"), "../generated/locales/uz-uz.ts": () => import("./locales/uz-uz.mjs"), "../generated/locales/vi-vn.ts": () => import("./locales/vi-vn.mjs"), "../generated/locales/wo-sn.ts": () => import("./locales/wo-sn.mjs"), "../generated/locales/xh-za.ts": () => import("./locales/xh-za.mjs"), "../generated/locales/yo-ng.ts": () => import("./locales/yo-ng.mjs"), "../generated/locales/zh-cn.ts": () => import("./locales/zh-cn.mjs"), "../generated/locales/zh-hk.ts": () => import("./locales/zh-hk.mjs"), "../generated/locales/zh-tw.ts": () => import("./locales/zh-tw.mjs"), "../generated/locales/zu-za.ts": () => import("./locales/zu-za.mjs") }), `../generated/locales/${e}.ts`, 4);
function jo(e) {
  let t = Re.get(e);
  return t || (pt[e] ? t = Promise.resolve(pt[e]) : t = It(e), Re.set(e, t)), t;
}
const { getLocale: Zo, setLocale: qo } = Qt({
  sourceLocale: Do,
  targetLocales: Ro,
  loadLocale: jo
}), Go = (e) => {
  const t = we(e), o = we(document.documentElement.lang), r = Ho(), a = we(Oe.language) || Oe.language;
  return t || // via preferred language code
  o || // via html lang attribute
  r || // via URL
  a;
};
function Rn(e, t) {
  Re.set(e, Promise.resolve(t));
}
function Nn(e) {
  It = e;
}
function Ve(e) {
  const t = Math.floor(e / 3600), o = Math.floor(e % 3600 / 60), r = Math.floor(e % 60), a = t > 0 ? `${t}:` : "", n = `${o.toString().padStart(t > 0 ? 2 : 1, "0")}:`, i = r.toString().padStart(2, "0");
  return `${a}${n}${i}`;
}
const ht = /* @__PURE__ */ new Map();
function Ko(e) {
  let t = ht.get(e);
  return t || (t = {
    hour: new Intl.NumberFormat(e, {
      style: "unit",
      unit: "hour",
      unitDisplay: "long"
    }),
    minute: new Intl.NumberFormat(e, {
      style: "unit",
      unit: "minute",
      unitDisplay: "long"
    }),
    second: new Intl.NumberFormat(e, {
      style: "unit",
      unit: "second",
      unitDisplay: "long"
    })
  }, ht.set(e, t)), t;
}
function mt(e, t) {
  const o = Ko(t);
  if (Math.floor(e) === 0)
    return o.second.format(0);
  const r = Math.floor(e / 3600), a = Math.floor(e % 3600 / 60), n = Math.floor(e % 60), i = [];
  return r > 0 && i.push(o.hour.format(r)), a > 0 && i.push(o.minute.format(a)), n > 0 && i.push(o.second.format(n)), i.join(", ");
}
const Qo = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.03 13.9 3.56 10a.75.75 0 0 0-1.12 1l4 4.5c.29.32.79.34 1.09.03l10.5-10.5a.75.75 0 0 0-1.06-1.06l-9.94 9.94Z"/></svg>', Yo = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m4.09 4.22.06-.07a.5.5 0 0 1 .63-.06l.07.06L10 9.29l5.15-5.14a.5.5 0 0 1 .63-.06l.07.06c.18.17.2.44.06.63l-.06.07L10.71 10l5.14 5.15c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L10 10.71l-5.15 5.14a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07L9.29 10 4.15 4.85a.5.5 0 0 1-.06-.63l.06-.07-.06.07Z"/></svg>', Wo = '<svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><path d="m18.27 3.21 7.5 7.25a.75.75 0 0 1 0 1.08l-7.5 7.25a.73.73 0 0 1-.81.15.75.75 0 0 1-.46-.69v-3.74c-6.7.27-9.52 4.02-9.64 4.18a.77.77 0 0 1-.84.27.75.75 0 0 1-.52-.71c0-8.02 6.59-10.48 11-10.73V3.75a.75.75 0 0 1 1.27-.54Zm.23 10.54v2.71L24.17 11 18.5 5.52v2.73a.76.76 0 0 1-.75.75c-.97 0-8.85.22-10.09 7.28A15.58 15.58 0 0 1 17.75 13a.76.76 0 0 1 .75.75Zm4.22 5.47a.76.76 0 0 1 .53-.22.76.76 0 0 1 .75.75v.5A4.75 4.75 0 0 1 19.25 25H7.75A4.75 4.75 0 0 1 3 20.25V8.75A4.75 4.75 0 0 1 7.75 4h4.5a.75.75 0 1 1 0 1.5h-4.5A3.26 3.26 0 0 0 4.5 8.75v11.5a3.26 3.26 0 0 0 3.25 3.25h11.5a3.26 3.26 0 0 0 3.25-3.25v-.5c0-.2.08-.39.22-.53Z"/></svg>', Le = w`
.dialog{background-color:var(--color-brand-30);color:var(--color-neutral-foreground-1);border-radius:var(--border-radius-x-large);border:solid var(--stroke-width-thin) var(--color-white-alpha-30);box-shadow:var(--shadow-8)}
`;
var Xo = Object.defineProperty, Jo = Object.getOwnPropertyDescriptor, Xe = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? Jo(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && Xo(t, o, a), a;
};
let ue = class extends C {
  render() {
    const { shareOptions: e } = this.playerState, t = e.find((r) => r.id === "copy"), o = e.filter(
      (r) => r.id !== "copy"
    );
    return d`
      <dialog
        data-focusgroup
        @click=${this.onDialogClick}
        @keydown=${this.onKeyDown}
        @close=${this.onClose}
      >
        <div class="dialog-backdrop"></div>
        <div class="dialog">
          <div class="share-icon">${v(Wo)}</div>

          <button
            type="button"
            class=${c({
      btn: !0,
      "btn-sm": !0,
      "btn-subtle": !0,
      "btn-icon-only": !0,
      "btn-close": !0,
      ...u(this.playerState)
    })}
            @click=${this.onClose}
            aria-label=${s("Close")}
            data-id="close-button"
            data-testid="share-dialog-close-button"
          >
            ${v(Yo)}
          </button>

          <div class="dialog-content">
            <h2>${s("Share this video")}</h2>

            ${t ? d`
                  <label>
                    <span class="section-title">Link</span>
                    <div class="input">
                      <input
                        type="text"
                        readonly
                        value="${t.url}"
                        title="${t.url}"
                      />

                      <button
                        type="button"
                        class=${c({
      btn: !0,
      "btn-outline": !0,
      "btn-copy": !0,
      ...u(this.playerState)
    })}
                        @click=${this.onCopyButtonClicked(t.url)}
                        data-testid="copy-share-url-button"
                        aria-label="${s("Copy")}"
                      >
                        ${s("Copy")}
                      </button>
                    </div>
                  </label>
                ` : null}

            <div>
              <span class="section-title">${s("Social")}</span>
              <div class="share-dialog-icons">
                ${o.map(
      (r) => d`
                    <a
                      href=${r.url}
                      class=${c({
        btn: !0,
        "btn-subtle": !0,
        "btn-icon-only": !0,
        "btn-social": !0,
        ...u(this.playerState)
      })}
                      target="_blank"
                      aria-label="${s("Share this video on")} ${r.id}"
                      data-testid="share-social-${r.id}"
                    >
                      ${v(r.icon)}
                    </a>
                  `
    )}
              </div>
            </div>
          </div>
        </div>
      </dialog>
    `;
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.copyTimeoutId && clearTimeout(this.copyTimeoutId);
  }
  firstUpdated(e) {
    super.firstUpdated(e);
  }
  show() {
    this.dialog.show();
  }
  get opened() {
    return this.dialog.open;
  }
  onCopyButtonClicked(e) {
    return async (t) => {
      try {
        const o = t.target;
        await navigator.clipboard.writeText(e), o.ariaLabel = s("Link Copied"), o.innerHTML = Qo, this.copyTimeoutId && clearTimeout(this.copyTimeoutId), this.copyTimeoutId = setTimeout(() => {
          o.ariaLabel = s("Copy"), o.innerText = s("Copy");
        }, 3e3);
      } catch (o) {
        console.log("error copying text", o);
      }
    };
  }
  onDialogClick(e) {
    e.target === this.dialog && this.onClose();
  }
  onKeyDown(e) {
    this.playerState.disableKeyboardEvents || e.key === "Escape" && this.onClose();
  }
  onClose() {
    this.dialog.close(), this.dispatchEvent(new p("share-dialog-closed"));
  }
};
ue.styles = [
  Le,
  B,
  w`
      dialog {
        border: none;
        display: none;
        position: absolute;
        inset: 0;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background-color: transparent;
        max-width: 100%;
        max-height: 100%;
        box-sizing: border-box;
        text-align: left;
      }

      dialog[open] {
        display: flex;
      }

      .dialog {
        padding: var(--spacing-xxl) var(--spacing-xxxl);
        display: flex;
        gap: var(--spacing-xxl);
        z-index: 10;
        margin: var(--spacing-xxl);
        position: relative;
        font-family: var(--controls-font-family);
        color: var(--color-neutral-foreground-1);
      }

      .dialog-backdrop {
        position: absolute;
        inset: 0;
        background-color: var(--color-black-alpha-50);
        pointer-events: none;
      }

      .share-icon {
        stroke: currentcolor;
        fill: currentcolor;
      }

      .btn-close {
        position: absolute;
        right: var(--spacing-xl);
        top: var(--spacing-xl);

        &:hover {
          background-color: transparent;
        }
      }

      .dialog-content {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-xxl);
        margin-right: var(--spacing-xxxl);
      }

      h2 {
        margin-top: 0;
        margin-bottom: var(--spacing-s);
        flex-grow: 1;
      }

      .section-title {
        display: block;
        margin-bottom: var(--spacing-m);
        font-weight: var(--font-weight-semibold);
      }

      .input {
        display: flex;
        align-items: center;
        border-radius: var(--border-radius-medium);
        border: solid var(--stroke-width-thin) var(--color-neutral-stroke-1);
        padding: var(--spacing-s) var(--spacing-m);
        border-color: var(--color-grey-86);
        gap: var(--spacing-m);

        input {
          background-color: transparent;
          border: none;
          outline: none;
          margin: 0;
          padding: 0;
          font-family: var(--controls-font-family);
          font-size: var(--font-size-base-400);
          flex-grow: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
          opacity: 0.8;
          color: var(--color-neutral-foreground-1);
        }

        .btn-copy {
          color: var(--color-white-alpha-70);
          font-weight: var(--font-weight-normal);
          flex-shrink: 0;
          flex-basis: 0;
          border-color: var(--color-brand-150);
          border-width: var(--stroke-width-thick);
          border-radius: var(--border-radius-x-large);
          padding: var(--spacing-xxs) var(--spacing-s);
        }
      }

      .share-dialog-icons {
        display: flex;
        align-items: center;
        gap: var(--spacing-m);
      }

      .btn-social {
        background-color: var(--color-brand-140);

        svg {
          width: var(--size-6);
          height: var(--size-6);
          fill: var(--color-brand-40);
        }
      }

      .btn-social:hover {
        background-color: var(--color-brand-150);
      }

      .btn-social:active {
        background-color: var(--color-brand-130);
      }

      @media (forced-colors: active) {
        .btn-close:hover {
            background-color: Highlight;
            color: HighlightText;
          }
        }

        .btn-copy:hover { 
          border-color: Highlight;
          color: HighlightText;
          forced-color-adjust: none;
        }

        .btn-social {
          svg {
            fill: ButtonText;
          }
        }

        .btn-social:hover {
          background-color: Highlight;
          border-color: Highlight;

          svg {
            fill: HighlightText;
          }
        }
      }
    `
];
Xe([
  $("dialog")
], ue.prototype, "dialog", 2);
Xe([
  M({ context: L, subscribe: !0 })
], ue.prototype, "playerState", 2);
ue = Xe([
  S("ump-share-dialog")
], ue);
var er = Object.defineProperty, tr = Object.getOwnPropertyDescriptor, G = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? tr(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && er(t, o, a), a;
};
let U = class extends C {
  constructor() {
    super(...arguments), this.onSeekbarPointerDown = () => {
      this.dispatchEvent(new p("seekbar-pointer-down"));
    }, this.onSeekbarPointerMove = (e) => {
      const t = e.target, o = kt(e.offsetX / t.clientWidth, 0, 1);
      t.dataset.tooltip = Ve(this.playerState.duration * o), t.style.setProperty("--tooltip-pointer-x", `${e.offsetX}px`);
    }, this.onSeekbarPointerUp = () => {
      this.dispatchEvent(new p("seekbar-pointer-up"));
    };
  }
  render() {
    const e = Zo();
    return d`<div
        class="lower-controls-area"
        @focusin=${this.onFocusIn}
        ?inert=${this.playerState.shareDialogOpened}
      >
        <ump-slider
          class="seekbar slider tooltip"
          dir="ltr"
          @pointerdown=${this.onSeekbarPointerDown}
          @pointermove=${this.onSeekbarPointerMove}
          @pointerup=${this.onSeekbarPointerUp}
          @input=${this.onSeekbarSliderChanged}
          sliderarialabel="${s("Progress Bar")}"
          sliderAriaValueText="${mt(
      this.playerState.currentTime,
      e
    )} ${s("of")} ${mt(
      this.playerState.duration,
      e
    )}"
          value=${this.playerState.currentTime}
          min="0"
          max=${this.playerState.duration}
          focusStep=${1}
          data-testid="seekbar-slider"
          .ranges=${this.playerState.buffered}
        ></ump-slider>

        <div class="buttons">
          <button
            type="button"
            class=${c({
      btn: !0,
      "btn-subtle": !0,
      "btn-icon-only": !0,
      ...u(this.playerState),
      tooltip: !0,
      "tooltip-top": !0,
      "tooltip-left": this.playerState.dir === "ltr",
      "tooltip-right": this.playerState.dir === "rtl"
    })}
            data-tooltip="${this.playerState.ended ? s("Replay") : this.playerState.paused ? s("Play") : s("Pause")}"
            aria-label="${this.playerState.ended ? s("Replay") : this.playerState.paused ? s("Play") : s("Pause")}"
            id="play-button"
            data-testid="play-button"
            @click=${this.onPlayClicked}
          >
            ${this.playerState.ended ? v(Lo) : this.playerState.paused ? v(zo) : v(Vo)}
          </button>

          <div
            data-identifier="volume-container"
            class="volume-container"
            @focusin=${this.onVolumeContainerFocusIn}
            @focusout=${this.onVolumeContainerFocusOut}
            @pointerleave=${this.onVolumeContainerPointerLeave}
          >
            <button
              type="button"
              class=${c({
      btn: !0,
      "btn-subtle": !0,
      "btn-icon-only": !0,
      ...u(this.playerState),
      tooltip: !0
    })}
              aria-label=${this.playerState.muted ? s("Unmute") : s("Mute")}
              data-testid="volume-button"
              @click=${this.onVolumeClicked}
            >
              ${this.playerState.muted ? v(Oo) : v(Fo)}
            </button>

            ${this.playerState.showVolumeSlider ? d`
                  <div class="volume-menu">
                    <div class="volume-menu-slider-container">
                      <ump-slider
                        class="volume-slider"
                        style="--ump-slide-percentage: ${this.playerState.volume * 100}%;"
                        orientation="vertical"
                        sliderarialabel="${s("Volume Level")}"
                        aria-label=${s("Volume Slider")}
                        min="0"
                        max="1"
                        focusStep=${0.01}
                        sliderAriaValueText="${(this.playerState.volume * 100).toFixed() + "%"}"
                        value=${this.playerState.volume}
                        @click=${this.onVolumeSliderClicked}
                        @input=${this.onVolumeSliderChanged}
                        @pointerup=${this.onVolumeSliderPointerUp}
                      ></ump-slider>
                      <div
                        data-tooltip=${(this.playerState.volume * 100).toFixed() + "%"}
                        style="--ump-slide-percentage: ${this.playerState.volume * 100}%;"
                        class="volume-tooltip tooltip tooltip-visible"
                      ></div>
                    </div>
                    <div class="volume-menu-spacer"></div>
                  </div>
                ` : null}
          </div>

          <div
            class=${c({
      time: !0,
      "time-right": this.playerState.dir === "rtl"
    })}
            data-testid="time"
          >
            ${Ve(this.playerState.currentTime)} /
            ${Ve(this.playerState.duration)}
          </div>

          <ump-more-menu
            @share-clicked=${this.onShareClicked}
            id="more-menu"
          ></ump-more-menu>

          <ump-audio-menu></ump-audio-menu>

          <ump-caption-menu></ump-caption-menu>

          <ump-settings-menu></ump-settings-menu>

          <button
            type="button"
            class=${c({
      btn: !0,
      "btn-subtle": !0,
      "btn-icon-only": !0,
      ...u(this.playerState),
      tooltip: !0,
      "tooltip-top": !0,
      "tooltip-left": this.playerState.dir === "rtl",
      "tooltip-right": this.playerState.dir === "ltr"
    })}
            data-tooltip=${s("Fullscreen")}
            aria-label=${s("Fullscreen")}
            data-testid="fullscreen-button"
            @click=${this.onFullScreenClicked}
          >
            ${this.playerState.fullscreen ? v(_o) : v(Po)}
          </button>
        </div>
      </div>

      <ump-share-dialog></ump-share-dialog>`;
  }
  get hasOpenControl() {
    return [
      this.audioMenu,
      this.captionMenu,
      this.settingsMenu,
      this.moreMenu,
      this.shareDialog
    ].some((e) => e.opened);
  }
  onShareClicked() {
    this.shareDialog.show(), this.dispatchEvent(new p("share-button-clicked"));
  }
  onVolumeClicked() {
    this.dispatchEvent(new p("volume-button-clicked"));
  }
  onPlayClicked() {
    this.dispatchEvent(new p("play-button-clicked"));
  }
  onVolumeSliderChanged(e) {
    const t = e.target;
    this.dispatchEvent(new p("volume-updated", t.value));
  }
  onVolumeSliderPointerUp(e) {
    const t = e.target;
    this.dispatchEvent(new p("volume-drag-released", t.value));
  }
  onVolumeContainerFocusIn() {
    this.volumeContainer.classList.add("focused");
  }
  onVolumeContainerFocusOut() {
    this.volumeContainer.classList.remove("focused");
  }
  onVolumeContainerPointerLeave() {
    this.volumeContainer.classList.remove("focused");
  }
  onVolumeSliderClicked(e) {
    e.stopPropagation();
  }
  onSeekbarSliderChanged(e) {
    const t = e.target;
    this.dispatchEvent(new p("seekbar-updated", t.value));
  }
  onFullScreenClicked() {
    this.dispatchEvent(new p("fullscreen-button-clicked"));
  }
  onFocusIn() {
    this.dispatchEvent(new p("control-bar-focus-change"));
  }
};
U.styles = [
  B,
  te,
  w`
:host{--ump-lower-controls-height:var(--size-28)}*{box-sizing:border-box;margin:0;padding:0}.controls{position:absolute;inset:0;opacity:1;visibility:visible}.controls.hidden{opacity:0;transition:opacity 1s ease-out;cursor:none}.lower-controls-area{position:absolute;bottom:0;width:100%;background:var(--color-black-alpha-70);background:linear-gradient(0deg,var(--color-black-alpha-80) 0%,var(--color-black-alpha-80) 40%,transparent 100%);height:var(--ump-lower-controls-height);display:flex;flex-direction:column;justify-content:flex-end;padding:var(--spacing-s) var(--spacing-m)}.buttons{display:flex;align-items:center;gap:var(--spacing-xs);width:100%;z-index:10}.buttons .btn.tooltip{--tooltip-gap:var(--spacing-xxxl)}.time{color:var(--color-neutral-foreground-2);flex-grow:1;-webkit-user-select:none;user-select:none;text-align:left}.time-right{text-align:right}.volume-menu{box-sizing:border-box;position:absolute;left:50%;bottom:100%;transform:translateX(-50%);z-index:100;opacity:0;transition:opacity var(--duration-faster) var(--curve-easy-ease);pointer-events:none;width:100%}.volume-container{position:relative}.volume-container:hover .volume-menu,.volume-container:focus .volume-menu,.volume-container:focus-visible .volume-menu,.volume-container.focused .volume-menu{display:block;opacity:1;pointer-events:auto}.seekbar{width:100%;height:var(--size-5)}.seekbar.slider.tooltip{--tooltip-gap:var(--spacing-s);--tooltip-width:var(--size-6);--tooltip-pointer-x:0px;--tooltip-left:clamp(calc(var(--tooltip-width) / 2),var(--tooltip-pointer-x),calc(100% - var(--tooltip-width) / 2));text-align:center}.volume-menu-slider-container{z-index:100;background-color:var(--color-grey-10-alpha-90);border-radius:var(--border-radius-large);height:var(--size-28);display:flex;justify-content:center;padding:var(--spacing-s) 0;position:relative}.volume-slider{width:var(--size-6);outline:border 1px orange}.volume-tooltip{position:absolute !important;width:100%;inset:0;margin-top:var(--size-5);margin-bottom:var(--size-5)}.volume-tooltip::before{--tooltip-top:auto;--tooltip-left:100%;--tooltip-right:auto;--tooltip-translate-x:10%;--tooltip-translate-y:50%;--tooltip-bottom:var(--ump-slide-percentage);--tooltip-width:var(--size-7);margin-left:var(--spacing-xs);text-align:center}.volume-menu-spacer{height:var(--size-8);width:100%}@media (forced-colors:active){.time{color:ButtonText}}
    `
];
G([
  $("ump-more-menu")
], U.prototype, "moreMenu", 2);
G([
  $("ump-audio-menu")
], U.prototype, "audioMenu", 2);
G([
  $("ump-caption-menu")
], U.prototype, "captionMenu", 2);
G([
  $("ump-settings-menu")
], U.prototype, "settingsMenu", 2);
G([
  $("ump-share-dialog")
], U.prototype, "shareDialog", 2);
G([
  $(".volume-container")
], U.prototype, "volumeContainer", 2);
G([
  M({ context: L, subscribe: !0 })
], U.prototype, "playerState", 2);
U = G([
  Ke(),
  S("ump-control-bar")
], U);
const Tt = ft("menu"), or = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.37 10.17a.5.5 0 0 0-.74.66l4 4.5c.19.22.52.23.72.02l10.5-10.5a.5.5 0 0 0-.7-.7L7.02 14.27l-3.65-4.1Z"/></svg>';
var rr = Object.defineProperty, ar = Object.getOwnPropertyDescriptor, K = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? ar(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && rr(t, o, a), a;
};
let A = class extends C {
  constructor() {
    super(...arguments), this.type = "normal", this.checked = !1, this.submenu = null, this.focusable = !0, this.isFocused = !1, this.onFocusIn = () => {
      this.isFocused = !0;
    }, this.onFocusOut = () => {
      this.isFocused = !1;
    };
  }
  get tabindex() {
    var e;
    return this.focusable && ((e = this.playerState) != null && e.disableKeyboardEvents || this.isFocused) ? 0 : -1;
  }
  render() {
    return d`
      <div
        class=${c({
      "menu-item": !0,
      "menu-item-checked": this.checked,
      "menu-item-radio": this.type === "radio",
      "menu-item-has-submenu": !!this.submenu && !this.isBackButton(),
      "menu-item-back-button": this.isBackButton()
    })}
      >
        <div class="menu-item-check-mark" aria-hidden="true">
          ${v(or)}
        </div>

        <div class="menu-item-chevron-left" aria-hidden="true">
          ${this.playerState.dir === "ltr" ? v(Ae) : v(De)}
        </div>

        <slot name="prefix"></slot>

        <slot></slot>

        <slot name="suffix"></slot>

        <div class="menu-item-chevron" aria-hidden="true">
          ${this.playerState.dir === "ltr" ? v(De) : v(Ae)}
        </div>
      </div>
    `;
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("focusin", this.onFocusIn), this.addEventListener("focusout", this.onFocusOut);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("focusin", this.onFocusIn), this.removeEventListener("focusout", this.onFocusOut);
  }
  isBackButton() {
    return this.submenu === z;
  }
  updated(e) {
    (e.has("type") || e.has("checked")) && this.updateAriaAttributes(), e.has("isFocused") && this.requestUpdate("tabindex");
  }
  updateAriaAttributes() {
    this.setAttribute(
      "role",
      this.type === "radio" ? "menuitemradio" : "menuitem"
    ), this.type === "radio" ? this.setAttribute("aria-checked", this.checked ? "true" : "false") : this.removeAttribute("aria-checked");
  }
  static isMenuItem(e) {
    return e instanceof HTMLElement && e.tagName.toLowerCase() === "ump-menu-item";
  }
};
A.styles = [
  w`
.menu-item{display:flex;align-items:center;justify-content:flex-start;gap:var(--spacing-s);margin:0;box-sizing:border-box;padding:var(--spacing-s) var(--spacing-xs);border-radius:var(--border-radius-medium);color:var(--color-neutral-foreground-1);font-weight:var(--font-weight-regular);line-height:var(--line-height-base-300);transition-duration:var(--duration-faster);transition-property:background,color;transition-timing-function:var(--curve-easy-ease);cursor:pointer;-webkit-user-select:none;user-select:none;background-color:transparent}.menu-item-check-mark{stroke:currentcolor;justify-content:center;align-items:center;display:none;visibility:hidden}.menu-item-radio .menu-item-check-mark{display:flex}.menu-item-checked .menu-item-check-mark{visibility:visible}.menu-item-chevron{stroke:currentcolor;visibility:hidden;display:flex;justify-content:center;align-items:center}.menu-item-has-submenu .menu-item-chevron{visibility:visible}.menu-item-chevron-left{display:none;justify-content:center;align-items:center;stroke:currentcolor}.menu-item-back-button .menu-item-chevron-left{display:flex}slot:not([name]){display:flex;align-items:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;gap:var(--spacing-s);flex-grow:1}slot[name='prefix']{flex:0 0 auto;display:flex;align-items:center;stroke:currentcolor}slot[name='prefix']::slotted(*){display:contents}slot[name='suffix']{flex:0 0 auto;display:flex;align-items:center;stroke:currentcolor}:host(:hover) .menu-item{background-color:var(--color-white-alpha-10);color:var(--color-neutral-foreground-2-hover)}:host(:active) .menu-item{background-color:var(--color-white-alpha-5);color:var(--color-neutral-foreground-2-pressed)}:host(.focus-always:focus) .menu-item,:host(.focus-default:focus-visible) .menu-item{outline:var(--stroke-width-thick) solid var(--color-stroke-focus-2);border:none}:host(.cc-style-menu-item:hover) .menu-item,:host(.cc-style-menu-item:active) .menu-item{background-color:initial}@media (forced-colors:active){.menu-item{forced-color-adjust:none;color:ButtonText}:host(:hover) .menu-item{background-color:Highlight;color:HighlightText}:host(.focus-default:focus-visible) .menu-item,:host(.cc-style-menu-item:active) .menu-item{outline:var(--stroke-width-thick) solid Highlight}:host(.cc-style-menu-item:hover) .menu-item,:host(.cc-style-menu-item:active) .menu-item{color:ButtonText}}
    `
];
K([
  I({ attribute: !0 })
], A.prototype, "type", 2);
K([
  I({ attribute: !0, type: Boolean, reflect: !0 })
], A.prototype, "checked", 2);
K([
  I({ attribute: !0, type: String })
], A.prototype, "submenu", 2);
K([
  M({ context: L, subscribe: !0 })
], A.prototype, "playerState", 2);
K([
  I({ type: Boolean })
], A.prototype, "focusable", 2);
K([
  I({ type: Number, reflect: !0 })
], A.prototype, "tabindex", 1);
K([
  I({ type: Boolean })
], A.prototype, "isFocused", 2);
A = K([
  S("ump-menu-item")
], A);
var nr = Object.defineProperty, ir = Object.getOwnPropertyDescriptor, Mt = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? ir(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && nr(t, o, a), a;
};
let Ce = class extends C {
  render() {
    return this.isActive() ? d`<slot></slot>` : null;
  }
  getMenuItems() {
    return Array.from(
      this.querySelectorAll('[role="menuitemradio"],[role="menuitem"]')
    );
  }
  isActive() {
    return !this.menuContext.history.length && !this.id ? !0 : this.menuContext.history[this.menuContext.history.length - 1] === this.id;
  }
};
Mt([
  M({ context: Tt, subscribe: !0 }),
  Te()
], Ce.prototype, "menuContext", 2);
Ce = Mt([
  S("ump-submenu")
], Ce);
var sr = Object.defineProperty, lr = Object.getOwnPropertyDescriptor, ge = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? lr(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && sr(t, o, a), a;
};
let q = class extends C {
  constructor() {
    super(...arguments), this.role = "menu", this.menuContext = {
      history: []
    };
  }
  render() {
    return d`<slot
      @click=${this.onClick}
      @keydown=${this.onKeyDown}
      data-scrollable
    ></slot>`;
  }
  async onClick(e) {
    const t = q.findSubmenuId(e.composedPath());
    t && (e.stopPropagation(), t === z ? this.pop() : this.push(t), await this.updateComplete, this.focusFirstItem());
  }
  onKeyDown(e) {
    if (!this.playerState.disableKeyboardEvents) {
      if (e.key === " " || e.key === "Enter") {
        const t = this.getActiveItem();
        t && (e.preventDefault(), e.stopPropagation(), t.click());
      } else if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Home" || e.key === "End") {
        e.preventDefault(), e.stopPropagation();
        const t = this.getMenuItems();
        let o = t.findIndex((r) => r.tabIndex === 0);
        e.key === "ArrowDown" ? o += 1 : e.key === "ArrowUp" ? o -= 1 : e.key === "Home" ? o = 0 : e.key === "End" && (o = t.length - 1), o >= t.length && (o = 0), o < 0 && (o = t.length - 1), this.setActiveIndex(o);
      }
    }
  }
  focusFirstItem() {
    this.setActiveIndex(0);
  }
  focusLastItem() {
    this.setActiveIndex(this.getMenuItems().length - 1);
  }
  /**
   * Set the index for which item should be active/focused.
   */
  setActiveIndex(e) {
    var t;
    (t = this.getMenuItems()[e]) == null || t.focus();
  }
  /**
   * Gets all menu items, ignoring dividers, headers, and other elements.
   * */
  getMenuItems() {
    const e = this.defaultSlot.assignedElements({ flatten: !0 }).filter((o) => A.isMenuItem(o));
    if (e.length)
      return e;
    const t = this.defaultSlot.assignedElements({ flatten: !0 }).find((o) => o instanceof Ce && o.isActive());
    return (t == null ? void 0 : t.getMenuItems()) ?? [];
  }
  /**
   * Gets the currently active menu item.
   * */
  getActiveItem() {
    return this.getMenuItems().find((e) => e.tabIndex === 0);
  }
  /**
   * Pops the last item from the submenu stack. Since the stack can have
   * deeply nested submenus, this method allows you to go back to the
   * previous submenu. If there are no more submenus in the stack, it will
   * render the default submenu which has no id.
   */
  pop() {
    this.menuContext = {
      ...this.menuContext,
      history: this.menuContext.history.slice(0, -1)
    };
  }
  /**
   * Push a submenu id onto the stack. This will render the submenu with the
   * given id.
   */
  push(e) {
    this.menuContext = {
      ...this.menuContext,
      history: [...this.menuContext.history, e]
    };
  }
  /**
   * Clear the submenu stack. Useful when opening/closing the popover menu component.
   */
  clearHistory() {
    this.menuContext = {
      ...this.menuContext,
      history: []
    };
  }
  static findSubmenuId(e) {
    for (const t of e)
      if (t instanceof HTMLElement) {
        const o = t.getAttribute("submenu");
        if (o)
          return o;
      }
  }
};
q.styles = [
  w`
:host{border-radius:var(--border-radius-x-large);overflow:hidden}slot{display:flex;flex-direction:column;overflow:hidden auto;border:none;padding:var(--spacing-s);background-color:var(--color-grey-10-alpha-90);box-shadow:var(--shadow-4)}@container universalmediaplayer (min-width:0){slot{max-height:calc(100cqh - var(--ump-lower-controls-height))}}@media (forced-colors:active){slot{background-color:var(--color-grey-10)}}
    `
];
ge([
  M({ context: L, subscribe: !0 })
], q.prototype, "playerState", 2);
ge([
  I({ reflect: !0 })
], q.prototype, "role", 2);
ge([
  $("slot")
], q.prototype, "defaultSlot", 2);
ge([
  qt({ context: Tt }),
  Te()
], q.prototype, "menuContext", 2);
q = ge([
  S("ump-menu")
], q);
var cr = Object.defineProperty, ur = Object.getOwnPropertyDescriptor, dr = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? ur(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && cr(t, o, a), a;
};
let Ne = class extends C {
  render() {
    return d` <slot class="footer-button" name="suffix"></slot> `;
  }
};
Ne.styles = w`
:host{display:flex;justify-content:flex-end;padding:var(--spacing-s);gap:var(--spacing-s)}:host(:focus),:host(:focus-visible){outline:none}.footer-button{display:inline-flex;border-radius:var(--border-radius-medium)}.footer-button:hover{background-color:var(--color-neutral-background-1-hover);border-color:transparent;color:var(--color-neutral-foreground-1-hover)}:host(:focus) .footer-button,:host(:focus-visible) .footer-button{outline:var(--stroke-width-thick) solid var(--color-stroke-focus-2);outline-offset:calc(var(--stroke-width-thick) * -1);border:none}@media (forced-colors:active){.footer-button{forced-color-adjust:none}}
  `;
Ne = dr([
  S("ump-menu-footer")
], Ne);
var pr = Object.defineProperty, hr = Object.getOwnPropertyDescriptor, mr = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? hr(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && pr(t, o, a), a;
};
let Ue = class extends C {
  render() {
    return d`
      <slot class="prefix-slot" name="prefix"></slot>
      <slot class="default-slot"></slot>
      <slot class="suffix-slot" name="suffix"></slot>
    `;
  }
};
Ue.styles = w`
:host{display:flex;padding:var(--spacing-s);gap:var(--spacing-s)}.default-slot{flex-grow:1;display:flex;align-items:center;justify-content:flex-start;margin:0;box-sizing:border-box;border-radius:var(--border-radius-medium);color:var(--color-neutral-foreground-1);font-weight:var(--font-weight-semibold);line-height:var(--line-height-base-300);-webkit-user-select:none;user-select:none;background-color:transparent}@media (forced-colors:active){.default-slot{color:ButtonText}}
  `;
Ue = mr([
  S("ump-menu-label")
], Ue);
const gr = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15.5 17a.5.5 0 0 1 .09 1H4.5a.5.5 0 0 1-.09-1H15.5ZM10 2a.5.5 0 0 1 .5.41V14.3l3.64-3.65a.5.5 0 0 1 .64-.06l.07.06c.17.17.2.44.06.63l-.06.07-4.5 4.5a.5.5 0 0 1-.25.14L10 16a.5.5 0 0 1-.4-.2l-4.46-4.45a.5.5 0 0 1 .64-.76l.07.06 3.65 3.64V2.5c0-.27.22-.5.5-.5Z"/></svg>', vr = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.25 10a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM15 11.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"/></svg>', br = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.35 2.15a.5.5 0 0 0-.7 0l-4.5 4.5a.5.5 0 1 0 .7.7L9.5 3.71v8.79a.5.5 0 0 0 1 0V3.7l3.65 3.65a.5.5 0 0 0 .7-.7l-4.5-4.5ZM4 9.5a.5.5 0 0 0-1 0V14a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V9.5a.5.5 0 0 0-1 0V14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9.5Z"/></svg>';
var fr = Object.defineProperty, yr = Object.getOwnPropertyDescriptor, Je = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? yr(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && fr(t, o, a), a;
};
let de = class extends C {
  render() {
    const {
      downloadableVideoFiles: e,
      downloadableTranscriptFiles: t,
      shareOptions: o
    } = this.playerState, r = t.length === 0 && e.length === 0;
    return r && o.length === 0 ? null : d`
      <ump-popup popupAriaLabel="${s("More")}">
        <button
          type="button"
          slot="trigger"
          class=${c({
      btn: !0,
      "btn-subtle": !0,
      "btn-icon-only": !0,
      ...u(this.playerState),
      tooltip: !0,
      "tooltip-disable-when-aria-expanded": !0
    })}
          data-tooltip="${s("More")}"
          aria-label="${s("More")}"
          data-id="more-menu-button"
          data-testid="more-menu-button"
        >
          ${v(vr)}
        </button>

        <ump-menu data-focusgroup>
          <!-- DEFAULT MENU -->
          <ump-submenu>
            ${!r && this.playerState.showDownloadMenu ? d`
                  <ump-menu-item
                    class=${c({ ...u(this.playerState) })}
                    submenu="download"
                    data-testid="download-menu-item"
                  >
                    <span slot="prefix">${v(gr)}</span>
                    ${s("Download")}
                  </ump-menu-item>
                ` : null}
            ${o.length > 0 ? d`
                  <ump-menu-item
                    class=${c({ ...u(this.playerState) })}
                    @click=${this.onShareClicked}
                    data-testid="share-menu-item"
                  >
                    <span slot="prefix">${v(br)}</span>
                    ${s("Share")}
                  </ump-menu-item>
                ` : null}
          </ump-submenu>

          <ump-submenu id="download">
            <ump-menu-item
              class=${c({ ...u(this.playerState) })}
              submenu="${z}"
              >${s("Download")}</ump-menu-item
            >

            <hr aria-hidden="true" />

            ${e.length > 0 ? d`<ump-menu-item
                  class=${c({ ...u(this.playerState) })}
                  submenu="download-video"
                >
                  ${s("Video")}
                </ump-menu-item>` : null}
            ${t.length > 0 ? d`<ump-menu-item
                  class=${c({ ...u(this.playerState) })}
                  submenu="download-transcript"
                >
                  ${s("Transcript")}
                </ump-menu-item>` : null}
          </ump-submenu>

          <ump-submenu id="download-video">
            <ump-menu-item
              class=${c({ ...u(this.playerState) })}
              submenu="${z}"
              >${s("Download Video")}</ump-menu-item
            >

            <hr aria-hidden="true" />

            ${e.map(
      (a) => d` <ump-menu-item
                  class=${c({ ...u(this.playerState) })}
                  @click=${this.onDownloadClicked(a)}
                >
                  ${a.locale}
                </ump-menu-item>`
    )}
          </ump-submenu>

          <ump-submenu id="download-transcript">
            <ump-menu-item
              class=${c({ ...u(this.playerState) })}
              submenu="${z}"
              >${s("Download Transcript")}</ump-menu-item
            >

            <hr aria-hidden="true" />

            ${t.map(
      (a) => d`<ump-menu-item
                  class=${c({ ...u(this.playerState) })}
                  @click=${this.onDownloadClicked(a)}
                  >${a.locale}</ump-menu-item
                >`
    )}
          </ump-submenu>
        </ump-menu>
      </ump-popup>
    `;
  }
  onShareClicked() {
    this.dispatchEvent(new p("share-clicked"));
  }
  onDownloadClicked(e) {
    return () => {
      this.dispatchEvent(new p("download-file-clicked", e));
    };
  }
  get opened() {
    var e;
    return (e = this.popup) == null ? void 0 : e.opened;
  }
};
de.styles = [
  B,
  Me,
  te,
  w`
.btn.tooltip{--tooltip-gap:var(--spacing-xxxl)}ump-popup{--ump-popup-spacing:var(--spacing-xxxl)}ump-menu{width:var(--size-64);display:block}
    `
];
Je([
  $("ump-popup")
], de.prototype, "popup", 2);
Je([
  M({ context: L, subscribe: !0 })
], de.prototype, "playerState", 2);
de = Je([
  S("ump-more-menu")
], de);
var wr = Object.defineProperty, kr = Object.getOwnPropertyDescriptor, W = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? kr(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && wr(t, o, a), a;
};
let H = class extends C {
  constructor() {
    super(...arguments), this._opened = !1, this.popupAriaLabel = "", this.documentMouseDown = (e) => {
      e.composedPath().includes(this) || this.close();
    }, this.documentKeyDown = (e) => {
      !e.composedPath().includes(this) && (e.key === " " || e.key === "Enter") && this.close();
    };
  }
  render() {
    return d`
      <div class="popup-container" @click=${this.onClick}>
        <slot
          name="trigger"
          @click=${this.onClicked}
          @keydown=${this.onKeyDown}
          @slotchange=${this.onSlotChanged}
        ></slot>

        <dialog
          class=${c({
      "ump-rtl": this.playerState.dir === "rtl"
    })}
          .open=${this._opened}
          aria-hidden="${this._opened ? "false" : "true"}"
          aria-label="${this.popupAriaLabel}"
          @keydown=${this.dialogKeyDown}
          @close=${this.close}
        >
          <slot class="popup-panel"></slot>
        </dialog>
      </div>
    `;
  }
  show() {
    this._opened = !0, this.updateAccessibleTrigger(), document.addEventListener("mousedown", this.documentMouseDown), document.addEventListener("keydown", this.documentKeyDown), this.dispatchEvent(new p("ump-popup-changed"));
  }
  close() {
    var e;
    this.dialog.close(), this._opened = !1, this.updateAccessibleTrigger(), document.removeEventListener("mousedown", this.documentMouseDown), document.removeEventListener("keydown", this.documentKeyDown), this.dispatchEvent(new p("ump-popup-changed")), (e = this.getMenu()) == null || e.clearHistory();
  }
  get opened() {
    return this._opened;
  }
  //
  // Slotted triggers can be arbitrary content, but we need to link them to the dropdown panel with `aria-haspopup` and
  // `aria-expanded`. These must be applied to the "accessible trigger" (the tabbable portion of the trigger element
  // that gets slotted in) so screen readers will understand them. The accessible trigger should be a button element.
  // We currently only support a button as a slotted trigger, but this could be expanded to support other elements in the future.
  //
  updateAccessibleTrigger() {
    const e = this.getTriggerElement();
    e.setAttribute("aria-haspopup", "true"), e.setAttribute("aria-expanded", this._opened ? "true" : "false");
  }
  focusTrigger() {
    this.getTriggerElement().focus();
  }
  getTriggerElement() {
    return this.trigger.assignedElements({ flatten: !0 })[0];
  }
  getMenu() {
    return this.popupPanel.assignedElements({ flatten: !0 }).find((e) => e.tagName.toLowerCase() === "ump-menu");
  }
  // LISTENERS
  // If a menu item was clicked, automatically close the popup. Sometimes
  // the popup menu should stay open after a click. In those cases, the
  // component should handle the click event and call `event.stopPropagation()`
  // to prevent this event from bubbling up to this listener.
  onClick(e) {
    e.composedPath().find((o) => A.isMenuItem(o)) && this.close();
  }
  onClicked() {
    this._opened ? this.close() : this.show();
  }
  onSlotChanged() {
    this.updateAccessibleTrigger();
  }
  async onKeyDown(e) {
    if (!this.playerState.disableKeyboardEvents)
      if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Home" || e.key === "End") {
        e.preventDefault(), this._opened || (this.show(), await this.updateComplete);
        const t = this.getMenu();
        if (!t)
          return;
        e.key === "ArrowUp" || e.key === "End" ? t.focusLastItem() : t.focusFirstItem();
      } else e.key === "Escape" && (this.focusTrigger(), this.close());
  }
  dialogKeyDown(e) {
    this.playerState.disableKeyboardEvents || (e.key === "Escape" || e.key === "Tab") && this._opened && (e.preventDefault(), this.close(), this.focusTrigger());
  }
};
H.styles = w`
:host{--ump-popup-spacing:var(--spacing-s)}.popup-container{position:relative}dialog{display:none;padding:0;border:none;outline:none;background-color:transparent;position:absolute;left:100%;bottom:100%;transform:translateX(-100%);margin-bottom:var(--ump-popup-spacing)}dialog.ump-rtl{transform:translateX(calc(100% - var(--spacing-xxxxl)))}dialog[open]{display:block}@container universalmediaplayer (max-width:450px){.popup-container{position:unset}dialog{bottom:15cqh;left:98cqw}}
  `;
W([
  $("dialog")
], H.prototype, "dialog", 2);
W([
  M({ context: L, subscribe: !0 })
], H.prototype, "playerState", 2);
W([
  Te()
], H.prototype, "_opened", 2);
W([
  I({ type: String })
], H.prototype, "popupAriaLabel", 2);
W([
  $('slot[name="trigger"]')
], H.prototype, "trigger", 2);
W([
  $(".popup-panel")
], H.prototype, "popupPanel", 2);
H = W([
  S("ump-popup")
], H);
const xr = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2c-.53 0-1.06.05-1.56.15a.5.5 0 0 0 .2.98 7.04 7.04 0 0 1 2.73 0 .5.5 0 0 0 .2-.98C11.05 2.05 10.52 2 10 2Zm4.45 1.35a.5.5 0 0 0-.56.83 7.04 7.04 0 0 1 1.93 1.93.5.5 0 1 0 .83-.56 8.04 8.04 0 0 0-2.2-2.2Zm-8.34.83a.5.5 0 1 0-.56-.83 8.04 8.04 0 0 0-2.2 2.2.5.5 0 1 0 .83.56A7.04 7.04 0 0 1 6.1 4.18ZM3.13 8.63a.5.5 0 0 0-.98-.2 8.04 8.04 0 0 0 0 3.13.5.5 0 0 0 .98-.2 7.04 7.04 0 0 1 0-2.73Zm14.72-.2a.5.5 0 1 0-.98.2 7.04 7.04 0 0 1 0 2.74.5.5 0 1 0 .98.2 8.03 8.03 0 0 0 0-3.13ZM4.18 13.9a.5.5 0 1 0-.83.56 8.04 8.04 0 0 0 2.2 2.2.5.5 0 1 0 .56-.83 7.04 7.04 0 0 1-1.93-1.93Zm12.47.56a.5.5 0 0 0-.83-.56 7.04 7.04 0 0 1-1.93 1.93.5.5 0 1 0 .56.83 8.04 8.04 0 0 0 2.2-2.2Zm-8.02 2.42a.5.5 0 1 0-.2.98 8.03 8.03 0 0 0 3.13 0 .5.5 0 0 0-.2-.98 7.04 7.04 0 0 1-2.73 0ZM8 7.83c0-.57.63-.94 1.13-.65l4.12 2.39a.5.5 0 0 1 0 .86l-4.12 2.39A.75.75 0 0 1 8 12.17V7.83Z"/></svg>', Er = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 3H6a3 3 0 0 0-3 3v.5a.5.5 0 0 0 1 0V6c0-1.1.9-2 2-2h2.5a.5.5 0 0 0 0-1ZM5.8 15.99A2 2 0 0 1 4 14v-3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H6l-.2-.01ZM3 14a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v3Zm10.5 3a.5.5 0 0 1 0-1h.5a2 2 0 0 0 2-2v-2.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-3 3h-.5ZM17 8.5a.5.5 0 0 1-1 0V6a2 2 0 0 0-2-2h-2.5a.5.5 0 0 1 0-1H14a3 3 0 0 1 3 3v2.5Z"/></svg>', Cr = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 8.53 8.53 0 0 1 3.55 0c.2.04.35.2.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32a1 1 0 0 0 0 1.52l1.56 1.32a.5.5 0 0 1 .15.54 8.5 8.5 0 0 1-1.78 3.08.5.5 0 0 1-.54.13l-1.92-.68a1 1 0 0 0-1.32.76l-.37 2a.5.5 0 0 1-.38.4 8.53 8.53 0 0 1-3.56 0 .5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54ZM8 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"/></svg>', $r = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 8.53 8.53 0 0 1 3.55 0c.2.04.35.2.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32a1 1 0 0 0 0 1.52l1.56 1.32a.5.5 0 0 1 .15.54 8.5 8.5 0 0 1-1.78 3.08.5.5 0 0 1-.54.13l-1.92-.68a1 1 0 0 0-1.32.76l-.37 2a.5.5 0 0 1-.38.4 8.53 8.53 0 0 1-3.56 0 .5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54Zm1.06 0 1.3 1.1a2 2 0 0 1 0 3.04l-1.3 1.1c.3.79.72 1.51 1.25 2.16l1.6-.58a2 2 0 0 1 2.63 1.53l.3 1.67a7.56 7.56 0 0 0 2.5 0l.3-1.67a2 2 0 0 1 2.64-1.53l1.6.58a7.5 7.5 0 0 0 1.24-2.16l-1.3-1.1a2 2 0 0 1 0-3.04l1.3-1.1a7.5 7.5 0 0 0-1.25-2.16l-1.6.58a2 2 0 0 1-2.63-1.53l-.3-1.67a7.55 7.55 0 0 0-2.5 0l-.3 1.67A2 2 0 0 1 5.81 5.8l-1.6-.58a7.5 7.5 0 0 0-1.24 2.16ZM7.5 10a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm1 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z"/></svg>';
var Sr = Object.defineProperty, Ir = Object.getOwnPropertyDescriptor, et = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? Ir(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && Sr(t, o, a), a;
};
let pe = class extends C {
  render() {
    var r, a;
    let e, t;
    for (const n of this.playerState.videoQualities)
      n.videoId === this.playerState.activeVideoQualityId && (e = n), n.videoId === this.playerState.selectedVideoQualityId && (t = n);
    const o = (r = this.playerState.playbackRates.find(
      (n) => n.value === this.playerState.playbackRate
    )) == null ? void 0 : r.label;
    return this.playerState.playbackRates.length < 2 && this.playerState.videoQualities.length < 2 ? null : d`
      <ump-popup
        popupAriaLabel="${s("Settings")}"
        @ump-popup-changed=${() => this.requestUpdate()}
      >
        <button
          type="button"
          slot="trigger"
          class=${c({
      btn: !0,
      "btn-subtle": !0,
      "btn-icon-only": !0,
      ...u(this.playerState),
      tooltip: !0,
      "tooltip-disable-when-aria-expanded": !0
    })}
          data-tooltip="${s("Settings")}"
          aria-label="${s("Settings")}"
          data-testid="settings-menu-button"
        >
          ${(a = this.popup) != null && a.opened ? v(Cr) : v($r)}
        </button>

        <ump-menu data-focusgroup>
          <!-- DEFAULT MENU -->
          <ump-submenu>
            ${this.playerState.playbackRates.length >= 2 ? d`
                  <ump-menu-item
                    class=${c({ ...u(this.playerState) })}
                    submenu="playbackRate"
                  >
                    <span slot="prefix">${v(xr)}</span>
                    ${s("Playback rate")}

                    <span slot="suffix">${o}</span>
                  </ump-menu-item>
                ` : null}
            ${this.playerState.showQualityMenu && this.playerState.videoQualities.length >= 2 ? d`
                  <ump-menu-item
                    class=${c({ ...u(this.playerState) })}
                    submenu="quality"
                  >
                    <span slot="prefix">${v(Er)}</span>
                    ${s("Quality")}
                    <span slot="suffix"
                      ><span class="quality-label"
                        >${t == null ? void 0 : t.label}</span
                      >
                      ${e && (t == null ? void 0 : t.videoId) === ie.videoId ? d`<span>${e.label}</span>` : null}
                    </span>
                  </ump-menu-item>
                ` : null}
          </ump-submenu>

          <!-- PLAYBACK RATE SUBMENU -->
          <ump-submenu id="playbackRate">
            <ump-menu-item
              class=${c({ ...u(this.playerState) })}
              submenu="${z}"
              >${s("Playback rate")}</ump-menu-item
            >

            <hr aria-hidden="true" />

            ${this.playerState.playbackRates.map(
      (n) => d`
                <ump-menu-item
                  class=${c({ ...u(this.playerState) })}
                  type="radio"
                  @click=${this.playbackRateClicked(n.value)}
                  .checked=${n.value === this.playerState.playbackRate}
                >
                  ${n.label}
                </ump-menu-item>
              `
    )}
          </ump-submenu>

          <!-- QUALITY SUBMENU -->
          <ump-submenu id="quality">
            <ump-menu-item
              class=${c({ ...u(this.playerState) })}
              submenu="${z}"
              >${s("Quality")}</ump-menu-item
            >

            <hr aria-hidden="true" />

            ${this.playerState.videoQualities.map(
      (n) => d`
                <ump-menu-item
                  class=${c({ ...u(this.playerState) })}
                  type="radio"
                  .checked=${n.videoId === this.playerState.selectedVideoQualityId}
                  @click=${this.onQualitySelected(n)}
                >
                  ${n.label}
                </ump-menu-item>
              `
    )}
          </ump-submenu>
        </ump-menu>
      </ump-popup>
    `;
  }
  onQualitySelected(e) {
    return () => {
      this.dispatchEvent(new p("video-quality-clicked", e)), this.dispatchEvent(new p("videoqualitychanged"));
    };
  }
  playbackRateClicked(e) {
    return () => {
      this.dispatchEvent(new p("playback-rate-clicked", e));
    };
  }
  get opened() {
    var e;
    return (e = this.popup) == null ? void 0 : e.opened;
  }
};
pe.styles = [
  B,
  Me,
  te,
  w`
.btn.tooltip{--tooltip-gap:var(--spacing-xxxl)}ump-popup{--ump-popup-spacing:var(--spacing-xxxl)}ump-menu{width:var(--size-64);display:block}.quality-label{font-weight:var(--font-weight-semibold)}
    `
];
et([
  $("ump-popup")
], pe.prototype, "popup", 2);
et([
  M({ context: L, subscribe: !0 })
], pe.prototype, "playerState", 2);
pe = et([
  S("ump-settings-menu")
], pe);
function ze(e, t, o) {
  return (o - e) / (t - e);
}
var Tr = Object.defineProperty, Mr = Object.getOwnPropertyDescriptor, D = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? Mr(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && Tr(t, o, a), a;
};
let _ = class extends C {
  constructor() {
    super(...arguments), this.min = 0, this.max = 1, this.value = 0, this.step = 5e-3, this.focusStep = 1, this.orientation = "horizontal", this.sliderarialabel = "", this.sliderAriaValueText = "", this.ranges = [], this.onInputChange = (e) => {
      this.value = Number(e.target.value);
    }, this.onInputFocusIn = (e) => {
      const t = e.target;
      t.matches(":focus-visible") && (t.step = this.focusStep.toString());
    }, this.onInputFocusOut = (e) => {
      const t = e.target;
      t.step = this.step.toString();
    };
  }
  render() {
    return d`
      <!-- Track -->
      <div aria-hidden="true" aria-busy="false" value="0" class="track"></div>

      <!-- Ranges -->
      ${this.ranges.map(
      (e) => d`
          <div
            data-testid="ump-slider-range"
            class="range"
            style="width: ${ze(
        this.min,
        this.max,
        e.end - e.start
      ) * 100}%; left: ${ze(this.min, this.max, e.start) * 100}%"
          ></div>
        `
    )}

      <!-- Progress -->
      <div aria-hidden="true" aria-busy="false" class="progress"></div>

      <!-- Thumb -->
      <div class="thumb"></div>

      <!-- HTML Input Range -->
      <input
        class=${c({
      ...u(this.playerState),
      input: !0
    })}
        data-testid="ump-slider"
        type="range"
        min="${this.min}"
        max="${this.max}"
        step="${this.step}"
        aria-label="${this.sliderarialabel}"
        aria-live="polite"
        aria-orientation="${this.orientation}"
        aria-valuetext="${this.sliderAriaValueText}"
        @input=${this.onInputChange}
        @focusin=${this.onInputFocusIn}
        @focusout=${this.onInputFocusOut}
      />
    `;
  }
  /**
   * Keep the progress element in sync with the input element.
   */
  updated(e) {
    e.has("value") && (this.inputElement.value = this.value.toString()), (e.has("value") || e.has("min") || e.has("max")) && this.updateSliderThumb();
  }
  updateSliderThumb() {
    const e = ze(this.min, this.max, this.value);
    this.style.setProperty("--ump-slide-percentage", `${e * 100}%`);
  }
};
_.styles = [
  w`
:host{--ump-slider-track-thickness:var(--size-1);--ump-slider-track-color:var(--color-white-alpha-40);--ump-slider-thumb-inline-size:var(--size-5);--ump-slider-thumb-block-size:var(--size-3);--ump-half-slider-thumb-inline-size:calc(var(--ump-slider-thumb-inline-size) / 2);--ump-half-slider-thumb-block-size:calc(var(--ump-slider-thumb-block-size) / 2);--ump-slider-thumb-color:var(--color-neutral-foreground-1);--ump-slider-progress-color:var(--color-neutral-foreground-1);--ump-slider-range-color:var(--color-white-alpha-30);--ump-slide-percentage:0%;--ump-slider-padding:var(--spacing-xs);position:relative;display:block;writing-mode:horizontal-tb;z-index:10}:host(:hover){--ump-slider-thumb-transform:scale(1);--ump-slider-track-thickness:var(--size-1-5)}:host([orientation='vertical']){writing-mode:vertical-lr;direction:rtl;-webkit-appearance:none;appearance:none}*{box-sizing:border-box;margin:0;padding:0}.input{-webkit-appearance:none;appearance:none;background:transparent;display:block;cursor:pointer;border-radius:var(--border-radius-medium);color:var(--color-neutral-foreground-1);padding-block:var(--ump-slider-padding);position:absolute;inset:0}.input::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;block-size:var(--ump-slider-thumb-block-size);inline-size:var(--ump-slider-thumb-inline-size);border-radius:var(--border-radius-circular);background-color:transparent}.input::-moz-range-thumb{appearance:none;background-color:transparent;border:none;block-size:var(--ump-slider-thumb-block-size);inline-size:var(--ump-slider-thumb-inline-size)}.input.focus-always:focus,.input.focus-default:focus-visible{outline:var(--stroke-width-thick) solid var(--color-stroke-focus-2)}.thumb{pointer-events:none;position:absolute;inset:0;display:grid;align-items:center;margin-inline:var(--ump-half-slider-thumb-inline-size) var(--ump-half-slider-thumb-inline-size)}.thumb::after{position:absolute;z-index:50;inline-size:var(--ump-slider-thumb-inline-size);block-size:var(--ump-slider-thumb-block-size);margin-inline-start:calc(var(--ump-slide-percentage) - var(--ump-half-slider-thumb-inline-size));margin-block-start:self-block;background-color:var(--ump-slider-thumb-color);border-radius:var(--border-radius-circular);transform:var(--ump-slider-thumb-transform);display:block;transition:transform var(--duration-faster) var(--curve-easy-ease);transform-origin:center;content:''}.track{z-index:10;position:absolute;inset:0;overflow:hidden;pointer-events:none;display:flex;align-items:center}.track::before{content:'';background-color:var(--ump-slider-track-color);inline-size:100%;block-size:var(--ump-slider-track-thickness);position:absolute;border-radius:var(--border-radius-circular);transition:block-size var(--duration-faster) var(--curve-easy-ease)}.range{position:absolute;background-color:var(--ump-slider-range-color);height:var(--ump-slider-track-thickness);width:0;pointer-events:none;z-index:20;top:50%;transform:translateY(-50%);border-radius:var(--border-radius-circular);transition:height var(--duration-faster) var(--curve-easy-ease)}.progress{position:absolute;z-index:40;inset:0;display:flex;align-items:center;margin-inline:var(--ump-half-slider-thumb-inline-size);pointer-events:none}.progress::before{content:'';position:absolute;display:block;block-size:var(--ump-slider-track-thickness);inline-size:var(--ump-slide-percentage);background:var(--ump-slider-progress-color);transition:block-size var(--duration-faster) var(--curve-easy-ease)}.progress::after{content:'';position:absolute;display:block;block-size:var(--ump-slider-track-thickness);inline-size:var(--ump-half-slider-thumb-inline-size);margin-inline-start:calc(-1 * var(--ump-half-slider-thumb-inline-size));border-start-start-radius:var(--border-radius-circular);border-end-start-radius:var(--border-radius-circular);background:var(--ump-slider-progress-color);transition:block-size var(--duration-faster) var(--curve-easy-ease)}@media (forced-colors:active){:host{--ump-slider-track-color:ButtonText;--ump-slider-progress-color:Highlight}.thumb::after{background:Highlight}}
    `
];
D([
  I({ type: Number, attribute: !0 })
], _.prototype, "min", 2);
D([
  I({ type: Number, attribute: !0 })
], _.prototype, "max", 2);
D([
  I({ type: Number, attribute: !0, reflect: !0 })
], _.prototype, "value", 2);
D([
  I({ type: Number, attribute: !0 })
], _.prototype, "step", 2);
D([
  I({ type: Number, attribute: !0 })
], _.prototype, "focusStep", 2);
D([
  I({ type: String, attribute: !0 })
], _.prototype, "orientation", 2);
D([
  I({ type: String, attribute: !0 })
], _.prototype, "sliderarialabel", 2);
D([
  I({ type: String, attribute: !0 })
], _.prototype, "sliderAriaValueText", 2);
D([
  I({ type: Array })
], _.prototype, "ranges", 2);
D([
  $("input")
], _.prototype, "inputElement", 2);
D([
  M({ context: L, subscribe: !0 })
], _.prototype, "playerState", 2);
_ = D([
  S("ump-slider")
], _);
var Lr = Object.defineProperty, Pr = Object.getOwnPropertyDescriptor, oe = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? Pr(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && Lr(t, o, a), a;
};
let j = class extends C {
  constructor() {
    super(...arguments), this.userActive = !0;
  }
  render() {
    var e;
    return d`<div
      class="controls-wrapper"
      data-testid="controls-wrapper"
      tabindex=${!this.playerState.disableKeyboardEvents && this.playerState.controlsState !== "bigplaybutton" ? "0" : ""}
      @keydown=${this.onControlsWrapperKeyDown}
    >
      <div
        class=${c({
      controls: !0,
      loading: this.playerState.loading,
      hidden: this.userActive === !1 && this.playerState.paused === !1 && (this.playerState.controlsState === "bigplaybutton" || ((e = this.controlBar) == null ? void 0 : e.hasOpenControl) === !1)
    })}
        data-testid="controls"
        @pointermove=${this.onUserInteraction}
        @control-bar-focus-change=${this.onUserInteraction}
        @input=${this.onUserInteraction}
        @keydown=${this.onUserInteraction}
        @mousedown=${this.onControlsMouseDown}
        @touchstart=${this.onControlsTouchStart}
      >
        <div
          class=${c({
      overlay: !0,
      mask20: this.playerState.maskLevel === 20,
      mask40: this.playerState.maskLevel === 40,
      mask60: this.playerState.maskLevel === 60,
      mask80: this.playerState.maskLevel === 80,
      mask100: this.playerState.maskLevel === 100
    })}
          data-testid="mask-level-overlay"
        ></div>
        ${this.renderControls()}
      </div>
    </div>`;
  }
  renderControls() {
    if (this.playerState.controlsState === "bigplaybutton")
      return d`<ump-big-play-button></ump-big-play-button>`;
    if (this.playerState.controlsState === "controlbar")
      return d`<ump-control-bar></ump-control-bar>`;
  }
  onUserInteraction() {
    this.userActive = !0, this.userInteractionTimeout && clearTimeout(this.userInteractionTimeout), this.userInteractionTimeout = setTimeout(() => {
      this.userActive = !1;
    }, co);
  }
  onControlsMouseDown(e) {
    e.target === this.controlsContainer && e.button === 0 && this.dispatchEvent(new p("controls-triggered")), this.onUserInteraction();
  }
  // When the user touches the controls, we want to show the controls
  // so they can see the playback controls and then take action as they
  // see fit. This is especially important on touch devices where the
  // controls are hidden and there is no way to show them without
  // interacting with the controls.
  onControlsTouchStart(e) {
    e.target === this.controlsContainer && (e.preventDefault(), e.stopPropagation(), this.userActive && this.dispatchEvent(new p("controls-triggered")), this.onUserInteraction());
  }
  onControlsWrapperKeyDown(e) {
    this.playerState.disableKeyboardEvents || e.target !== this.controlsWrapper || (e.key === "Enter" || e.key === " ") && (e.preventDefault(), this.dispatchEvent(new p("controls-triggered")));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.userInteractionTimeout && clearTimeout(this.userInteractionTimeout);
  }
};
j.shadowRootOptions = {
  ...C.shadowRootOptions,
  delegatesFocus: !0
};
j.styles = w`
.controls-wrapper{position:absolute;inset:0}.controls-wrapper:focus-visible{outline:none;box-shadow:inset 0 0 0 var(--stroke-width-thick) var(--color-stroke-focus-2);border-radius:var(--border-radius,0)}.controls{position:absolute;inset:0;opacity:1;visibility:visible}.controls.hidden{opacity:0;transition:opacity 1s ease-out;cursor:none}.overlay{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:-1}.overlay.mask20{background:var(--color-black-alpha-20)}.overlay.mask40{background:var(--color-black-alpha-40)}.overlay.mask60{background:var(--color-black-alpha-60)}.overlay.mask80{background:var(--color-black-alpha-80)}.overlay.mask100{background:var(--color-black)}ump-big-play-button{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.controls.loading ump-big-play-button{opacity:0}
  `;
oe([
  $(".controls-wrapper")
], j.prototype, "controlsWrapper", 2);
oe([
  $(".controls")
], j.prototype, "controlsContainer", 2);
oe([
  $("ump-control-bar")
], j.prototype, "controlBar", 2);
oe([
  M({ context: L, subscribe: !0 })
], j.prototype, "playerState", 2);
oe([
  Te()
], j.prototype, "userActive", 2);
j = oe([
  Ke(),
  S("ump-controls")
], j);
function _r(e, t, o, r) {
  return e.addEventListener(t, o, r), () => e.removeEventListener(t, o);
}
function he(e) {
  const t = [];
  return {
    addEventListener(o, r, a) {
      const n = _r(e, o, r, a);
      t.push(n);
    },
    removeAllListeners() {
      t.forEach((o) => o());
    }
  };
}
function Vr(e, t) {
  return (o) => {
    const r = he(e);
    r.addEventListener(
      "big-play-button-triggered",
      k
    ), r.addEventListener("play-button-clicked", x), r.addEventListener("volume-button-clicked", E), r.addEventListener("fullscreen-button-clicked", P), r.addEventListener("seekbar-updated", l), r.addEventListener("volume-updated", g), r.addEventListener("volume-drag-released", m), r.addEventListener("audio-track-clicked", N), r.addEventListener("video-quality-clicked", f), r.addEventListener("caption-track-clicked", fe), r.addEventListener("playback-rate-clicked", Zt), r.addEventListener("controls-triggered", F), r.addEventListener("seekbar-pointer-down", i), r.addEventListener("seekbar-pointer-up", h), r.addEventListener(
      "caption-font-size-clicked",
      J
    ), r.addEventListener(
      "caption-text-color-clicked",
      Rt
    ), r.addEventListener(
      "caption-text-opacity-clicked",
      Nt
    ), r.addEventListener(
      "caption-background-color-clicked",
      Ut
    ), r.addEventListener(
      "caption-background-opacity-clicked",
      Bt
    ), r.addEventListener(
      "caption-font-family-clicked",
      Ht
    ), r.addEventListener(
      "caption-text-edge-style-clicked",
      jt
    ), o.options.hideControls == null && o.addEventListener(
      "play",
      () => {
        a("controlbar");
      },
      { once: !0 }
    ), o.options.autoplay || a("bigplaybutton"), o.options.hideControls === "controlbar" && a("bigplaybutton"), o.options.hideControls === "all" && a("none"), t.setValue({
      ...t.value,
      playButtonSize: o.options.playButtonSize,
      playButtonTheme: o.options.playButtonTheme
    }), t.setValue({
      ...t.value,
      maskLevel: o.options.maskLevel
    }), o.options.maskLevel !== 0 && o.addEventListener(
      "play",
      () => {
        t.setValue({
          ...t.value,
          maskLevel: 0
        });
      },
      { once: !0 }
    );
    function a(b) {
      t.setValue({
        ...t.value,
        controlsState: b
      });
    }
    let n = !1;
    function i() {
      n = o.paused, o.pause();
    }
    function l(b) {
      o.currentTime = b.detail;
    }
    function h() {
      n || o.play();
    }
    function k() {
      var b, at;
      if (t.setValue({
        ...t.value,
        bigPlayButtonClicked: !0
      }), X(), o.options.hideControls !== "all" && o.options.hideControls !== "controlbar") {
        const ee = e.renderRoot.querySelector("video");
        ee && ee.setAttribute("tabindex", "-1");
      }
      if (!t.value.disableKeyboardEvents && o.options.hideControls !== "all" && o.options.hideControls !== "controlbar") {
        const ee = (at = (b = e.renderRoot.querySelector("ump-controls")) == null ? void 0 : b.renderRoot) == null ? void 0 : at.querySelector(".controls-wrapper");
        ee && (ee.tabIndex = 0, ee.focus());
      }
    }
    function x() {
      X();
    }
    function E() {
      o.muted = !o.muted;
    }
    function g(b) {
      o.volume = b.detail;
    }
    function m(b) {
      o.saveLastSelectedVolume(b.detail);
    }
    function P() {
      o.fullscreen ? o.exitFullscreen() : o.requestFullscreen(e);
    }
    function N(b) {
      o.audioTrack = b.detail;
    }
    function f(b) {
      o.selectVideoQuality(b.detail);
    }
    function F() {
      X();
    }
    function X() {
      o.ended ? (o.dispatchEvent(new y.util.FakeEvent("replay")), o.play()) : o.paused ? (o.currentTime === 0 && o.dispatchEvent(new y.util.FakeEvent("umpplay")), o.currentTime !== 0 && o.dispatchEvent(new y.util.FakeEvent("resume")), o.play()) : (o.dispatchEvent(new y.util.FakeEvent("umppause")), o.pause());
    }
    function fe(b) {
      t.setValue({
        ...t.value,
        captionSettings: {
          ...t.value.captionSettings,
          enabled: b.detail.captionId !== -1
        }
      }), o.captionTrack = b.detail;
    }
    function J(b) {
      t.setValue({
        ...t.value,
        captionSettings: {
          ...t.value.captionSettings,
          fontScale: b.detail
        }
      });
    }
    function Rt(b) {
      t.setValue({
        ...t.value,
        captionSettings: {
          ...t.value.captionSettings,
          textColor: b.detail
        }
      });
    }
    function Nt(b) {
      t.setValue({
        ...t.value,
        captionSettings: {
          ...t.value.captionSettings,
          textOpacity: b.detail
        }
      });
    }
    function Ut(b) {
      t.setValue({
        ...t.value,
        captionSettings: {
          ...t.value.captionSettings,
          backgroundColor: b.detail
        }
      });
    }
    function Bt(b) {
      t.setValue({
        ...t.value,
        captionSettings: {
          ...t.value.captionSettings,
          backgroundOpacity: b.detail
        }
      });
    }
    function Ht(b) {
      t.setValue({
        ...t.value,
        captionSettings: {
          ...t.value.captionSettings,
          fontFamily: b.detail
        }
      });
    }
    function jt(b) {
      t.setValue({
        ...t.value,
        captionSettings: {
          ...t.value.captionSettings,
          textShadow: b.detail
        }
      });
    }
    function Zt(b) {
      o.playbackRate = b.detail;
    }
    return () => {
      r.removeAllListeners();
    };
  };
}
const zr = "";
var re = /* @__PURE__ */ ((e) => (e.PlayerLoadDurationMs = "playerLoadDurationMs", e.BufferDurationMs = "bufferDurationMs", e.InitialPlaybackStartDurationMs = "initialPlaybackStartDurationMs", e.PosterImageLoadDurationMs = "posterImageLoadDurationMs", e))(re || {}), V = /* @__PURE__ */ ((e) => (e.BufferComplete = "BufferComplete", e.CommonPlayerImpression = "CommonPlayerImpression", e.ContentCheckpoint = "ContentCheckpoint", e.ContentComplete = "ContentComplete", e.ContentError = "ContentError", e.FullScreenEnter = "FullScreenEnter", e.FullScreenExit = "FullScreenExit", e.InviewEnter = "InviewEnter", e.InviewExit = "InviewExit", e.Mute = "Mute", e.Pause = "Pause", e.Play = "Play", e.PlayerError = "PlayerError", e.Replay = "Replay", e.Resume = "Resume", e.Seek = "Seek", e.Unmute = "Unmute", e.VideoAudioTrackControl = "VideoAudioTrackControl", e.VideoPlayerClick = "VideoPlayerClick", e))(V || {});
class Lt {
  /**
   * @constructor
   * @description Constructor for the report class.
   * @public
   * @param player Video.js player
   * @param playerInfo information on the player
   * @param isDebugMode prints to console.log if in debug mode.
   * @param name the name of the reporter
   */
  constructor(t, o, r, a = !1, n) {
    this.reporterName = "Reporter", this._playerInfo = t, this._player = o, this._playerStateContext = r, this._isDebugMode = a, n && (this.reporterName = n);
  }
  /**
   * @name log
   * @description log a debug message on console.
   * @protected
   * @returns {void}
   */
  log(t) {
    this._isDebugMode && console.log(JSON.stringify(t), this.reporterName);
  }
  get playerInfo() {
    return this._playerInfo;
  }
  set playerInfo(t) {
    this._playerInfo = t;
  }
  /**
   * Report a metric without a value
   * @param name Name of the metric
   * @param additionalData
   */
  reportNominalMetric(t, o) {
    if (this.shouldEmitNominalMetric(t)) {
      const r = this.formatNominalMetric(
        t,
        this.getBaseTelemetryData(),
        o
      );
      this.log(r), this.emitTelemetry(r);
    }
  }
  /**
   * Reports a metric with a value
   * @param name Name of the metric
   * @param value Value of the metric
   */
  reportNumericMetric(t, o) {
    if (this.shouldEmitNumericMetric(t)) {
      const r = this.formatNumericMetric(
        t,
        o,
        this.getBaseTelemetryData()
      );
      this.log(r), this.emitTelemetry(r);
    }
  }
  /**
   * Reports an error
   * @param errorDetails Details for the error
   */
  reportError(t) {
    if (this.shouldEmitError(t.errorType)) {
      const o = this.formatError(
        t,
        this.getBaseTelemetryData()
      );
      this.log(o), this.emitTelemetry(o);
    }
  }
  getBaseTelemetryData() {
    var t;
    return {
      deliveryMethod: this._playerInfo.deliveryMethod,
      playerInstanceId: this._playerInfo.playerInstanceId,
      playerCommit: this._playerInfo.playerCommit,
      playerVersionNumber: this._playerInfo.playerVersionNumber,
      playerUrl: this._playerInfo.playerUrl,
      title: this._playerInfo.title,
      videoId: this._playerInfo.videoId,
      videoElapsedTime: this._player.currentTime,
      videoDuration: this._player.duration,
      language: this._player.options.language,
      playerState: {
        autoplay: (t = this._player) == null ? void 0 : t.autoplay,
        // Our contract with authors is that they can only specify true/false for these values.
        muted: this._player.muted,
        loop: this._player.loop,
        visible: this._playerStateContext.value.visible
      }
    };
  }
}
class Fr extends Lt {
  constructor(t, o, r, a = !1) {
    super(
      t,
      o,
      r,
      a,
      "AppInsightsReporter"
    ), this.hasEmittedFirstNonUmpMessage = !1, this.playerTech = "shaka", this.formatNominalMetric = () => {
      throw new Error("Unsupported by AppInsights reporter.");
    }, this.shouldEmitNominalMetric = () => !1, this.shouldEmitNumericMetric = (n) => Object.values(re).includes(n), this.shouldEmitError = () => !0, this.isException = (n) => n.exception !== void 0;
    try {
      this._appInsights = this.initAppInsights();
    } catch (n) {
      a && console.error("Error Initializing AppInsights.", n);
    }
    this.contextProvider = r;
  }
  initAppInsights() {
    const t = new oo({
      config: {
        connectionString: "InstrumentationKey=81bc6725-8164-4f38-93f8-ea681394304b;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=ef77fed2-4fcc-4568-aed4-b87c867a1e21",
        disableAjaxTracking: !0,
        disableExceptionTracking: !0,
        disableFetchTracking: !0,
        disableCorrelationHeaders: !0,
        disableCookiesUsage: !0
      }
    });
    return t.loadAppInsights(), t.addTelemetryInitializer(this.telemetryInitializer.bind(this)), t;
  }
  telemetryInitializer(t) {
    var o;
    return t.baseData = t.baseData || {}, t.baseData.properties = {
      ...t.baseData.properties,
      deliveryMethod: this._playerInfo.deliveryMethod,
      playerInstanceId: this._playerInfo.playerInstanceId,
      playerVersionNumber: this._playerInfo.playerVersionNumber,
      uri: window.location.href,
      partnerName: this._playerInfo.partnerName,
      playerTech: this.playerTech,
      playerVisible: (o = this.contextProvider.value) == null ? void 0 : o.visible
    }, document.referrer && document.referrer !== window.location.href && (t.baseData.properties.referrer = document.referrer), t.baseData.properties.ump ? (delete t.baseData.properties.ump, !0) : (t.baseData.properties.nonump = !0, this.hasEmittedFirstNonUmpMessage ? !1 : (this.hasEmittedFirstNonUmpMessage = !0, !0));
  }
  emitTelemetry(t) {
    var o, r;
    this.isException(t) ? (o = this._appInsights) == null || o.trackException(t) : (r = this._appInsights) == null || r.trackMetric({
      name: t.name,
      average: t.average,
      properties: t.properties
    });
  }
  formatNumericMetric(t, o, r) {
    return {
      name: t,
      average: o,
      properties: {
        playerUrl: r.playerUrl,
        language: r.language,
        ump: !0
      }
    };
  }
  formatError(t, o) {
    return {
      exception: Object.assign(new Error(t.errorDescription), {
        name: t.errorType
      }),
      properties: {
        playerUrl: o.playerUrl,
        language: o.language,
        errorMessage: t.errorDescription,
        ump: !0
      }
    };
  }
}
var T = /* @__PURE__ */ ((e) => (e[e.VideoSeen = 239] = "VideoSeen", e[e.VideoStart = 240] = "VideoStart", e[e.VideoPause = 241] = "VideoPause", e[e.VideoContinue = 242] = "VideoContinue", e[e.VideoCheckpoint = 243] = "VideoCheckpoint", e[e.VideoJump = 244] = "VideoJump", e[e.VideoComplete = 245] = "VideoComplete", e[e.VideoBuffering = 246] = "VideoBuffering", e[e.VideoError = 247] = "VideoError", e[e.VideoMute = 248] = "VideoMute", e[e.VideoUnmute = 249] = "VideoUnmute", e[e.VideoFullscreen = 250] = "VideoFullscreen", e[e.VideoUnfullscreen = 251] = "VideoUnfullscreen", e[e.VideoReplay = 252] = "VideoReplay", e[e.VideoPlayerLoad = 253] = "VideoPlayerLoad", e[e.VideoPlayerClick = 254] = "VideoPlayerClick", e[e.VideoVolumeControl = 255] = "VideoVolumeControl", e[e.VideoAudioTrackControl = 256] = "VideoAudioTrackControl", e[e.VideoClosedCaptionControl = 257] = "VideoClosedCaptionControl", e[e.VideoClosedCaptionStyle = 258] = "VideoClosedCaptionStyle", e[e.VideoResolutionControl = 259] = "VideoResolutionControl", e[e.VideoUndefinedEvent = 0] = "VideoUndefinedEvent", e))(T || {});
const gt = {
  243: {
    actionType: "A",
    telemetryMethodType: "capturePageAction"
  },
  245: {
    actionType: "A",
    telemetryMethodType: "capturePageAction"
  },
  246: {
    actionType: "A",
    telemetryMethodType: "captureContentUpdate"
  },
  253: {
    actionType: "A",
    telemetryMethodType: "captureContentUpdate"
  },
  239: {
    actionType: "O",
    telemetryMethodType: "captureContentUpdate"
  },
  0: {
    actionType: "O",
    telemetryMethodType: "captureContentUpdate"
  },
  247: {
    actionType: "O",
    telemetryMethodType: "captureContentUpdate"
  },
  252: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  240: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  241: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  242: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  244: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  248: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  249: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  250: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  251: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  254: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  255: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  256: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  257: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  258: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  },
  259: {
    actionType: "CL",
    telemetryMethodType: "capturePageAction"
  }
}, Fe = {
  BufferComplete: T.VideoBuffering,
  CommonPlayerImpression: T.VideoPlayerLoad,
  ContentCheckpoint: T.VideoCheckpoint,
  ContentComplete: T.VideoComplete,
  ContentError: T.VideoError,
  FullScreenEnter: T.VideoFullscreen,
  FullScreenExit: T.VideoUnfullscreen,
  InviewEnter: T.VideoSeen,
  Mute: T.VideoMute,
  Pause: T.VideoPause,
  Play: T.VideoStart,
  PlayerError: T.VideoError,
  Replay: T.VideoReplay,
  Resume: T.VideoContinue,
  Seek: T.VideoJump,
  Unmute: T.VideoUnmute,
  VideoAudioTrackControl: T.VideoAudioTrackControl,
  VideoPlayerClick: T.VideoPlayerClick
};
class Or extends Lt {
  constructor(t, o, r, a = !1) {
    super(t, o, r, a, "MartechReporter"), this.formatNominalMetric = (n, i, l) => {
      const h = Fe[n], k = gt[h];
      return {
        actionType: k == null ? void 0 : k.actionType,
        behavior: h,
        contentTags: {
          ...this.createContentTags(i),
          additionalData: l
        }
      };
    }, this.formatNumericMetric = () => {
      throw new Error("Unsupported by Martech reporter.");
    }, this.formatError = (n, i) => ({
      actionType: "O",
      behavior: Fe.ContentError,
      contentTags: {
        ...this.createContentTags(i),
        errorDetails: n
      }
    }), this.shouldEmitNominalMetric = (n) => Fe[n] !== void 0, this.shouldEmitNumericMetric = () => !1, this.shouldEmitError = () => !0, this.createContentTags = (n) => ({
      playerInstanceId: n.playerInstanceId,
      containerName: "Universal Media Player",
      compnm: "Universal Media Player",
      vidnm: n.title,
      // Video Title
      vidid: n.videoId,
      // Video ID
      vidpct: Math.round(n.videoElapsedTime / n.videoDuration * 100),
      // Video Percent Complete
      viddur: Math.round(n.videoDuration),
      // Video Duration
      vidwt: Math.round(n.videoElapsedTime),
      // Video Watch Time
      playerState: n.playerState
    });
  }
  emitTelemetry(t) {
    var n, i, l, h;
    const o = window.owap, r = window.awa, { telemetryMethodType: a } = gt[t.behavior];
    (n = o == null ? void 0 : o.isInitialized) != null && n.call(o) ? (i = o == null ? void 0 : o[a]) == null || i.call(o, null, t) : (r == null ? void 0 : r.isInitialized) === !0 && ((h = (l = r == null ? void 0 : r.ct) == null ? void 0 : l[a]) == null || h.call(l, null, t));
  }
}
class Ar {
  constructor(t, o, r, a, n = !1) {
    this._playerInfo = {}, this.reporters = [], a && this.reporters.push(
      new Or(t, o, r, n)
    ), this.sampleInstance() && this.reporters.push(
      new Fr(
        t,
        o,
        r,
        n
      )
    ), this.playerInfo = t;
  }
  get playerInfo() {
    return this._playerInfo;
  }
  set playerInfo(t) {
    this._playerInfo = t, t.partnerName || console.warn(
      '"partnerName" is undefined and must be provided to the video player options.'
    ), this.reporters.forEach((o) => o.playerInfo = t);
  }
  sampleInstance() {
    return Math.random() * 100 < 1;
  }
  reportNominalMetric(t, o) {
    this.reporters.forEach(
      (r) => r.reportNominalMetric(t, o)
    );
  }
  reportNumericMetric(t, o) {
    this.reporters.forEach(
      (r) => r.reportNumericMetric(t, o)
    );
  }
  reportError(t) {
    this.reporters.forEach((o) => o.reportError(t));
  }
}
function Dr(e, t, o) {
  const r = (a) => {
    Rr(a, t, o);
  };
  return e.addEventListener("error", r), t.addEventListener("error", r), () => {
    e.removeEventListener("error", r), t.removeEventListener("error", r);
  };
}
function Rr(e, t, o) {
  if (t.dispatchEvent(new p("playererror")), e instanceof y.util.FakeEvent) {
    const r = e.detail;
    r.umpErrorType ? o.reportError({
      errorType: r.umpErrorType,
      errorDescription: r.umpErrorDescription
    }) : o.reportError({
      errorType: `Shaka Error: ${r.code}. Severity: ${r.severity}`,
      errorDescription: `${r.category}: ${r.data.toString()}`
    });
  } else
    o.reportError({
      errorType: "unknown error event",
      errorDescription: "unknown error event"
    });
}
function Nr(e, t, o) {
  Hr(e, o), Ur(e, o), Br(e, o), jr(e, o), Zr(e, t, o), qr(e, t, o), Xr(e, o), Gr(e, t, o), Jr(e, t, o), Kr(e, o), Qr(e, o), Yr(e, o), Wr(e, t, o), ea(t, o);
}
function Ur(e, t) {
  e.addEventListener(
    "play",
    () => {
      const o = performance.now();
      e.addEventListener(
        "playing",
        () => {
          t.reportNumericMetric(
            re.InitialPlaybackStartDurationMs,
            performance.now() - o
          );
        },
        { once: !0 }
      );
    },
    { once: !0 }
  );
}
function Br(e, t) {
  e.addEventListener(
    "umpplay",
    () => {
      t.reportNominalMetric(V.Play);
    },
    { once: !0 }
  );
}
function Hr(e, t) {
  e.addEventListener(
    "ended",
    () => {
      t.reportNominalMetric(V.ContentComplete);
    },
    { once: !0 }
  );
}
function jr(e, t) {
  e.addEventListener("umppause", () => {
    t.reportNominalMetric(V.Pause);
  });
}
function Zr(e, t, o) {
  e.addEventListener("resume", () => {
    t.dispatchEvent(new p("resume")), o.reportNominalMetric(V.Resume);
  });
}
function qr(e, t, o) {
  e.addEventListener("replay", () => {
    t.dispatchEvent(new p("replay")), o.reportNominalMetric(V.Replay);
  });
}
function Gr(e, t, o) {
  let r;
  e.addEventListener("buffering", (a) => {
    a.buffering ? (t.dispatchEvent(new p("buffering")), r = performance.now()) : (o.reportNominalMetric(V.BufferComplete), o.reportNumericMetric(
      re.BufferDurationMs,
      performance.now() - r
    ));
  });
}
function Kr(e, t) {
  e.addEventListener("fullscreenchanged", () => {
    e.fullscreen ? t.reportNominalMetric(V.FullScreenEnter) : t.reportNominalMetric(V.FullScreenExit);
  });
}
function Qr(e, t) {
  e.addEventListener("playerloadmediastart", () => {
    const o = performance.now();
    e.addEventListener("playerloadmediaend", () => {
      t.reportNumericMetric(
        re.PlayerLoadDurationMs,
        performance.now() - o
      );
    });
  });
}
function Yr(e, t) {
  const o = performance.now();
  e.addEventListener(
    "playerposterloadcomplete",
    () => {
      t.reportNumericMetric(
        re.PosterImageLoadDurationMs,
        performance.now() - o
      );
    },
    { once: !0 }
  );
}
function Wr(e, t, o) {
  const r = [0.25, 0.5, 0.75], a = e.options.checkpoints.filter((n) => n >= 0 && n <= 1).sort((n, i) => n - i);
  e.addEventListener("timeupdate", () => {
    const n = e.currentTime / e.duration;
    for (; r.length > 0 && n >= r[0]; )
      r.shift(), o.reportNominalMetric(V.ContentCheckpoint);
    for (; a.length > 0 && n >= a[0]; )
      a.shift(), t.dispatchEvent(new p("checkpoint"));
  });
}
function Xr(e, t) {
  e.addEventListener("seeked", () => {
    (e.currentTime >= 0.2 || e.currentTime === 0) && t.reportNominalMetric(V.Seek);
  });
}
function Jr(e, t, o) {
  let r = e.options.muted;
  e.addEventListener("volumechange", () => {
    const a = e.volume === 0 || e.muted;
    r !== a && (r = a, o.reportNominalMetric(
      a ? V.Mute : V.Unmute
    ), t.dispatchEvent(new p(a ? "mute" : "unmute")));
  });
}
function ea(e, t) {
  e.addEventListener(
    "ready",
    () => {
      t.reportNominalMetric(V.CommonPlayerImpression);
    },
    { once: !0 }
  );
}
function ta(e, t) {
  return (o) => {
    const r = {
      deliveryMethod: "npm",
      playerInstanceId: e.umpId,
      playerVersionNumber: 1737055079165,
      playerCommit: "f10b591ec73eead1df5d2d9ed284b6bdc8312e5c",
      playerUrl: zr,
      title: o.options.unlocalizedTitle || o.options.title,
      partnerName: o.options.partnerName
    }, a = new Ar(
      r,
      o,
      t,
      o.options.reporting,
      o.options.debug
    );
    Nr(o, e, a);
    const n = Dr(
      o,
      e,
      a
    );
    return () => {
      n();
    };
  };
}
const oa = `<svg width='24' height='24'
     viewBox='0 0 24 24'
     xmlns='http://www.w3.org/2000/svg'
    class="spinner-icon"
  >
  <defs>
    <clipPath id="circleClip">
      <circle cx="12" cy="12" r="12"/>
    </clipPath>
  </defs>
  <style>
    .spinner-icon {
      --stroke-width: 2;
      --stroke-bg: #333;
      --stroke-fg: #fff;

      transform-origin: center;
      animation: rotate 2s linear infinite;
      stroke-width: var(--stroke-width);
    }

    .spinner-bg {
      stroke: var(--stroke-bg);
    }
    
    .spinner-stroke {
      stroke: var(--stroke-fg);
      animation: animate-stroke 1.5s ease-out infinite;
    }

    @keyframes rotate {
      100% {
        transform: rotate(360deg)
      }
    }

    @keyframes animate-stroke {
      0% {
        stroke-dasharray: 0 150;
        stroke-dashoffset: 0;
      }

      47.5% {
        stroke-dasharray: 42 150;
        stroke-dashoffset: -16;
      }

      95%,
      100% {
        stroke-dasharray: 42 150;
        stroke-dashoffset: -59
      }
    }
  </style>
    <circle class="spinner-bg" cx='12' cy='12' r='9.5' fill='none' clip-path="url(#circleClip)"></circle>
    <circle class="spinner-stroke" cx='12' cy='12' r='9.5' fill='none' clip-path="url(#circleClip)"></circle>
</svg>`;
function ra(e) {
  return `data:image/svg+xml,${encodeURIComponent(e).replace(/'/g, "%27").replace(/"/g, "%22")}`;
}
const aa = w`
.spinner{background-image:url('${yt(ra(oa))}');background-repeat:no-repeat;background-position:center;background-size:cover;width:var(--size-8);height:var(--size-8)}
`;
var na = Object.defineProperty, ia = Object.getOwnPropertyDescriptor, Pt = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? ia(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && na(t, o, a), a;
};
let $e = class extends C {
  render() {
    return this.playerState.controlsState === "none" || !this.playerState.loading ? null : d`<div class="spinner"></div>`;
  }
};
$e.styles = [
  aa,
  w`
.spinner{width:var(--size-12);height:var(--size-12)}
    `
];
Pt([
  M({ context: L, subscribe: !0 })
], $e.prototype, "playerState", 2);
$e = Pt([
  S("ump-loading-spinner")
], $e);
const _t = w`
:host{--border-radius-none:0;--border-radius-small:2px;--border-radius-medium:4px;--border-radius-large:6px;--border-radius-x-large:8px;--border-radius-circular:10000px;--font-size-base-100:0.625rem;--font-size-base-200:0.75rem;--font-size-base-300:0.875rem;--font-size-base-400:1rem;--font-size-base-500:1.25rem;--font-size-base-600:1.5rem;--font-size-hero-700:1.75rem;--font-size-hero-800:2rem;--font-size-hero-900:2.5rem;--font-size-hero-1000:2.25rem;--font-weight-regular:400;--font-weight-medium:500;--font-weight-semibold:600;--font-weight-bold:700;--duration-ultra-fast:50ms;--duration-faster:100ms;--duration-fast:150ms;--duration-normal:200ms;--duration-gentle:250ms;--duration-slow:300ms;--duration-slower:400ms;--duration-ultra-slow:500ms;--curve-accelerate-max:cubic-bezier(0.9,0.1,1,0.2);--curve-accelerate-mid:cubic-bezier(1,0,1,1);--curve-accelerate-min:cubic-bezier(0.8,0,0.78,1);--curve-decelerate-max:cubic-bezier(0.1,0.9,0.2,1);--curve-decelerate-mid:cubic-bezier(0,0,0,1);--curve-decelerate-min:cubic-bezier(0.33,0,0.1,1);--curve-easy-ease-max:cubic-bezier(0.8,0,0.2,1);--curve-easy-ease:cubic-bezier(0.33,0,0.67,1);--curve-linear:cubic-bezier(0,0,1,1);--line-height-base-100:0.875rem;--line-height-base-200:1rem;--line-height-base-300:1.25rem;--line-height-base-400:1.375rem;--line-height-base-500:1.75rem;--line-height-base-600:2rem;--line-height-hero-700:2.25rem;--line-height-hero-800:2.5rem;--line-height-hero-900:3.125rem;--line-height-hero-1000:5.75rem;--spacing-none:0;--spacing-xxs:0.125rem;--spacing-xs:0.25rem;--spacing-s-nudge:0.375rem;--spacing-s:0.5rem;--spacing-m-nudge:0.625rem;--spacing-m:0.75rem;--spacing-l:1rem;--spacing-xl:1.25rem;--spacing-xxl:1.5rem;--spacing-xxxl:2rem;--spacing-xxxxl:2.25rem;--size-0:0px;--size-px:1px;--size-0-5:0.125rem;--size-1:0.25rem;--size-1-5:0.375rem;--size-2:0.5rem;--size-2-5:0.625rem;--size-3:0.75rem;--size-3-5:0.875rem;--size-4:1rem;--size-5:1.25rem;--size-6:1.5rem;--size-7:1.75rem;--size-8:2rem;--size-9:2.25rem;--size-10:2.5rem;--size-11:2.75rem;--size-12:3rem;--size-14:3.5rem;--size-16:4rem;--size-20:5rem;--size-24:6rem;--size-28:7rem;--size-32:8rem;--size-36:9rem;--size-40:10rem;--size-44:11rem;--size-48:12rem;--size-52:13rem;--size-56:14rem;--size-60:15rem;--size-64:16rem;--size-72:18rem;--size-80:20rem;--size-96:24rem;--size-100:30rem;--stroke-width-thin:1px;--stroke-width-thick:2px;--stroke-width-thicker:3px;--stroke-width-thickest:4px;--color-neutral-shadow-ambient:rgb(0 0 0/24%);--color-neutral-shadow-key:rgb(0 0 0/28%);--color-neutral-shadow-ambient-lighter:rgb(0 0 0/12%);--color-neutral-shadow-key-lighter:rgb(0 0 0/14%);--color-neutral-shadow-ambient-darker:rgb(0 0 0/40%);--color-neutral-shadow-key-darker:rgb(0 0 0/48%);--color-brand-shadow-ambient:rgb(0 0 0/30%);--color-brand-shadow-key:rgb(0 0 0/25%);--color-grey-2:#050505;--color-grey-4:#0a0a0a;--color-grey-6:#0f0f0f;--color-grey-8:#141414;--color-grey-10:#1a1a1a;--color-grey-12:#1f1f1f;--color-grey-14:#242424;--color-grey-16:#292929;--color-grey-18:#2e2e2e;--color-grey-20:#333;--color-grey-22:#383838;--color-grey-24:#3d3d3d;--color-grey-26:#424242;--color-grey-28:#474747;--color-grey-30:#4d4d4d;--color-grey-32:#525252;--color-grey-34:#575757;--color-grey-36:#5c5c5c;--color-grey-38:#616161;--color-grey-40:#666;--color-grey-42:#6b6b6b;--color-grey-44:#707070;--color-grey-46:#757575;--color-grey-48:#7a7a7a;--color-grey-50:#808080;--color-grey-52:#858585;--color-grey-54:#8a8a8a;--color-grey-56:#8f8f8f;--color-grey-58:#949494;--color-grey-60:#999;--color-grey-62:#9e9e9e;--color-grey-64:#a3a3a3;--color-grey-66:#a8a8a8;--color-grey-68:#adadad;--color-grey-70:#b3b3b3;--color-grey-72:#b8b8b8;--color-grey-74:#bdbdbd;--color-grey-76:#c2c2c2;--color-grey-78:#c7c7c7;--color-grey-80:#ccc;--color-grey-82:#d1d1d1;--color-grey-84:#d6d6d6;--color-grey-86:#dbdbdb;--color-grey-88:#e0e0e0;--color-grey-90:#e6e6e6;--color-grey-92:#ebebeb;--color-grey-94:#f0f0f0;--color-grey-96:#f5f5f5;--color-grey-98:#fafafa;--color-white:#fff;--color-white-alpha-5:rgb(255 255 255/5%);--color-white-alpha-10:rgb(255 255 255/10%);--color-white-alpha-20:rgb(255 255 255/20%);--color-white-alpha-30:rgb(255 255 255/30%);--color-white-alpha-40:rgb(255 255 255/40%);--color-white-alpha-50:rgb(255 255 255/50%);--color-white-alpha-60:rgb(255 255 255/60%);--color-white-alpha-70:rgb(255 255 255/70%);--color-white-alpha-80:rgb(255 255 255/80%);--color-white-alpha-90:rgb(255 255 255/90%);--color-black:#000;--color-black-alpha-5:rgb(0 0 0/5%);--color-black-alpha-10:rgb(0 0 0/10%);--color-black-alpha-20:rgb(0 0 0/20%);--color-black-alpha-30:rgb(0 0 0/30%);--color-black-alpha-40:rgb(0 0 0/40%);--color-black-alpha-50:rgb(0 0 0/50%);--color-black-alpha-60:rgb(0 0 0/60%);--color-black-alpha-70:rgb(0 0 0/70%);--color-black-alpha-80:rgb(0 0 0/80%);--color-black-alpha-90:rgb(0 0 0/90%);--color-grey-10-alpha-5:rgb(26 26 26/5%);--color-grey-10-alpha-10:rgb(26 26 26/10%);--color-grey-10-alpha-20:rgb(26 26 26/20%);--color-grey-10-alpha-30:rgb(26 26 26/30%);--color-grey-10-alpha-40:rgb(26 26 26/40%);--color-grey-10-alpha-50:rgb(26 26 26/50%);--color-grey-10-alpha-60:rgb(26 26 26/60%);--color-grey-10-alpha-70:rgb(26 26 26/70%);--color-grey-10-alpha-80:rgb(26 26 26/80%);--color-grey-10-alpha-90:rgb(26 26 26/90%);--color-grey-12-alpha-5:rgb(31 31 31/5%);--color-grey-12-alpha-10:rgb(31 31 31/10%);--color-grey-12-alpha-20:rgb(31 31 31/20%);--color-grey-12-alpha-30:rgb(31 31 31/30%);--color-grey-12-alpha-40:rgb(31 31 31/40%);--color-grey-12-alpha-50:rgb(31 31 31/50%);--color-grey-12-alpha-60:rgb(31 31 31/60%);--color-grey-12-alpha-70:rgb(31 31 31/70%);--color-grey-12-alpha-80:rgb(31 31 31/80%);--color-grey-12-alpha-90:rgb(31 31 31/90%);--color-grey-14-alpha-5:rgb(36 36 36/5%);--color-grey-14-alpha-10:rgb(36 36 36/10%);--color-grey-14-alpha-20:rgb(36 36 36/20%);--color-grey-14-alpha-30:rgb(36 36 36/30%);--color-grey-14-alpha-40:rgb(36 36 36/40%);--color-grey-14-alpha-50:rgb(36 36 36/50%);--color-grey-14-alpha-60:rgb(36 36 36/60%);--color-grey-14-alpha-70:rgb(36 36 36/70%);--color-grey-14-alpha-80:rgb(36 36 36/80%);--color-grey-14-alpha-90:rgb(36 36 36/90%);--color-brand-10:#061724;--color-brand-20:#082338;--color-brand-30:#0a2e4a;--color-brand-40:#0c3b5e;--color-brand-50:#0e4775;--color-brand-60:#0f548c;--color-brand-70:#115ea3;--color-brand-80:#0f6cbd;--color-brand-90:#2886de;--color-brand-100:#479ef5;--color-brand-110:#62abf5;--color-brand-120:#77b7f7;--color-brand-130:#96c6fa;--color-brand-140:#b4d6fa;--color-brand-150:#cfe4fa;--color-brand-160:#ebf3fc;--color-neutral-foreground-1:var(--color-white);--color-neutral-foreground-1-hover:var(--color-white);--color-neutral-foreground-1-pressed:var(--color-white);--color-neutral-foreground-1-selected:var(--color-white);--color-neutral-foreground-2:var(--color-grey-84);--color-neutral-foreground-2-hover:var(--color-white);--color-neutral-foreground-2-pressed:var(--color-white);--color-neutral-foreground-2-selected:var(--color-white);--color-neutral-foreground-2-brand-hover:var(--color-brand-100);--color-neutral-foreground-2-brand-pressed:var(--color-brand-90);--color-neutral-foreground-2-brand-selected:var(--color-brand-100);--color-neutral-foreground-3:var(--color-grey-68);--color-neutral-foreground-3-hover:var(--color-grey-84);--color-neutral-foreground-3-pressed:var(--color-grey-84);--color-neutral-foreground-3-selected:var(--color-grey-84);--color-neutral-foreground-3-brand-hover:var(--color-brand-100);--color-neutral-foreground-3-brand-pressed:var(--color-brand-90);--color-neutral-foreground-3-brand-selected:var(--color-brand-100);--color-neutral-foreground-4:var(--color-grey-60);--color-neutral-foreground-disabled:var(--color-grey-36);--color-neutral-foreground-inverted-disabled:var(--color-white-alpha-40);--color-brand-foreground-link:var(--color-brand-100);--color-brand-foreground-link-hover:var(--color-brand-110);--color-brand-foreground-link-pressed:var(--color-brand-90);--color-brand-foreground-link-selected:var(--color-brand-100);--color-neutral-foreground-2-link:var(--color-grey-84);--color-neutral-foreground-2-link-hover:var(--color-white);--color-neutral-foreground-2-link-pressed:var(--color-white);--color-neutral-foreground-2-link-selected:var(--color-white);--color-compound-brand-foreground-1:var(--color-brand-100);--color-compound-brand-foreground-1-hover:var(--color-brand-110);--color-compound-brand-foreground-1-pressed:var(--color-brand-90);--color-brand-foreground-1:var(--color-brand-100);--color-brand-foreground-2:var(--color-brand-110);--color-brand-foreground-2-hover:var(--color-brand-130);--color-brand-foreground-2-pressed:var(--color-brand-160);--color-neutral-foreground-1-static:var(--color-grey-14);--color-neutral-foreground-static-inverted:var(--color-white);--color-neutral-foreground-inverted:var(--color-grey-14);--color-neutral-foreground-inverted-hover:var(--color-grey-14);--color-neutral-foreground-inverted-pressed:var(--color-grey-14);--color-neutral-foreground-inverted-selected:var(--color-grey-14);--color-neutral-foreground-inverted-2:var(--color-grey-14);--color-neutral-foreground-on-brand:var(--color-white);--color-neutral-foreground-inverted-link:var(--color-white);--color-neutral-foreground-inverted-link-hover:var(--color-white);--color-neutral-foreground-inverted-link-pressed:var(--color-white);--color-neutral-foreground-inverted-link-selected:var(--color-white);--color-brand-foreground-inverted:var(--color-brand-80);--color-brand-foreground-inverted-hover:var(--color-brand-70);--color-brand-foreground-inverted-pressed:var(--color-brand-60);--color-brand-foreground-on-light:var(--color-brand-80);--color-brand-foreground-on-light-hover:var(--color-brand-70);--color-brand-foreground-on-light-pressed:var(--color-brand-50);--color-brand-foreground-on-light-selected:var(--color-brand-60);--color-neutral-background-1:var(--color-grey-16);--color-neutral-background-1-hover:var(--color-grey-24);--color-neutral-background-1-pressed:var(--color-grey-12);--color-neutral-background-1-selected:var(--color-grey-22);--color-neutral-background-2:var(--color-grey-12);--color-neutral-background-2-hover:var(--color-grey-20);--color-neutral-background-2-pressed:var(--color-grey-8);--color-neutral-background-2-selected:var(--color-grey-18);--color-neutral-background-3:var(--color-grey-8);--color-neutral-background-3-hover:var(--color-grey-16);--color-neutral-background-3-pressed:var(--color-grey-4);--color-neutral-background-3-selected:var(--color-grey-14);--color-neutral-background-4:var(--color-grey-4);--color-neutral-background-4-hover:var(--color-grey-12);--color-neutral-background-4-pressed:var(--color-black);--color-neutral-background-4-selected:var(--color-grey-10);--color-neutral-background-5:var(--color-black);--color-neutral-background-5-hover:var(--color-grey-8);--color-neutral-background-5-pressed:var(--color-grey-2);--color-neutral-background-5-selected:var(--color-grey-6);--color-neutral-background-6:var(--color-grey-20);--color-neutral-background-inverted:var(--color-white);--color-neutral-background-static:var(--color-grey-24);--color-neutral-background-alpha:var(--color-grey-10-alpha-50);--color-neutral-background-alpha-2:var(--color-grey-12-alpha-70);--color-neutral-background-disabled:var(--color-grey-8);--color-neutral-background-inverted-disabled:var(--color-white-alpha-10);--color-subtle-background:transparent;--color-subtle-background-hover:var(--color-grey-22);--color-subtle-background-pressed:var(--color-grey-18);--color-subtle-background-selected:var(--color-grey-20);--color-subtle-background-light-alpha-hover:var(--color-grey-14-alpha-80);--color-subtle-background-light-alpha-pressed:var(--color-grey-14-alpha-50);--color-subtle-background-light-alpha-selected:transparent;--color-subtle-background-inverted:transparent;--color-subtle-background-inverted-hover:var(--color-black-alpha-10);--color-subtle-background-inverted-pressed:var(--color-black-alpha-30);--color-subtle-background-inverted-selected:var(--color-black-alpha-20);--color-transparent-background:transparent;--color-transparent-background-hover:transparent;--color-transparent-background-pressed:transparent;--color-transparent-background-selected:transparent;--color-background-overlay:var(--color-black-alpha-50);--color-brand-background:var(--color-brand-70);--color-brand-background-hover:var(--color-brand-80);--color-brand-background-pressed:var(--color-brand-40);--color-brand-background-selected:var(--color-brand-60);--color-compound-brand-background:var(--color-brand-100);--color-compound-brand-background-hover:var(--color-brand-110);--color-compound-brand-background-pressed:var(--color-brand-90);--color-brand-background-static:var(--color-brand-80);--color-brand-background-2:var(--color-brand-20);--color-brand-background-2-hover:var(--color-brand-40);--color-brand-background-2-pressed:var(--color-brand-10);--color-brand-background-3-static:var(--color-brand-60);--color-brand-background-4-static:var(--color-brand-40);--color-brand-background-inverted:var(--color-white);--color-brand-background-inverted-hover:var(--color-brand-160);--color-brand-background-inverted-pressed:var(--color-brand-140);--color-brand-background-inverted-selected:var(--color-brand-150);--color-neutral-card-background:var(--color-grey-20);--color-neutral-card-background-hover:var(--color-grey-24);--color-neutral-card-background-pressed:var(--color-grey-18);--color-neutral-card-background-selected:var(--color-grey-22);--color-neutral-card-background-disabled:var(--color-grey-8);--color-neutral-stroke-accessible:var(--color-grey-68);--color-neutral-stroke-accessible-hover:var(--color-grey-74);--color-neutral-stroke-accessible-pressed:var(--color-grey-70);--color-neutral-stroke-accessible-selected:var(--color-brand-100);--color-neutral-stroke-1:var(--color-grey-40);--color-neutral-stroke-1-hover:var(--color-grey-46);--color-neutral-stroke-1-pressed:var(--color-grey-42);--color-neutral-stroke-1-selected:var(--color-grey-44);--color-neutral-stroke-2:var(--color-grey-32);--color-neutral-stroke-3:var(--color-grey-24);--color-neutral-stroke-subtle:var(--color-grey-4);--color-neutral-stroke-on-brand:var(--color-grey-16);--color-neutral-stroke-on-brand-2:var(--color-white);--color-neutral-stroke-on-brand-2-hover:var(--color-white);--color-neutral-stroke-on-brand-2-pressed:var(--color-white);--color-neutral-stroke-on-brand-2-selected:var(--color-white);--color-brand-stroke-1:var(--color-brand-100);--color-brand-stroke-2:var(--color-brand-50);--color-brand-stroke-2-hover:var(--color-brand-50);--color-brand-stroke-2-pressed:var(--color-brand-30);--color-brand-stroke-2-contrast:var(--color-brand-50);--color-compound-brand-stroke:var(--color-brand-100);--color-compound-brand-stroke-hover:var(--color-brand-110);--color-compound-brand-stroke-pressed:var(--color-brand-90);--color-neutral-stroke-disabled:var(--color-grey-26);--color-neutral-stroke-inverted-disabled:var(--color-white-alpha-40);--color-transparent-stroke:transparent;--color-transparent-stroke-interactive:transparent;--color-transparent-stroke-disabled:transparent;--color-neutral-stroke-alpha:var(--color-white-alpha-10);--color-neutral-stroke-alpha-2:var(--color-white-alpha-20);--color-stroke-focus-1:var(--color-black);--color-stroke-focus-2:var(--color-white);--shadow-2:0 0 2px var(--color-neutral-shadow-ambient),0 1px 2px var(--color-neutral-shadow-key);--shadow-4:0 0 2px var(--color-neutral-shadow-ambient),0 2px 4px var(--color-neutral-shadow-key);--shadow-8:0 0 2px var(--color-neutral-shadow-ambient),0 4px 8px var(--color-neutral-shadow-key);--shadow-16:0 0 2px var(--color-neutral-shadow-ambient),0 8px 16px var(--color-neutral-shadow-key);--shadow-28:0 0 8px var(--color-neutral-shadow-ambient),0 14px 28px var(--color-neutral-shadow-key);--shadow-64:0 0 8px var(--color-neutral-shadow-ambient),0 32px 64px var(--color-neutral-shadow-key);--shadow-2-brand:0 0 2px var(--color-brand-shadow-ambient),0 1px 2px var(--color-brand-shadow-key);--shadow-4-brand:0 0 2px var(--color-brand-shadow-ambient),0 2px 4px var(--color-brand-shadow-key);--shadow-8-brand:0 0 2px var(--color-brand-shadow-ambient),0 4px 8px var(--color-brand-shadow-key);--shadow-16-brand:0 0 2px var(--color-brand-shadow-ambient),0 8px 16px var(--color-brand-shadow-key);--shadow-28-brand:0 0 8px var(--color-brand-shadow-ambient),0 14px 28px var(--color-brand-shadow-key);--shadow-64-brand:0 0 8px var(--color-brand-shadow-ambient),0 32px 64px var(--color-brand-shadow-key);--font-family-default:'Segoe UI','Segoe UI Web (West European)',-apple-system,blinkmacsystemfont,roboto,'Helvetica Neue',sans-serif}
`, sa = '<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M16 13a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0ZM16 4a12 12 0 1 0 0 24 12 12 0 0 0 0-24Z"/></svg>';
var la = Object.defineProperty, ca = Object.getOwnPropertyDescriptor, ua = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? ca(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && la(t, o, a), a;
};
let Be = class extends C {
  render() {
    return d`
      <div class="dialog">
        <div class="header-icon">${v(sa)}</div>

        <div class="content">
          <hgroup>
            <h2>${s("You may not access this content")}</h2>
            <p>
              ${s(`An age restriction has been implemented due to mature themes or
              legal requirements intended to protect younger audiences.`)}
            </p>
          </hgroup>
        </div>
      </div>
    `;
  }
};
Be.styles = [
  B,
  Le,
  w`
:host{display:flex;align-items:center;justify-content:center;background-color:var(--color-neutral-background-2)}.dialog{padding:var(--spacing-xxxl) var(--spacing-xxxl);display:flex;align-items:flex-start;gap:var(--spacing-xl);z-index:10;margin:var(--spacing-xxl);max-width:var(--size-100)}.content{display:flex;align-items:flex-start;flex-direction:column;gap:var(--spacing-xxl);padding-right:var(--spacing-xxxl)}.header-icon{padding:var(--spacing-s);color:var(--color-brand-130);fill:currentcolor}h2{margin:0;padding:0}hgroup{display:flex;flex-direction:column;gap:var(--spacing-xs)}p{margin:0;padding:0}.select-container{display:flex;gap:var(--spacing-m)}
    `
];
Be = ua([
  S("ump-age-gate-restricted")
], Be);
const da = '<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M9 9a7 7 0 1 1 14 0A7 7 0 0 1 9 9Zm7-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm.38 15H7.5A3.5 3.5 0 0 0 4 21.5v.67C4 24.32 6.77 30 16 30c.43 0 .84-.01 1.24-.04-.31-.3-.6-.62-.87-.96H16c-8.77 0-11-5.32-11-6.83v-.67A2.5 2.5 0 0 1 7.5 19h8.2c.2-.35.43-.68.68-1Zm7.12-2a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm4.53 4.72c.3.3.3.77 0 1.06l-5.25 5.25c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06l1.97 1.97 4.72-4.72c.3-.3.77-.3 1.06 0Z"/></svg>', pa = w`
.select{--svg:url('data:image/svg+xml;utf8,${yt(
  encodeURIComponent(
    '<svg width="16" height="16" fill="none" stroke="#666" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M4.293 8.293a1 1 0 0 1 1.414 0L12 14.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Z" fill="#ffffff"/></svg>'
  )
)}');position:relative;display:inline-flex;align-items:center;gap:var(--spacing-s-nudge);margin:0;-webkit-appearance:none;appearance:none;padding:var(--spacing-s) var(--spacing-xxxl) var(--spacing-s) var(--spacing-l);color:var(--color-neutral-foreground-1);transition-duration:var(--duration-faster);transition-property:background,color;font-size:var(--font-size-base-400);transition-timing-function:var(--curve-easy-ease);cursor:pointer;-webkit-user-select:none;user-select:none;background-color:var(--color-neutral-background-1);border-radius:var(--border-radius-medium);border:none;background-image:var(--svg);background-repeat:no-repeat;background-position-y:center;background-position-x:calc(100% - 8px);font-family:var(--font-family-default)}.select:focus{outline:none;border-bottom:solid var(--stroke-width-thick) var(--color-brand-stroke-1)}.select:focus-within{outline:none;border-bottom:solid var(--stroke-width-thick) var(--color-brand-stroke-1)}.select.focus-always:focus,.select.focus-default:focus-visible{outline:var(--stroke-width-thick) solid var(--color-stroke-focus-2)}.select:active{outline:none}.select-outline{border:solid var(--stroke-width-thick) var(--color-neutral-stroke-1)}.select-outline.focus-always:focus,.select-outline.focus-default:focus-visible{border:solid var(--stroke-width-thick) var(--color-neutral-stroke-1)}
`;
function ha(e) {
  const t = /* @__PURE__ */ new Date(), o = new Date(e);
  o.setFullYear(t.getFullYear());
  let r = t.getFullYear() - e.getFullYear();
  return t < o && r--, r;
}
function tt(e, t) {
  return Array.from({ length: t - e + 1 }, (o, r) => e + r);
}
var ma = Object.defineProperty, ga = Object.getOwnPropertyDescriptor, ve = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? ga(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && ma(t, o, a), a;
};
const va = tt(1, 12), ba = tt(1, 31), fa = tt(1900, (/* @__PURE__ */ new Date()).getFullYear()).reverse();
let Y = class extends C {
  render() {
    return d`
    <div class="dialog">
      <div class="header-icon">${v(da)}</div>

        <div class="content">
          <hgroup>
            <h2>${s("Please enter your date of birth")}</h2>
            <p>${s("Age verification is required to access this content.")}</p>
          </hgroup>

          <div class="select-container">
            <div class="select-wrapper">
              <label for="month">${s("Month")}</label>
              <select 
                class=${c({
      ...u(this.playerState),
      select: !0,
      "select-outline": !0
    })}
                aria-label="${s("Month")}" 
                data-testid="month" 
                id="month"
                >
                <option disabled selected value=''></option>
                ${va.map(
      (e) => d`<option value=${e}>${e}</option>`
    )}
              </select>
            </div>

            <div class="select-wrapper">
              <label for="day">${s("Day")}</label>
              <select 
                class=${c({
      ...u(this.playerState),
      select: !0,
      "select-outline": !0
    })}
                aria-label="${s("Day")}" 
                data-testid="day" 
                id="day"
                >
                <option disabled selected value=''></option>
                ${ba.map(
      (e) => d`<option value=${e}>${e}</option>`
    )}
              </select>
            </div>
            
            <div class="select-wrapper">
              <label for="year">${s("Year")}</label>
              <select 
                class=${c({
      ...u(this.playerState),
      select: !0,
      "select-outline": !0
    })}
                aria-label="${s("Year")}" 
                data-testid="year" 
                id="year"
                >
                <option disabled selected value=''></option>
                ${fa.map(
      (e) => d`<option value=${e}>${e}</option>`
    )}
              </select>
            </div>
          </div>

          <button 
            type="button"
            class=${c({
      btn: !0,
      "btn-s": !0,
      "btn-brand": !0,
      ...u(this.playerState)
    })}
            data-testid="age-gate-submit"
          @click=${this.submitButtonClicked}>${s("Submit")}</button>
        </div>
      </div>
    </div>
    `;
  }
  submitButtonClicked() {
    const e = this.monthSelect.value, t = this.daySelect.value, o = this.yearSelect.value;
    if (!e || !t || !o)
      return;
    const r = ha(
      new Date(Number(o), Number(e) - 1, Number(t))
    );
    this.dispatchEvent(new p("user-age-set", r));
  }
};
Y.styles = [
  B,
  pa,
  Le,
  w`
:host{display:flex;align-items:center;justify-content:center}.dialog{padding:var(--spacing-xxl) var(--spacing-xxxl);display:flex;align-items:flex-start;gap:var(--spacing-xl);z-index:10;margin:var(--spacing-xxl);max-width:var(--size-100)}.content{display:flex;align-items:flex-start;flex-direction:column;gap:var(--spacing-xxxl);padding-right:var(--spacing-xxl)}.header-icon{padding:var(--spacing-s);color:var(--color-brand-130);fill:currentcolor}hgroup{display:flex;flex-direction:column;gap:var(--spacing-xs)}hgroup h2{margin:0;padding:0}hgroup p{margin:0;padding:0}.select-container{display:flex;flex-direction:row;gap:var(--spacing-m)}.select-wrapper{display:flex;flex-direction:column}.select{background-color:var(--color-brand-30)}.select-outline{border-color:var(--color-brand-150);border-width:var(--stroke-width-thin)}.select-outline.default:focus-visible,.select-outline.focus-always:focus{border-width:var(--stroke-width-thin)}
    `
];
ve([
  $("#month")
], Y.prototype, "monthSelect", 2);
ve([
  $("#day")
], Y.prototype, "daySelect", 2);
ve([
  $("#year")
], Y.prototype, "yearSelect", 2);
ve([
  M({ context: L, subscribe: !0 })
], Y.prototype, "playerState", 2);
Y = ve([
  S("ump-age-gate-verification")
], Y);
const ya = '<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M17.25 22a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM16 9a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0v-8a1 1 0 0 0-1-1Zm-3.06-5.2a3.5 3.5 0 0 1 6.12 0l10.5 19a3.5 3.5 0 0 1-3.07 5.2H5.51a3.5 3.5 0 0 1-3.07-5.2l10.5-19Zm4.37.98a1.5 1.5 0 0 0-2.62 0l-10.5 19A1.5 1.5 0 0 0 5.51 26h20.98a1.5 1.5 0 0 0 1.32-2.23l-10.5-19Z"/></svg>';
var wa = Object.defineProperty, ka = Object.getOwnPropertyDescriptor, Vt = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? ka(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && wa(t, o, a), a;
};
let Se = class extends C {
  render() {
    return d`
      <div class="dialog message-container" data-testid="error-message">
        <div class="header-icon">${v(ya)}</div>

        <div class="content">
          <hgroup>
            <h2>${s("Playback Error")}</h2>
            <p>${this.playerState.error}</p>
          </hgroup>
        </div>
      </div>
    `;
  }
};
Se.styles = [
  B,
  Le,
  w`
:host{display:flex;align-items:center;justify-content:center;background-color:var(--color-brand-10)}.message-container{display:flex;align-items:flex-start;gap:var(--spacing-xl);padding:var(--spacing-xxxl) var(--spacing-xxxl)}.content{display:flex;align-items:flex-start;flex-direction:column;gap:var(--spacing-xxl);padding-right:var(--spacing-xxxl)}.header-icon{padding:var(--spacing-s);color:var(--color-brand-foreground-1);fill:currentcolor}h2{margin:0;padding:0}hgroup{display:flex;flex-direction:column;gap:var(--spacing-xs)}p{margin:0;padding:0}.select-container{display:flex;gap:var(--spacing-m)}
    `
];
Vt([
  M({ context: L, subscribe: !0 })
], Se.prototype, "playerState", 2);
Se = Vt([
  S("ump-error-modal")
], Se);
var xa = Object.defineProperty, Ea = Object.getOwnPropertyDescriptor, zt = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? Ea(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && xa(t, o, a), a;
};
let Ie = class extends C {
  /**
   * Render in the order of importance for each modal.
   */
  render() {
    return this.playerState.error ? d`<ump-error-modal class="modal"></ump-error-modal>` : this.playerState.ageGate === "waiting" ? d`<div
        data-testid="age-gate-overlay"
        class="overlay modal"
      ></div>` : this.playerState.ageGate === "verification" ? d`<ump-age-gate-verification
        class="modal"
      ></ump-age-gate-verification> ` : this.playerState.ageGate === "denied" ? d`<ump-age-gate-restricted
        class="modal"
      ></ump-age-gate-restricted>` : null;
  }
  updated(e) {
    var o;
    super.updated(e);
    const t = !((o = this.shadowRoot) != null && o.children.length);
    this.ariaHidden = t.toString();
  }
};
Ie.styles = [
  _t,
  w`
:host([aria-hidden='true']){display:none}.overlay{background-color:var(--color-black)}.modal{position:absolute;inset:0;width:100%;height:100%;text-align:left}ump-age-gate-verification,ump-age-gate-restricted{background-color:var(--color-brand-10)}
    `
];
zt([
  M({ context: L, subscribe: !0 })
], Ie.prototype, "playerState", 2);
Ie = zt([
  S("ump-modals")
], Ie);
function me(e) {
  return e.map((t) => ({
    ...t,
    type: Et[t.type] ?? t.type
  })).sort((t, o) => {
    let r = st.indexOf(t.type) - st.indexOf(o.type);
    return r === 0 && t.type === "video/mp4" && (r = xe.indexOf(t.quality) - xe.indexOf(o.quality)), r;
  }).filter(Ca);
}
function Ca(e) {
  return document.createElement("video").canPlayType(e.type) != "" ? !0 : "ManagedMediaSource" in window || "MediaSource" in window;
}
function ot(e) {
  const o = e.map((r) => ({
    ...r,
    ccType: lo[r.ccType] ?? r.ccType
  })).reduce(
    (r, a) => (r[a.locale] || (r[a.locale] = []), r[a.locale].push(a), r),
    {}
  );
  return Object.values(o).map(
    (r) => r.find((a) => a.ccType === "text/vtt") ?? r[0]
  );
}
function rt(e) {
  let t = !1, o;
  return (...r) => (t || (o = e(...r), t = !0), o);
}
const $a = rt(async () => {
  try {
    const e = document.createElement("video"), t = e.volume;
    e.volume = t / 2 + 0.1;
    const o = e.volume;
    return t !== o && await new Promise((a) => setTimeout(a, 1)), t !== e.volume;
  } catch {
    return !1;
  }
}), Sa = rt(() => typeof document.createElement("div").requestFullscreen == "function");
function Ia(e) {
  return "webkitEnterFullscreen" in e && "webkitSupportsFullscreen" in e && typeof e.webkitEnterFullscreen == "function" && e.webkitSupportsFullscreen;
}
function Ta(e, t) {
  return Object.fromEntries(
    Object.entries(e).filter(([o, r]) => !t(o, r))
  );
}
function Ma(e) {
  return Ta(e, (t, o) => o == null);
}
const He = [
  "abort",
  "canplay",
  "canplaythrough",
  // @ts-expect-error - ts doesn't know about this
  "complete",
  "cuechange",
  "durationchange",
  "emptied",
  "ended",
  "error",
  "loadeddata",
  "loadedmetadata",
  "loadstart",
  "pause",
  "play",
  "playing",
  "progress",
  "ratechange",
  "seeked",
  "seeking",
  "stalled",
  "suspend",
  "timeupdate",
  "volumechange",
  "waiting"
];
class La extends y.Player {
  constructor(t, o, r) {
    super(), this.videoElementEventListeners = {}, this.plugins = [], this.pluginOnDestroy = [], this.loadRequested = !1, this._autoplay = !1, this.onFullscreenChange = () => {
      this.dispatchEvent(new y.util.FakeEvent("fullscreenchanged"));
    }, this.options = { ...Oe, ...Ma(t) }, t.autoplay && t.muted !== !1 && (this.options.muted = !0), this.videoElement = o, this.lastSelectedVolume = o.volume, this.captionDisplay = r, this.configure({
      streaming: {
        bufferBehind: 300,
        // 5 minutes
        ignoreTextStreamFailures: !0
      }
    });
  }
  async initialize() {
    this.plugins.forEach((t) => this.pluginOnDestroy.push(t(this))), this.setVideoContainer(this.captionDisplay.captionContainer), this.forwardVideoElementEvents(), this.loop = this.options.loop, this.muted = this.options.muted, this.options.hidePosterImage || (this.poster = this.options.poster), this.videoElement.disablePictureInPicture = !0, this.videoElement.playsInline = !0, await this.attach(this.videoElement);
  }
  async destroy() {
    Object.entries(this.videoElementEventListeners).forEach(
      ([t, o]) => this.videoElement.removeEventListener(t, o)
    ), this.pluginOnDestroy.forEach((t) => t()), this.removeFullscreenListener(), await super.destroy();
  }
  load(t, o, r) {
    return r === Et.MP4 && (this.adaptiveBitrate = !1), super.load(t, o, r);
  }
  async loadCaptions(t = this.options.ccFiles) {
    for (const o of ot(t))
      await this.addTextTrackAsync(
        o.url,
        o.locale,
        "captions",
        o.ccType
      );
  }
  async play() {
    if (this.getLoadMode() === y.Player.LoadMode.NOT_LOADED) {
      this.addEventListener(
        "loadsourcescomplete",
        this.handleLoadSourcesComplete
      ), this.loadRequest();
      return;
    }
    return this.videoElement.play();
  }
  pause() {
    if (!this.isFullyLoaded()) {
      this.removeEventListener(
        "loadsourcescomplete",
        this.handleLoadSourcesComplete
      );
      return;
    }
    return this.videoElement.pause();
  }
  loadRequest() {
    this.loadRequested || (this.loadRequested = !0, this.dispatchEvent(new y.util.FakeEvent("loadsourcesrequest")));
  }
  handleLoadSourcesComplete() {
    this.videoElement.play();
  }
  requestFullscreen(t) {
    this.removeFullscreenListener(), Sa() ? (this.fullscreenElement = t, t.addEventListener("fullscreenchange", this.onFullscreenChange), t.requestFullscreen({ navigationUI: "hide" })) : Ia(this.videoElement) && this.videoElement.webkitEnterFullscreen();
  }
  exitFullscreen() {
    document.exitFullscreen();
  }
  get fullscreen() {
    return document.fullscreenElement !== null;
  }
  get ended() {
    return this.videoElement.ended;
  }
  get paused() {
    return this.videoElement.paused;
  }
  get duration() {
    return this.videoElement.duration;
  }
  get currentTime() {
    return this.videoElement.currentTime;
  }
  set currentTime(t) {
    this.videoElement.currentTime = t;
  }
  get loop() {
    return this.videoElement.loop;
  }
  set loop(t) {
    this.videoElement.loop = t;
  }
  get autoplay() {
    return this._autoplay;
  }
  set autoplay(t) {
    this._autoplay = t;
  }
  get muted() {
    return this.volume === 0 ? !0 : this.videoElement.muted;
  }
  set muted(t) {
    this.videoElement.muted = t, this.videoElement.volume = t ? 0 : this.lastSelectedVolume;
  }
  get playbackRate() {
    return this.getPlaybackRate();
  }
  set playbackRate(t) {
    this.videoElement.playbackRate = t;
  }
  get poster() {
    return this.videoElement.poster;
  }
  /**
   * Sets the poster image for the video element and reports the load duration metric.
   *
   * Note: the video element does't have a way to determine how long the poster takes to load,
   * so we are instead loading to a new image element and measuring the load time.
   */
  set poster(t) {
    const o = new Image();
    o.addEventListener("load", () => {
      this.dispatchEvent(new y.util.FakeEvent("playerposterloadcomplete"));
    }), o.src = t, this.videoElement.poster = o.src;
  }
  get volume() {
    return this.videoElement.volume;
  }
  set volume(t) {
    this.videoElement.muted = !1, this.videoElement.volume = t;
  }
  get adaptiveBitrate() {
    return this.getConfiguration().abr.enabled;
  }
  set adaptiveBitrate(t) {
    this.configure({ abr: { enabled: t } });
  }
  get videoQualities() {
    if (this.getManifestType()) {
      const t = this.filterRelatedAdaptiveTracks();
      return t.length === 0 ? [] : [ie, ...t];
    } else
      return this.filterStaticMp4Tracks();
  }
  get activeVideoId() {
    var t, o;
    if (this.getManifestType()) {
      const r = (t = this.getVariantTracks().find(
        (a) => a.active
      )) == null ? void 0 : t.videoId;
      if (r) return r;
    } else {
      const r = this.getAssetUri();
      return (o = this.options.sources.find((a) => a.src === r)) == null ? void 0 : o.quality;
    }
  }
  get buffered() {
    const t = this.videoElement, o = [];
    for (let r = 0; r < t.buffered.length; r++)
      o.push({
        start: t.buffered.start(r),
        end: t.buffered.end(r)
      });
    return o;
  }
  // Used to dispatch UMP specific errors
  // Severity 2 events will stop playback and display an error or the poster image
  dispatchUmpError(t) {
    this.dispatchEvent(
      new y.util.FakeEvent("error", (/* @__PURE__ */ new Map()).set("detail", t))
    );
  }
  /**
   * Ignore 0, as that's seems to be the standard behavior (of other video players).
   */
  saveLastSelectedVolume(t) {
    t !== 0 && (this.lastSelectedVolume = t);
  }
  async selectVideoQuality(t) {
    if (this.getManifestType()) {
      if (t.videoId === ie.videoId) {
        this.adaptiveBitrate = !0;
        return;
      }
      this.adaptiveBitrate = !1;
      const o = this.getVariantTracks().filter((r) => r.audioId === this.activeAudioTrackId).find((r) => r.videoId === t.videoId);
      if (!o)
        throw new y.util.Error(
          y.util.Error.Severity.RECOVERABLE,
          y.util.Error.Category.MEDIA,
          y.util.Error.Code.VIDEO_ERROR
        );
      this.adaptiveBitrate = !1, this.selectVariantTrack(o, !0);
    } else {
      const o = me(this.options.sources).find(
        (n) => n.quality === t.videoId
      );
      if (!o)
        throw new y.util.Error(
          y.util.Error.Severity.RECOVERABLE,
          y.util.Error.Category.MEDIA,
          y.util.Error.Code.VIDEO_ERROR
        );
      const r = !this.paused, a = this.activeCaptionTrack;
      await this.load(
        o.src,
        this.videoElement.currentTime,
        o.type
      ), r && this.play(), await this.loadCaptions(), this.captionTrack = a;
    }
  }
  get audioTracks() {
    const t = this.getVariantTracks(), o = t.find((i) => i.active);
    if (!o) return [];
    const r = t.filter(
      (i) => i.videoId === o.videoId
    ), a = r.map((i) => {
      const l = i.originalLanguage ?? i.language;
      return l.startsWith(Pe) ? l.substring(Pe.length) : l;
    }), n = Ee(a);
    return r.map((i, l) => ({
      audioId: i.audioId,
      language: i.language.toLowerCase(),
      label: n[a[l]],
      role: i.language.startsWith(Pe) ? "public.accessibility.describes-video" : i.roles[0]
    })).sort((i, l) => i.label.localeCompare(l.label));
  }
  get activeAudioTrackId() {
    var o;
    const t = (o = this.getVariantTracks().find(
      (r) => r.active
    )) == null ? void 0 : o.audioId;
    if (t) return t;
  }
  set audioTrack(t) {
    this.selectAudioLanguage(t.language, t.role);
  }
  get captionTracks() {
    const t = Ee(
      this.getTextTracks().map((r) => r.language)
    ), o = this.getTextTracks().map((r) => ({
      captionId: r.id,
      language: r.language,
      label: t[r.language]
    })).sort((r, a) => r.label.localeCompare(a.label));
    return [ae, ...o];
  }
  get activeCaptionTrack() {
    var r;
    const t = (r = this.getTextTracks().find((a) => a.active)) == null ? void 0 : r.id, o = this.captionTracks.find(
      (a) => a.captionId === t
    );
    return !o || !this.isTextTrackVisible() ? ae : o;
  }
  get activeCaptionTrackId() {
    return this.activeCaptionTrack.captionId;
  }
  set captionTrack(t) {
    if (t.captionId === ae.captionId) {
      this.setTextTrackVisibility(!1);
      return;
    }
    this.selectTextLanguage(t.language), this.setTextTrackVisibility(!0);
  }
  addPlugin(t) {
    this.plugins.push(t);
  }
  addPlugins(...t) {
    t.forEach((o) => this.addPlugin(o));
  }
  addEventListener(t, o, r) {
    (r == null ? void 0 : r.once) === !0 ? Pa(this, t, o) : super.addEventListener(t, o, r);
  }
  forwardVideoElementEvents() {
    He.forEach((t) => {
      const o = () => this.dispatchEvent(new y.util.FakeEvent(t));
      this.videoElementEventListeners[t] = o, this.videoElement.addEventListener(t, o);
    });
  }
  filterStaticMp4Tracks() {
    return me(this.options.sources).filter((t) => t.type === "video/mp4").sort(
      (t, o) => xe.indexOf(t.quality) - xe.indexOf(o.quality)
    ).map((t) => ({
      videoId: t.quality,
      label: t.quality
    }));
  }
  filterRelatedAdaptiveTracks() {
    const t = this.getVariantTracks(), o = t.find((r) => r.active);
    return o ? t.filter((r) => r.audioId === o.audioId).sort((r, a) => a.height === r.height || r.height == null || a.height == null ? a.bandwidth - r.bandwidth : a.height - r.height).reduce((r, a) => {
      const n = new Set(
        r.map((l) => l.height ?? l.bandwidth)
      ), i = a.height ?? a.bandwidth;
      return n.has(i) || r.push(a), r;
    }, []).map((r) => ({
      videoId: r.videoId,
      label: r.height ? r.height.toString() : `${(r.bandwidth / 1e6).toFixed(2)} Mbps`
    })) : [];
  }
  removeFullscreenListener() {
    this.fullscreenElement && this.fullscreenElement.removeEventListener(
      "fullscreenchange",
      this.onFullscreenChange
    );
  }
}
function Pa(e, t, o) {
  const r = (a) => {
    e.removeEventListener(t, r), o(a);
  };
  e.addEventListener(t, r);
}
class _a {
  constructor(t, o) {
    this.prefix = t, this.store = o;
  }
  getItem(t) {
    return this.store.getItem(this.prefixed(t));
  }
  getNumber(t) {
    const o = this.getItem(t);
    if (o === null)
      return null;
    const r = Number(o);
    return isNaN(r) ? null : r;
  }
  setNumber(t, o) {
    this.setItem(t, o.toString());
  }
  setItem(t, o) {
    this.store.setItem(this.prefixed(t), o);
  }
  removeItem(t) {
    this.store.removeItem(this.prefixed(t));
  }
  prefixed(t) {
    return `${this.prefix}:${t}`;
  }
}
const Ft = new _a(
  Ct,
  window.sessionStorage
), je = "agegateupdate", Ze = "UserAge";
function Va(e, t) {
  return (o) => {
    var P, N;
    if (o.options.ageGate === !1)
      return () => {
      };
    let r = typeof o.options.ageGate == "object" && typeof ((P = o.options.ageGate) == null ? void 0 : P.minimumAge) == "number" ? o.options.ageGate.minimumAge : null, a = typeof o.options.ageGate == "object" && typeof ((N = o.options.ageGate) == null ? void 0 : N.userAge) == "number" ? o.options.ageGate.userAge : Ft.getNumber(Ze);
    n();
    function n() {
      if (t.value.ageGate === "verified") {
        x();
        return;
      }
      return r === 0 ? i("verified") : r === null ? i("waiting") : a === null ? i("verification") : a >= r ? i("verified") : i("denied");
    }
    function i(f) {
      t.setValue({
        ...t.value,
        ageGate: f
      });
    }
    function l(f) {
      r = f.detail, n();
    }
    function h(f) {
      a = f.detail, n(), za(a);
    }
    function k(f) {
      a = f.detail, n(), window.removeEventListener(je, k);
    }
    function x() {
      g.removeAllListeners(), m.removeAllListeners();
    }
    function E(f) {
      if (f.key !== `${Ct}:${Ze}` || !f.newValue)
        return;
      const F = Number(f.newValue);
      isNaN(F) || (a = F, n(), window.removeEventListener("storage", E));
    }
    const g = he(window), m = he(e);
    return g.addEventListener(je, k), g.addEventListener("storage", E), m.addEventListener("minimum-age-set", l), m.addEventListener("user-age-set", h), () => {
      x();
    };
  };
}
function za(e) {
  Ft.setNumber(Ze, e), window.dispatchEvent(new p(je, e));
}
const qe = new EventTarget();
let Ge = null;
function Fa(e) {
  e !== Ge && (Ge = e, qe.dispatchEvent(new Event("change")));
}
function Ot() {
  return Ge;
}
function Oa(e, t) {
  return (o) => {
    if (!o.options.autoplay)
      return () => {
      };
    const r = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ), a = {
      threshold: o.options.percentage / 100
    }, n = new IntersectionObserver((m) => {
      if (g(m[0]), !i())
        return;
      m[0].isIntersecting ? o.paused && o.play() : o.paused || o.pause();
    }, a);
    function i() {
      if (typeof t.value.ageGate == "string" && t.value.ageGate !== "verified")
        return !1;
      const m = Ot();
      return typeof m == "boolean" ? m : !r.matches;
    }
    function l() {
      o.autoplay = i();
    }
    function h() {
      l();
    }
    function k() {
      l();
    }
    function x() {
      l(), r.addEventListener("change", h), qe.addEventListener("change", k), e.addEventListener("click", E, { once: !0 }), o.addEventListener("ended", E, { once: !0 }), n.observe(e);
    }
    function E() {
      o.autoplay = !1, n.disconnect(), r.removeEventListener("change", h), qe.removeEventListener("change", k), e.removeEventListener("click", E);
    }
    const g = rt((m) => {
      (!o.autoplay || !m.isIntersecting) && (o.options.hideControls == null && t.setValue({
        ...t.value,
        controlsState: "bigplaybutton"
      }), o.options.hidePosterImage || (o.poster = o.options.poster));
    });
    return x(), E;
  };
}
function Aa(e) {
  return () => {
    async function t() {
      const o = await $a();
      e.setValue({
        ...e.value,
        showVolumeSlider: o
      });
    }
    return t(), () => {
    };
  };
}
function Da(e, t) {
  return (o) => {
    var n;
    function r(i) {
      e.dir = i, t.setValue({
        ...t.value,
        dir: i
      });
    }
    const a = (n = document.documentElement.getAttribute("dir")) == null ? void 0 : n.toLowerCase();
    return r(
      // dir precedence: player options, document dir, default to 'ltr'
      o.options.dir === "ltr" || o.options.dir === "rtl" ? o.options.dir : a === "ltr" || a === "rtl" ? a : "ltr"
    ), () => {
    };
  };
}
function Ra(e) {
  return (t) => (e.setValue({
    ...e.value,
    disableKeyboardEvents: t.options.disableKeyboardEvents
  }), () => {
  });
}
function Na(e, t) {
  return (o) => {
    if (!o.options.showDownloadMenu)
      return t.setValue({
        ...t.value,
        showDownloadMenu: !1
      }), () => {
      };
    const r = he(e);
    r.addEventListener("download-file-clicked", a), r.addEventListener(
      "download-files-updated",
      n
    ), o.options.downloadableFiles.length > 0 && i(o.options.downloadableFiles);
    async function a(l) {
      let h = null;
      try {
        const { url: k } = l.detail, x = await fetch(k);
        if (!x.ok)
          throw new Error(
            `Failed to download file: ${x.url} ${x.statusText}`
          );
        const E = await x.blob();
        h = document.createElement("a"), h.href = URL.createObjectURL(E);
        const g = k.split("/").pop();
        h.download = g, document.body.appendChild(h), h.dispatchEvent(new MouseEvent("click", { bubbles: !1 }));
      } catch (k) {
        console.error(`Failed to download file: ${k}`);
      } finally {
        h != null && h.href && (URL.revokeObjectURL(h.href), document.body.removeChild(h));
      }
    }
    function n(l) {
      i(l.detail);
    }
    function i(l) {
      const h = Ee(
        l.filter((g) => g.mediaType === "video").map((g) => g.locale)
      ), k = l.filter((g) => g.mediaType === "video").map((g) => ({
        ...g,
        locale: h[g.locale]
      })).sort((g, m) => g.locale.localeCompare(m.locale)), x = Ee(
        l.filter((g) => g.mediaType === "transcript").map((g) => g.locale)
      ), E = l.filter((g) => g.mediaType === "transcript").map((g) => ({
        ...g,
        locale: x[g.locale]
      })).sort((g, m) => g.locale.localeCompare(m.locale));
      t.setValue({
        ...t.value,
        downloadableVideoFiles: k,
        downloadableTranscriptFiles: E
      });
    }
    return () => {
      r.removeAllListeners();
    };
  };
}
function Ua(e) {
  return (t) => {
    const o = {
      abrstatuschanged: () => Q(e, t),
      adaptation: () => Q(e, t),
      loaded: () => {
        bt(e, t), Q(e, t), vt(e, t);
      },
      mediaqualitychanged: () => Q(e, t),
      trackschanged: () => bt(e, t),
      textchanged: () => Q(e, t),
      texttrackvisibility: () => Q(e, t),
      timeupdate: () => Ha(e, t),
      variantchanged: () => Q(e, t),
      volumechange: () => vt(e, t),
      ended: () => ja(e),
      playing: () => Za(e),
      pause: () => qa(e),
      seeking: () => Ga(e),
      durationchange: () => Ka(e, t),
      fullscreenchanged: () => Qa(e, t),
      ratechange: () => Ya(e, t),
      error: (r) => Wa(e, t, r.detail),
      progress: () => Xa(e, t)
    };
    return Ba(e, t), Ja(e, t), Object.entries(o).forEach(
      ([r, a]) => t.addEventListener(r, a)
    ), () => {
    };
  };
}
function Ba(e, t) {
  const o = t.options.playbackRates.map((r) => ({
    label: r === 1 ? "Normal" : `${r}x`,
    value: r
  }));
  e.setValue({
    ...e.value,
    playbackRates: o
  });
}
function Ha(e, t) {
  e.setValue({
    ...e.value,
    currentTime: t.currentTime
  });
}
function vt(e, t) {
  e.setValue({
    ...e.value,
    volume: t.volume,
    muted: t.muted
  });
}
function Q(e, t) {
  const o = t.activeVideoId;
  e.setValue({
    ...e.value,
    activeVideoQualityId: o,
    selectedVideoQualityId: t.adaptiveBitrate ? ie.videoId : o,
    selectedAudioTrackId: t.activeAudioTrackId,
    selectedCaptionTrackId: t.activeCaptionTrackId
  });
}
function bt(e, t) {
  e.setValue({
    ...e.value,
    videoQualities: t.videoQualities,
    audioTracks: t.audioTracks,
    captionTracks: t.captionTracks
  });
}
function ja(e) {
  e.setValue({
    ...e.value,
    ended: !0
  });
}
function Za(e) {
  e.setValue({
    ...e.value,
    paused: !1
  });
}
function qa(e) {
  e.setValue({
    ...e.value,
    paused: !0
  });
}
function Ga(e) {
  e.setValue({
    ...e.value,
    ended: !1
  });
}
function Ka(e, t) {
  e.setValue({
    ...e.value,
    duration: t.duration
  });
}
function Qa(e, t) {
  e.setValue({
    ...e.value,
    fullscreen: t.fullscreen
  });
}
function Ya(e, t) {
  e.setValue({
    ...e.value,
    playbackRate: t.playbackRate
  });
}
function Wa(e, t, o) {
  o.severity === y.util.Error.Severity.CRITICAL && (t.options.showImageOnError ? (t.unload(), e.setValue({
    ...e.value,
    controlsState: "none"
  })) : e.setValue({
    ...e.value,
    error: uo
  }));
}
function Xa(e, t) {
  e.setValue({
    ...e.value,
    buffered: t.buffered
  });
}
function Ja(e, t) {
  function o(n) {
    e.setValue({
      ...e.value,
      loading: n
    });
  }
  function r() {
    o(!0);
    const n = t.currentTime, i = () => {
      n !== t.currentTime && (o(!1), t.removeEventListener("timeupdate", i));
    };
    t.addEventListener("timeupdate", i);
  }
  function a(n) {
    n.detail.severity === y.util.Error.Severity.CRITICAL && o(!1);
  }
  t.addEventListener("playerloadmediastart", r), t.addEventListener("waiting", r), t.addEventListener("error", a), t.addEventListener("ended", () => o(!1)), t.addEventListener("playing", () => o(!1)), t.addEventListener("canplay", () => o(!1)), t.addEventListener("canplaythrough", () => o(!1));
}
function en(e, t) {
  return (o) => {
    const r = [], a = {
      contentVisibilityAuto: !0,
      opacityProperty: !0,
      visibilityProperty: !0
    }, n = () => {
      const m = e.getBoundingClientRect();
      return !(m.width === 0 || m.height === 0);
    }, i = (m) => ({
      size: () => n(),
      visibility: () => e.checkVisibility(a),
      all: () => n() || e.checkVisibility(a)
    })[m](), l = (m) => {
      const P = i(m);
      t.setValue({
        ...t.value,
        visible: P
      }), P || o.pause();
    }, h = (m) => {
      m.forEach((P) => {
        P.type === "attributes" && P.attributeName === "style" && l("visibility");
      });
    }, k = {
      attributes: !0
    };
    ((m) => {
      const P = new MutationObserver(h);
      for (; m; ) {
        P.observe(m, k), r.push(P);
        const N = m == null ? void 0 : m.getRootNode();
        m = (m == null ? void 0 : m.assignedSlot) || (m == null ? void 0 : m.parentElement) || (N instanceof ShadowRoot ? N.host : null);
      }
    })(e);
    const E = (m) => {
      m.forEach(() => {
        l("size");
      });
    }, g = new ResizeObserver(E);
    return g.observe(e), l("all"), () => {
      r.forEach((m) => m.disconnect()), g.disconnect();
    };
  };
}
function tn(e) {
  return (t) => (t.options.playFullScreen && t.addEventListener(
    "play",
    () => {
      t.requestFullscreen(e);
    },
    { once: !0 }
  ), () => {
  });
}
function on(e) {
  return (t) => {
    t.options.qualityBehavior === "forceHighestQuality" && t.configure({
      abr: {
        enable: !1,
        defaultBandwidthEstimate: 1e10,
        // 10 Gbps
        useNetworkInformation: !1
      }
    }), e.setValue({
      ...e.value,
      showQualityMenu: t.options.showQualityMenu
    });
    async function o() {
      if (t.options.qualityBehavior === "forceHighestQuality" && !!t.getManifest()) {
        const a = t.videoQualities[1];
        a && t.selectVideoQuality(a);
      }
    }
    return t.addEventListener("loadsourcescomplete", o, {
      once: !0
    }), () => {
    };
  };
}
const rn = `<svg
  width="38"
  height="37"
  viewBox="0 0 38 37"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M8.01585 5.78125C5.14224 5.78125 2.81272 8.11077 2.81272 10.9844V12.695C2.81242 12.7102 2.81243 12.7253 2.81272 12.7405V26.0156C2.81272 28.8892 5.14224 31.2188 8.01585 31.2188H29.9846C32.8582 31.2188 35.1877 28.8892 35.1877 26.0156V12.7405C35.188 12.7253 35.188 12.7102 35.1877 12.695V10.9844C35.1877 8.11077 32.8582 5.78125 29.9846 5.78125H8.01585ZM32.8752 12.0281L19.0002 19.4993L5.12522 12.0281V10.9844C5.12522 9.38793 6.4194 8.09375 8.01585 8.09375H29.9846C31.581 8.09375 32.8752 9.38793 32.8752 10.9844V12.0281ZM5.12522 14.6546L18.452 21.8305C18.7943 22.0148 19.2062 22.0148 19.5484 21.8305L32.8752 14.6546V26.0156C32.8752 27.6121 31.581 28.9062 29.9846 28.9062H8.01585C6.4194 28.9062 5.12522 27.6121 5.12522 26.0156V14.6546Z"
  />
</svg>`, an = `<svg
  width="16"
  height="30"
  viewBox="0 0 16 30"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_511_2982)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.6346 4.86093C9.21328 4.47388 10.4141 7.03694 10.35 11.136C11.691 11.136 14.6137 11.1421 15.4183 11.1421C15.0983 13.2175 14.6746 15.9452 14.6045 16.3993C13.0777 16.4054 11.6819 16.4114 10.3592 16.4145C10.3653 19.008 10.3683 27.8614 10.344 29.3425C9.42357 29.3425 5.54394 29.3974 4.65708 29.3425C4.65708 27.258 4.65098 18.5631 4.65098 16.3993C3.51422 16.3993 1.47535 16.4114 0.012491 16.3932C0.012491 15.3265 -0.00579475 12.9829 0.012491 11.133C0.844494 11.1116 3.70012 11.133 4.66317 11.1025C4.66317 9.9139 4.65708 8.7619 4.65403 7.25332C4.63879 1.92911 8.11919 -1.12157 15.6407 0.387011C15.6407 1.64568 15.6407 3.93445 15.6407 4.86093H15.6346Z"
    />
  </g>
  <defs>
    <clipPath id="clip0_511_2982">
      <rect width="15.6343" height="29.37" fill="white" />
    </clipPath>
  </defs>
</svg>`, nn = `<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_511_2987)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.3045 7.94905L8.62619 7.98985L8.59559 24C10.1698 24 11.7439 24 13.3181 23.9831C13.3181 21.9567 13.3113 18.9444 13.3181 16.5372C13.3215 14.4599 13.4303 12.0731 16.1502 11.9712C18.9687 11.8658 19.0163 14.3953 19.0197 16.51C19.0231 18.8458 18.9007 21.5691 19.0197 23.8607L23.8918 23.8811C23.9292 23.5377 23.902 17.0438 23.902 16.5134C23.902 15.3337 23.9734 13.9975 23.9156 12.8347C23.7592 9.66941 21.3147 7.47306 18.1902 7.46966C16.854 7.46966 15.3546 7.99325 14.4502 8.81603C13.9913 9.23422 13.7295 9.62521 13.3283 10.0332C13.3283 9.36002 13.3147 8.57804 13.3011 7.94565L13.3045 7.94905ZM0.571791 23.8437H5.29087C5.28067 22.9563 5.28747 9.67961 5.29087 7.94905H0.571791V23.8437ZM2.61174 0.0272487C0.986581 0.255043 -0.18639 1.60141 0.024405 3.27417C0.2114 4.76673 1.53737 6.0723 3.26792 5.8615C4.74009 5.68131 6.04225 4.32474 5.82466 2.60778C5.64106 1.15602 4.3015 -0.210745 2.61174 0.0272487Z"
    />
  </g>
  <defs>
    <clipPath id="clip0_511_2987">
      <rect
        width="23.9422"
        height="24"
        fill="white"
        transform="translate(0.000610352)"
      />
    </clipPath>
  </defs>
</svg>`, sn = `<svg
  width="28"
  height="24"
  viewBox="0 0 28 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_511_2985)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.2899 21.4804C19.8539 20.897 6.12454 2.76639 5.93862 2.51957C6.09569 2.51957 7.90683 2.51957 8.08955 2.51957C8.30112 2.80166 22.0401 20.7111 22.5947 21.4804H20.2899ZM17.001 10.0815C18.5685 8.26713 24.8995 0.891145 25.5951 0.0544945L21.7324 0.02885C20.6842 1.23734 15.5585 6.98811 15.0937 7.4978C14.4878 6.73167 9.34933 0.368639 9.07366 0H0.867432C1.87718 1.30466 10.4777 12.5081 10.8559 12.9985C8.76592 15.3963 2.15927 22.987 1.38994 23.8782L5.65012 23.9327L12.7889 15.781C13.8019 17.0792 18.5813 23.3653 19.216 24.0032C19.8924 24.0032 26.9703 23.9519 27.3902 23.9423C26.4991 22.7755 17.6068 10.8732 17.0042 10.0815H17.001Z"
    />
  </g>
  <defs>
    <clipPath id="clip0_511_2985">
      <rect
        width="26.5196"
        height="24"
        fill="white"
        transform="translate(0.867188)"
      />
    </clipPath>
  </defs>
</svg>`;
function ln(e, t) {
  return (o) => {
    const r = cn(o).map(
      (l) => un(l)
    );
    t.setValue({
      ...t.value,
      shareOptions: r
    });
    function a() {
      t.setValue({
        ...t.value,
        shareDialogOpened: !0
      });
    }
    function n() {
      var l, h, k, x, E, g;
      t.setValue({
        ...t.value,
        shareDialogOpened: !1
      }), (g = (E = (x = (k = (h = (l = e.renderRoot) == null ? void 0 : l.querySelector("ump-controls")) == null ? void 0 : h.renderRoot.querySelector("ump-control-bar")) == null ? void 0 : k.renderRoot.querySelector("ump-more-menu")) == null ? void 0 : x.renderRoot.querySelector(
        '[data-id="more-menu-button"]'
      )) == null ? void 0 : E.focus) == null || g.call(E);
    }
    const i = he(e);
    return i.addEventListener("share-button-clicked", a), i.addEventListener("share-dialog-closed", n), () => {
      i.removeAllListeners();
    };
  };
}
function cn(e) {
  return e.options.share ? e.options.shareOptions.length === 0 ? xt : e.options.shareOptions : [];
}
function un(e) {
  const t = new URL(window.location.href);
  t.searchParams.delete("jsapi");
  const o = t.toString();
  switch (e) {
    case "facebook":
      return {
        id: "facebook",
        url: `https://www.facebook.com/share.php?u=${encodeURIComponent(o)}`,
        icon: an
      };
    case "linkedin":
      return {
        id: "linkedin",
        url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(o)}&title=&summary=&source=`,
        icon: nn
      };
    case "twitter":
      return {
        id: "twitter",
        url: `https://x.com/share?url=${encodeURIComponent(o)}&text=`,
        icon: sn
      };
    case "mail":
      return {
        id: "mail",
        url: `mailto:?subject=Check out this great video&body=${encodeURIComponent(o)}`,
        icon: rn
      };
    default:
      return {
        id: "copy",
        url: o,
        icon: ""
        // no icon needed since copy is in a separate part of UI
      };
  }
}
function dn() {
  return (e) => {
    if (e.options.sources.length === 0)
      return () => {
      };
    e.addEventListener("loadsourcesrequest", t);
    async function t() {
      e.dispatchEvent(new y.util.FakeEvent("playerloadmediastart"));
      const o = me(e.options.sources);
      try {
        await e.load(
          o[0].src,
          e.options.startTime,
          o[0].type
        );
      } catch {
        e.dispatchUmpError({
          severity: y.util.Error.Severity.CRITICAL,
          umpErrorType: "Error loading video source",
          umpErrorDescription: `Error loading video source: ${o[0].src}`
        });
        return;
      }
      await e.loadCaptions(), e.dispatchEvent(new y.util.FakeEvent("playerloadmediaend")), e.dispatchEvent(new y.util.FakeEvent("loadsourcescomplete"));
    }
    return () => {
    };
  };
}
const pn = "https://afe-vidapi-pmeprod-gae4fddud0fpdxfb.b02.azurefd.net";
class hn {
  constructor(t) {
    this.dispose = () => {
      this.abortController.abort();
    }, this.options = t, this.abortController = new AbortController();
  }
  /**
   * Fetches metadata using Adobe API.
   * @async
   * @returns {Promise<ParsedAdobeCmsMetadata>} A promise that resolves to the parsed metadata or undefined if parsing fails.
   */
  async fetchVideoApiMetadata() {
    const t = this.options.adobeCms, o = this.abortController.signal, r = this.constructAdobeCmsEndpoint(
      t == null ? void 0 : t.operatingGroup,
      t == null ? void 0 : t.videoId,
      t == null ? void 0 : t.posterWidth,
      t == null ? void 0 : t.posterHeight
    ), a = await fetch(r.toString(), { signal: o });
    if (!a.ok)
      throw new Error(
        `Error fetching AdobeCMS Metadata from ${r}`
      );
    const n = await a.json();
    return {
      poster: n.posterUrl,
      sources: this.parseVideoFiles(n.sources),
      ccFiles: ot(n.closedCaptions),
      downloadableFiles: n.downloadableFiles,
      title: n.videoTitle,
      ageGate: {
        minimumAge: n.minimumAge
      }
    };
  }
  /**
   * Constructs the AdobeCms video information endpoint URL.
   * @param operatingGroup - AdobeCms Operating Group.
   * @param videoId - AdobeCms Video ID.
   * @param posterWidth - The width of the poster image.
   * @param posterHeight - The height of the poster image.
   * @returns The constructed URL for the video information endpoint.
   */
  constructAdobeCmsEndpoint(t, o, r, a) {
    const n = new URL(
      `${pn}/api/videos/${t}/${o}/videoInfo`
    );
    return r && n.searchParams.set("posterWidth", r), a && n.searchParams.set("posterHeight", a), n;
  }
  /**
   * Converts and sanitizes the AdobeCms sources
   * @param sources - The sources to be modified.
   * @returns {VideoSource[]} The list of modified video sources
   */
  parseVideoFiles(t) {
    return me(
      t.map((o) => ({
        src: o.url,
        type: o.type
      }))
    );
  }
}
const mn = "h.264_", gn = "transcript", vn = "TTML", bn = "DASH", fn = "HLS";
class yn {
  constructor(t) {
    this.dispose = () => {
      this.abortController.abort();
    }, this.player = t, this.abortController = new AbortController();
  }
  /**
   * Fetches metadata using PowerCms API.
   * @async
   * @returns {Promise<ParsedPowerCmsMetadata>} A promise that resolves to the parsed metadata or undefined if parsing fails.
   */
  async fetchVideoApiMetadata() {
    var n;
    const t = `https://prod-video-cms-rt-microsoft-com.akamaized.net/vhs/api/videos/${(n = this.player.options.plugins.powerCms) == null ? void 0 : n.videoId}`, o = this.abortController.signal, r = await fetch(`${t}`, { signal: o });
    if (!r.ok)
      throw new Error(
        `Error fetching PowerCMS Metadata from ${t}`
      );
    const a = await r.json();
    return {
      poster: this.forceHttps(a.snippet.thumbnails.medium.url),
      sources: this.parseVideoFiles(a),
      ccFiles: this.parseCcFiles(a),
      downloadableFiles: this.parseDownloadableFiles(a),
      title: a.snippet.title,
      ageGate: {
        minimumAge: a.snippet.minimumAge
      }
    };
  }
  /**
   * Converts and sanitizes the PowerCms sources
   * @param sources - The sources to be modified.
   * @returns {VideoSource[]} The list of modified video sources
   */
  parseVideoFiles(t) {
    return me([
      {
        src: this.forceHttps(t.streams.mPEG_DASH.url),
        type: bn
      },
      {
        src: this.forceHttps(t.streams.apple_HTTP_Live_Streaming.url),
        type: fn
      }
    ]);
  }
  /**
   * Parses the captions from the metadata.
   * @param metadata - The metadata containing the captions.
   * @returns Parsed captions.
   */
  parseCcFiles(t) {
    return ot(
      Object.entries(t.captions).map(([o, r]) => ({
        ccType: vn,
        url: this.forceHttps(r.url),
        locale: o
      }))
    );
  }
  /**
   * Parses the downloadable files from the metadata.
   * @param metadata - The metadata containing the downloadable files.
   * @returns Parsed downloadable files.
   */
  parseDownloadableFiles(t) {
    const o = Object.entries(t.streams).filter(([a]) => a.startsWith(mn)).map(([, a]) => a).reduce(
      (a, n) => a.widthPixels > n.widthPixels ? a : n
    );
    return [
      ...Object.entries(
        t.transcripts
      ).map(([a, n]) => ({
        mediaType: gn,
        url: this.forceHttps(n.url),
        locale: a
      })),
      {
        mediaType: "video",
        url: this.forceHttps(o.url),
        locale: t.snippet.culture
      }
    ];
  }
  /**
   * Forces HTTPS on a URL.
   * @param url - The URL to force HTTPS on.
   * @returns The URL with HTTPS.
   */
  forceHttps(t) {
    return t.replace("http://", "https://");
  }
}
function wn(e) {
  return (t) => {
    var N;
    const o = t.options.adobeCms, r = (N = t.options.plugins) == null ? void 0 : N.powerCms;
    if ((!(o != null && o.operatingGroup) || !(o != null && o.videoId)) && !(r != null && r.videoId))
      return () => {
      };
    let a = () => {
    }, n = o != null && o.operatingGroup && (o != null && o.videoId) ? 1 : 0;
    const i = new AbortController();
    let l = {};
    async function h() {
      var X, fe;
      if (!((fe = (X = t.options.plugins) == null ? void 0 : X.powerCms) != null && fe.videoId))
        return;
      const f = `https://www.microsoft.com/videoplayer/umpOptionsMappings/${t.options.plugins.powerCms.videoId}.json`, F = i.signal;
      try {
        const J = await fetch(f, { signal: F });
        if (!J.ok)
          return;
        l = await J.json(), n = 2;
      } catch (J) {
        console.error("Error fetching video options mapping", J);
      }
    }
    const k = h();
    t.addEventListener("loadsourcesrequest", P);
    const x = [], E = [];
    async function g() {
      await k;
      let f;
      switch (n) {
        case 1:
        case 2: {
          const F = new hn(
            n === 2 ? l : t.options
          );
          a = F.dispose, f = await F.fetchVideoApiMetadata();
          break;
        }
        case 0: {
          const F = new yn(t);
          a = F.dispose, f = await F.fetchVideoApiMetadata();
          break;
        }
      }
      if (!f || f.sources.length === 0)
        throw new Error("No metadata or no sources found in metadata");
      f.title && (e.ariaLabel = f.title), x.push(...f.sources), t.options.hidePosterImage || (t.poster = f.poster), E.push(...f.ccFiles), e.dispatchEvent(
        new p("minimum-age-set", f.ageGate.minimumAge ?? 0)
      ), f.downloadableFiles.length > 0 && e.dispatchEvent(
        new p("download-files-updated", f.downloadableFiles)
      );
    }
    const m = (async () => {
      try {
        await g();
      } catch (f) {
        f instanceof Error && t.dispatchUmpError({
          severity: y.util.Error.Severity.CRITICAL,
          umpErrorType: "Error fetching video metadata",
          umpErrorDescription: JSON.stringify(f.message)
        });
      }
    })();
    async function P() {
      t.dispatchEvent(new y.util.FakeEvent("playerloadmediastart")), await m, await t.load(
        x[0].src,
        t.options.startTime,
        x[0].type
      ), await t.loadCaptions(E), t.dispatchEvent(new y.util.FakeEvent("playerloadmediaend")), t.dispatchEvent(new y.util.FakeEvent("loadsourcescomplete"));
    }
    return () => {
      i.abort(), a();
    };
  };
}
function kn() {
  try {
    return crypto.randomUUID();
  } catch {
    return `10000000-1000-4000-8000-${1e11}`.replace(
      /[018]/g,
      (t) => (t ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> t / 4).toString(16)
    );
  }
}
var xn = Object.defineProperty, En = Object.getOwnPropertyDescriptor, be = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? En(t, o) : t, n = e.length - 1, i; n >= 0; n--)
    (i = e[n]) && (a = (r ? i(t, o, a) : i(a)) || a);
  return r && a && xn(t, o, a), a;
};
y.polyfill.installAll();
const At = "options";
function Dt(e, t, o) {
  const r = e instanceof R ? e : R.getById(e);
  return o && r.addEventListener("ready", o, { once: !0 }), r.setAttribute("options", JSON.stringify(t)), r;
}
Object.defineProperty(Dt, "allowAutoplay", {
  get: Ot,
  set: Fa
});
let R = class extends C {
  constructor() {
    super(...arguments), this.umpId = `ump-${kn()}`, this.ariaLabel = null, this.playerStateContext = new Gt(this, {
      context: L,
      initialValue: it
    }), this.onVideoEvent = (e) => {
      this.dispatchEvent(new p(e.type, e.target));
    };
  }
  render() {
    return d`
      <ump-caption-display></ump-caption-display>
      <ump-controls class="fill-parent"></ump-controls>
      <ump-loading-spinner></ump-loading-spinner>
      <ump-modals class="fill-parent"></ump-modals>
      <ump-aria-announcer></ump-aria-announcer>
    `;
  }
  setMinimumAge(e) {
    this.dispatchEvent(new p("minimum-age-set", e));
  }
  setAge(e) {
    this.dispatchEvent(new p("user-age-set", e));
  }
  dispose() {
    this.destroyPlayer();
  }
  get currentState() {
    var e;
    if (this.player)
      return {
        duration: this.player.duration,
        currentTime: this.player.currentTime,
        percentageComplete: this.player.currentTime / this.player.duration,
        autoPlay: this.player.autoplay,
        muted: this.player.muted,
        loop: this.player.loop,
        title: this.player.options.title,
        powerCmsVideoId: (e = this.player.options.plugins.powerCms) == null ? void 0 : e.videoId
      };
  }
  play() {
    var e;
    (e = this.player) == null || e.play();
  }
  pause() {
    var e;
    (e = this.player) == null || e.pause();
  }
  /**
   * Creates/recreates the player for the following:
   * - If the options change
   * - If the player doesn't exist
   */
  async updated(e) {
    e.has(At) && (await this.destroyPlayer(), this.options && await this.initPlayer(this.options));
  }
  async disconnectedCallback() {
    super.disconnectedCallback(), await this.destroyPlayer();
  }
  connectedCallback() {
    super.connectedCallback(), this.requestUpdate();
  }
  async initPlayer(e) {
    var o, r;
    this.playerStateContext.setValue(it);
    const t = this.addVideo();
    this.player = new La(e, t, this.captionDisplay), this.player.addPlugins(
      ta(this, this.playerStateContext),
      dn(),
      wn(this),
      Ua(this.playerStateContext),
      Na(this, this.playerStateContext),
      ln(this, this.playerStateContext),
      Vr(this, this.playerStateContext),
      Va(this, this.playerStateContext),
      en(this, this.playerStateContext),
      tn(this),
      Oa(this, this.playerStateContext),
      Aa(this.playerStateContext),
      on(this.playerStateContext),
      Ra(this.playerStateContext),
      vo(this.playerStateContext),
      Da(this, this.playerStateContext)
    ), this.updateStyles(this.player), this.ariaLabel = ((o = this.options) == null ? void 0 : o.title) || null, qo(Go((r = this.options) == null ? void 0 : r.language)), await this.player.initialize(), this.dispatchEvent(new p("ready", this.player));
  }
  addVideo() {
    var t;
    const e = document.createElement("video");
    return e.classList.add("fill-parent"), He.forEach((o) => {
      e.addEventListener(o, this.onVideoEvent);
    }), (t = this.shadowRoot) == null || t.prepend(e), e;
  }
  removeVideo() {
    var t;
    const e = (t = this.player) == null ? void 0 : t.getMediaElement();
    e && (He.forEach((o) => {
      e.removeEventListener(o, this.onVideoEvent);
    }), e.remove());
  }
  async destroyPlayer() {
    var e;
    this.removeVideo(), await ((e = this.player) == null ? void 0 : e.destroy()), this.player = void 0;
  }
  updateStyles(e) {
    this.style.setProperty(
      "--ump-aspect-ratio",
      e.options.aspectRatio.replace(":", " /")
    ), e.options.layout === "fill" ? this.style.setProperty("--ump-height", "100%") : this.style.setProperty("--ump-height", "unset");
  }
  static getById(e) {
    const t = document.getElementById(e);
    if (!(t instanceof R))
      throw new Error(
        `Not a valid element. To use Universal Media Player, you must pass in an element named "${po}" but you passed in id ${e} which resolves to element ${t == null ? void 0 : t.tagName}.`
      );
    return t;
  }
};
R.shadowRootOptions = {
  ...C.shadowRootOptions,
  delegatesFocus: !0
};
R.styles = [
  _t,
  w`
:host{--ump-aspect-ratio:unset;--ump-height:unset;container-type:size;container-name:universalmediaplayer;display:inline-block;position:relative;width:100%;height:var(--ump-height);aspect-ratio:var(--ump-aspect-ratio);background-color:var(--color-black);font-family:var(--font-family-default);font-size:var(--font-size-base-300);word-break:normal}video{object-fit:contain}.fill-parent{position:absolute;inset:0;width:100%;height:100%}ump-controls{z-index:10}ump-modals{z-index:20}ump-loading-spinner{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:15}
    `
];
be([
  I({ type: Object, attribute: At, reflect: !0 })
], R.prototype, "options", 2);
be([
  I({ reflect: !0 })
], R.prototype, "umpId", 2);
be([
  I({ attribute: "aria-label", reflect: !0 })
], R.prototype, "ariaLabel", 2);
be([
  $("ump-caption-display")
], R.prototype, "captionDisplay", 2);
R = be([
  S("universal-media-player")
], R);
window.ump = Dt;
window.ISOBoxer = Kt;
export {
  At as OPTIONS_ATTRIBUTE_NAME,
  R as UniversalMediaPlayer,
  Rn as registerTranslation,
  Nn as setTranslationLoader,
  Dt as ump
};
